/* eslint-disable max-len */
// const SOFTWARE_NAME = '365 Monitoreo';

const formItems = {
  EMAIL: 'Email',
  PASSWORD: 'Password',
  FIRSTNAME: 'Firstname',
  LASTNAME: 'Lastname',
  WORKSPACE_NAME: 'Workspace name',
  WORKSPACE_ID: 'Workspace ID',
  COMPANY_NAME: 'Company Name',
  COUNTRY: 'Country',
  WORKSPACE: 'workspace',
  ID: 'Identifier',
};

const formItemsValidation = {
  // ENTER
  ENTER_EMAIL: `Enter  ${formItems.EMAIL}`,
  ENTER_PASSWORD: `Enter  ${formItems.PASSWORD}`,
  ENTER_NEW_PASSWORD: `Enter new ${formItems.PASSWORD}`,
  ENTER_FIRSTNAME: `Enter  ${formItems.FIRSTNAME}`,
  ENTER_LASTNAME: `Enter  ${formItems.LASTNAME}`,

  // ---------
  // VALIDATE
  GENERIC_VALIDATE: 'The field is not valid', // cambie el nombre de GENERIC_VALIDATION
  VALIDATE_COUNTRY: `The ${formItems.COUNTRY.toLocaleLowerCase()} is not valid`,
  VALIDATE_WORKSPACE_NAME: `Enter a ${formItems.WORKSPACE_NAME.toLocaleLowerCase()}`,
  VALIDATE_PASSWORD_LENGHT_ERROR: `${formItems.PASSWORD.toLocaleLowerCase()} must be greater than 8 characters`,
  VALIDATE_PASSWORD_MAX_LENGHT_ERROR: `${formItems.PASSWORD.toLocaleLowerCase()} must be less than 16 characters`,
  PASSWORD_RULES_LETTER: `${formItems.PASSWORD.toLocaleLowerCase()} must contain at least one letter`,
  PASSWORD_RULES_NUMBER: `${formItems.PASSWORD.toLocaleLowerCase()} must contain at least one number`,
  VALIDATE_FIRSTNAME_MIN_LENGHT_ERROR: `${formItems.FIRSTNAME.toLocaleLowerCase()} must be greater than 2 characters`,
  VALIDATE_FIRSTNAME_MAX_LENGHT_ERROR: `${formItems.FIRSTNAME.toLocaleLowerCase()} must be less than 30 characters`,
  VALIDATE_LASTNAME_MIN_LENGHT_ERROR: `${formItems.LASTNAME.toLocaleLowerCase()} must be greater than 2 characters`,
  VALIDATE_LASTNAME_MAX_LENGHT_ERROR: `${formItems.LASTNAME.toLocaleLowerCase()} must be less than 30 characters`,
  VALIDATE_EMAIL_ERROR: `must be a valid ${formItems.EMAIL.toLocaleLowerCase()}`,

  // ---------
  // REQUIRED
  GENERIC_REQUIRED: 'The field is required', // cambie el nombre de GENERIC_VALIDATION
  COMPANY_NAME_REQUIRED: `The ${formItems.COMPANY_NAME.toLocaleLowerCase()} is required`, // cambie el nombre de VALIDATE_COMPANY_NAME
  FIRSTNAME_REQUIRED: `${formItems.FIRSTNAME} is required`,
  LASTNAME_REQUIRED: `${formItems.LASTNAME} is required`,
  EMAIL_REQUIRED: `${formItems.EMAIL} is required`,
  PASSWORD_REQUIRED: `${formItems.PASSWORD} is required`,
  ID_REQUIRED: `${formItems.ID} is required`,

  // ---------
  // VALIDATION UNCATEGORIZED
  CONFIRM_PASSWORD: `Confirm ${formItems.PASSWORD}`,
  PASSWORD_MUST_MATCH: 'passwords must match',
};

// const actions = {
//   SUBMIT: 'Submit',
//   CANCEL: 'Cancel',
//   ACCEPT: 'Accept',
//   PREVIOUS: 'Previous',
//   NEXT: 'Next',
//   JOIN: 'Join',
//   CONFIRM: 'Confirm',
//   SIGNIN: 'SignIn',
//   SAVING: 'Saving',
//   SAVE_CHANGES: 'Save changes',
// };

const errors = {
  GENERAL_ERROR: 'An error has occurred',
  NETWORK_ERROR:
    'Un error ha ocurrido procesando su solicitud, intente de nuevo mas tarde.',
  INVALID_LINK: 'Invalid link',
  SESSION_EXPIRED_ERROR:
    'The session has expired, please re-enter the platform.',
  EMAIL_ALREADY_EXIST_ERROR:
    "Your email already exist, if you don't remember your password try to change it with the forgot password process",
};

// const registerWizard = {
//   FIRST_STEP_TITLE: "Let's start",
//   FIRST_STEP_SUBTITLE: 'We need to know your email',
//   SECOND_STEP_TITLE: 'Account',
//   SECOND_STEP_SUBTITLE: 'We need some details to create the account',
//   SECOND_STEP_INNER_TITLE: 'Account information',
//   THIRD_STEP_TITLE: 'Complete',
//   THIRD_STEP_SUBTITLE: "Add your password and we're done",
//   THIRD_STEP_INNER_TITLE: 'Last step',
//   EMAIL_RECOMMENDATION: 'Use your work email, this way we can connect with your team.',
// };

// const workspaceWizard = {
//   REPRESENT_QUESTION: 'Which of these represent you better?',
//   NO_WORKSPACE_TITLE: 'You are not in a workspace yet.',
//   NO_WORKSPACE_SUBTITLE: 'A workspace is where everything happens, it is usually a company.',
//   NO_WORKSPACE_FOOTER: 'If you are not sure what to do, please read the',
//   NO_WORKSPACE_CREATE_BUTTON: 'Create a workspace',
//   NO_WORKSPACE_SECONDARY_TEXT: 'an existing',
//   CREATE_WORKSPACE_TITLE: 'Workspace creation',
//   CREATE_WORKSPACE_SUBTITLE: 'A workspace is where all the devices live and where you configure the platform,
// usually it represents a company. If you are not sure what to do, please read the',
//   CREATE_WORKSPACE_BODY: 'If your team already have a workspace',
//   CREATE_WORKSPACE_QUESTION: 'Do you represent a company?',
//   SUBSCRIPTION_WORKSPACE_TITLE: 'Subscription',
//   SUBSCRIPTION_WORKSPACE_SUBTITLE: 'Let's configure the modules you want to activate first, you can modify this settings later.',
//   SUBSCRIPTION_WORKSPACE_BODY: 'If you want to read about the modules',
//   JOIN_WORKSPACE_TITLE: 'Join a existing workspace',
//   JOIN_WORKSPACE_SUBTITLE: 'To join a workspace you can fill the workspace id here,
// if you don't know it, then ask to the workspace admin for an invitation.',
// };

// const deviceList = {
//   CUSTOMER_TABLE_TITLE: 'Customer list',
//   CUSTOMER_TABLE_SUBTITLE: 'List of clients within the workspace',
//   DEVICE_TABLE_SUBTITLE: 'Devices belonging to the selected customer',
//   DELETE_CUSTOMER_QUESTION: 'Are you sure you want to delete the client',
//   DELETED_CUSTOMER: 'The client has been deleted',
//   DELETE_DEVICE_QUESTION: 'Are you sure you want to delete the device',
//   DELETED_DEVICE: 'Device removed',
//   DEVICES: 'devices',
// };

// const auth = {
//   // signup
//   SIGNUP: 'Signup',
//   SIGNUP_ACTION: 'Create Account',
//   SIGNUP_SUBTITLE: 'Enter your information to create the account',
//   REGISTRATION_SUCCESSFUL: 'Successful registration! An email was sent to validate the account.',
//   VALIDATED_ACCOUNT_SUCCESS: 'Your account has been successfully validated',

//   // login
//   LOGIN: 'Login',
//   LOGIN_SUBTITLE: 'Enter your mail & password',
//   GO_BACK_TO_LOGIN: 'Login here',
//   BACK_TO_LOGIN_QUESTION: 'Do you already have an account?',

//   // forgotPassword
//   FORGOT_PASSWORD_QUESTION: `Forgot your ${formItems.PASSWORD}?`,
//   FORGOT_PASSWORD_SUBTITLE: `Enter your email to reset your ${formItems.PASSWORD}`,
//   FORGOT_PASSWORD_SUCCESS: 'A link has been sent to the email so that you can recover your password',

//   // resetPassword
//   RESET_PASSWORD: `Reset ${formItems.PASSWORD}`,
//   RESET_PASSWORD_SUBTITLE: `Enter your new ${formItems.PASSWORD} and confirm it`,
//   RESET_PASSWORD_SUCCESS: `${formItems.PASSWORD} successfully updated`,

//   // changePassword
//   CHANGE_PASSWORD: `Change ${formItems.PASSWORD}`,
//   CHANGE_PASSWORD_SUBTITLE: `Enter the fields to change your ${formItems.PASSWORD}`,
//   CHANGE_PASSWORD_SUCCESS: `${formItems.PASSWORD} successfully updated`,
// };

// // always last
// const miscellaneous = {
//   AUTH_PAGE_TITLE: `Welcome to ${SOFTWARE_NAME}`,
//   AUTH_PAGE_SUBTITLE: 'The most modern monitoring software on the market',
//   COPYRIGHT: `${new Date().getFullYear()} ${SOFTWARE_NAME}`,
//   I_ACCEPT_THE: 'I accept the',
//   TERMS_AND_CONDITIONS: 'Terms and conditions',
//   HAVING_ISSUES: 'Having issues?',
//   GET_HELP: 'Get Help',
//   FAQ: 'faq',
//   CONTACT_US: 'contact us',
//   CLICK_HERE: 'click here',
//   CLICK_HERE_TO_JOIN: 'click here to join it',
//   OR: 'or',
//   SKIP_STEP: 'skip step',
//   NO_ACCOUNT_QUESTION: "Don't have an account yet?",
//   GO_BACK_TO_DASHBOARD: 'Go back to dashboard',
//   NO_CHANGES_MADE: 'No changes were made.',
//   NOTIFICATION: 'Notificación',
//   THEME: 'Theme',
//   SELECT_THEME: 'Select theme',
//   THEME_LIGHT: 'Light',
//   THEME_DARK: 'Dark',
//   APPEARANCE: 'appearance',
//   SELECT: 'Select',
// };

// const profile = {
//   PERSONAL_INFORMATION: 'Personal information',
//   UPDATE_YOUR_INFORMATION: 'Update your personal information',
//   LANGUAGE: 'Language',
//   CUSTOMER_INFO: 'Customer information',
//   SELECT_LANGUAGE: 'Select language',
//   UPDATE_USER_SUCCESSFULL: 'Successfully updated user',
// };

export default {
  reporter_face: {
    title: 'Face verification',
    description:
      'Managed here for this workspace. The reporter captures their face on the phone after confirming their password. Password fallback remains available.',
    // The long form explains the state; it is what the dialog shows and what
    // the table column puts in the chip's tooltip.
    status: {
      disabled: 'Disabled',
      awaiting_capture: 'Waiting for the reporter to capture their face',
      pending_approval: 'Awaiting administrator approval',
      approved: 'Approved',
    },
    // The short form fits a table cell.
    statusShort: {
      disabled: 'Disabled',
      awaiting_capture: 'Awaiting capture',
      pending_approval: 'Awaiting approval',
      approved: 'Approved',
    },
    unavailable: 'The face verification service is not currently available.',
    reviewHelp:
      'Confirm that this face belongs to the named reporter using a trusted identity check before approving.',
    preview: 'Face submitted for approval',
    enable: 'Enable',
    approve: 'Approve',
    reject: 'Reject',
    reset: 'Request new enrollment',
    disable: 'Disable',
    erase: 'Delete face data',
    error:
      'Could not update face verification. Check your permissions and refresh before trying again.',
    errors: {
      changed:
        'This enrollment changed while you were reviewing it. It has been refreshed; review it again.',
      notPending: 'This capture is no longer pending.',
    },
    confirm: {
      approve: 'I have checked that this face belongs to this reporter.',
      reject: 'Reject this capture and ask the reporter to enroll again?',
      reset: 'Remove the current face and require a new capture and approval?',
      disable:
        "Disable face verification and remove this reporter's enrolled face?",
      erase:
        'Permanently delete this reporter\u2019s face data in this workspace? This cannot be undone and works even if they are no longer assigned to a device.',
    },
    close: 'Close',
  },
  // traduciones genéricas
  ...formItemsValidation,
  recurrence_days: {
    monday: 'MO',
    tuesday: 'TU',
    wednesday: 'WE',
    thursday: 'TH',
    friday: 'FR',
    saturday: 'SA',
    sunday: 'SU',
  },
  /* ------------------ */
  'monitoring.call.button.tooltip': 'Make a call',
  'monitoring.chat.button.tooltip': 'Start a chat',
  'monitoring.log.button.tooltip': 'View log',
  'monitoring.verification.button.tooltip': 'Request alarm verification',
  'monitoring.verification.error.no_eligible_members':
    'No conversation members are linked as emergency contacts with codes for this device.',
  'monitoring.verification.error.no_codes_configured':
    'This device has no verification codes. Add a secret or duress key to the device, or a device-specific emergency contact with an email and a code.',
  'monitoring.verification.error.request_pending':
    'A verification request is already pending. Wait for the user to respond before sending another.',
  'monitoring.verification.error.generic':
    'Could not send verification request. Please try again.',
  'monitoring.unread_chat_message': 'Unread chat message',
  'monitoring.open_situation_chat': 'Open chat',
  Resolution: 'Resolution',
  'authpage.title': 'Treinco',
  'authpage.subtitle': 'cloud base monitoring platform',
  'login.noaccount.message': 'Create an account for free.',
  'page.authentication': 'Treinco Cloud',
  'login.link.register': 'Register',
  'login.title': 'Login',
  'login.subtitle': 'Do you already have an account? Then login',
  'login.form.email': 'Email',
  'login.form.password': 'Password',
  'login.button.forgotPassword': 'Forgot password?',
  'login.button.submit': 'Login',
  'register.title': 'Create an account',
  'register.subtitle':
    'You can create an account for free in seconds filling the following form',
  'registered.title': 'You have created an account!',
  'registered.subtitle': 'Check your email and confirm it.',
  'signup.form.firstname': 'Firstname',
  'signup.form.lastname': 'Lastname',
  'signup.form.email': 'Email',
  'signup.form.password': 'Password',
  'signup.form.confirmpassword': 'Confirm password',
  'register.haveaccount.message': 'Do you have an account?',
  'register.link.login': 'Login',
  'register.info.fromInvitationLink':
    'This account was created from an invitation link',
  'forgotpassword.title': 'Reset your password',
  'forgotpassword.subtitle':
    'Did you forget your password? Fill the details and we help you to create a new one',
  'forgotpassword.button.submit': 'Reset password',
  'forgotpassword.link.login': 'Login',
  'signup.success': 'Ready to start?',
  'signup.link.login': 'Login',
  'signup.button.submit': 'Register',
  'forgotpassword.success': 'Check your email',
  'forgotpassword.confirmation.send.to': 'We sent you an email to',
  'forgotpassword.confirmation.check.email':
    'You will find the instructions to create a new password',
  'validateaccount.success': 'We have validated your account',
  'validateaccount.link.login': 'Login',
  'resetpassword.title': 'Create a new password',
  'resetpassword.subtitle': 'Use a strong password that you can remember',
  'resetpassword.form.password': 'Password',
  'resetpassword.form.confirmpassword': 'Confirm password',
  'resetpassword.form.button.submit': 'Create new password',
  'resetpassword.success': 'Your password has been updated',
  'resetpassword.link.login': "Let's go to login",

  // User Profile Form
  'userprofile.form.firstname': 'First Name',
  'userprofile.form.lastname': 'Last Name',
  'userprofile.form.email': 'Email',
  'user_edit_form.success_message': 'User updated successfully',
  'user.profile.changePassword.form.oldPassword': 'Old Password',
  'user.profile.changePassword.form.newPassword': 'New Password',
  'user.profile.changePassword.form.confirmPassword': 'Confirm Password',

  // Invite Members Form
  'invite_members_form.title': 'Invite Member',
  'invite_members_form.subtitle': 'Send an invitation to a new member',
  'invite_members_form.email': 'Email',
  'invite_members_form.button_submit_label': 'Send Invitation',
  'invite_members_form.success': 'Invitation sent successfully',
  'invite_members_form.error.user_exist': 'This user already exists',
  'invite_members_form.error.user_invited_already':
    'This user has already been invited',
  'invite_members_form.error.general_error':
    'An error occurred while sending the invitation',
  'invite_members_form.error.device_not_belong_to_customer':
    'One of the selected devices does not belong to this customer',
  'invite_members_form.error.inviter_role_ambiguous':
    'The selected devices have different roles. Invite them separately.',

  // Monitoring

  'situation_category.title_text': 'Situation Categories',
  'situation_category.category_label': 'Select Situation Category',
  'situation_category.process_button': 'Process Situation',
  'situation_category.fetch_error':
    'Failed to load categories. Please try again.',

  'events.event_field_text': 'Event',
  'events.generated_at_text': 'Generated',
  'events.received_at_text': 'Received',
  'events.action_field_text': 'Actions',

  'removeDeviceHistory.success': 'Excluded event from situation',
  'removeDeviceHistory.error': 'Failed to exclude event from situation',

  'select.one': 'Select',
  'resolution.placeholder':
    'Here you can write what is happening with this situation and add it to the log',
  'monitoring.process.button.text': 'Process',
  'monitoring.comment.button.text': 'Comment',
  'monitoring.pending.button.text': 'Set to pending',
  'monitoring.pending.button.hold': 'Clear from pending queue',
  'monitoring.transfer.button.text': 'Transfer',
  'monitoring.process_bulk_modal': 'Bulk process',
  'monitoring.bulk.select_all': 'Select all',
  'monitoring.situation_events_count': 'Events to process',
  'Monitoring.bulk.byEventCode': 'By event code',
  'Monitoring.bulk.byDevice': 'By device',
  'Monitoring.bulk.byEventgroup': 'By event group',
  'Monitoring.bulk.all': 'All',
  'events.timeline.title_text': 'Log',
  'timeline.error_text': 'Could not load the log.',
  'timeline.retry_button_text': 'Retry',
  'events.notes.title_text': 'Notes',
  'events.notes.empty_state': 'No notes for this device.',
  'notes.createdAt': 'Created',
  'notes.expiresAt': 'Expires',
  'events.tab.activities': 'Activities',
  'events.tab.events': 'Events',
  'events.activities.empty': 'No cameras associated with the active round',
  'events.activities.channel_commented': 'Channel already commented',
  'events.activities.comment_channel': 'Comment channel',
  'events.activities.round_started':
    'CCTV round started — Activities tab is now available',
  'events.timeline.opened_cctv_camera_log_text': 'Camera opened',
  'events.timeline.opened_cctv_camera_log_description':
    '{{ operator }} opened camera {{ channelName }}',
  'events.timeline.checked_cctv_channel_log_text': 'Channel checked',
  'events.timeline.checked_cctv_channel_log_description':
    '{{ operator }} checked channel {{ channelName }}: "{{ comment }}"',
  'events.contacts.title_text': 'Emergency Contacts',
  'monitoring.chat.button.text': 'Chat',
  'monitoring.call.button.text': 'Call',
  'monitoring.send.button.tooltip': 'Send (coming soon)',
  'monitoring.games.button.tooltip': 'Quick actions (coming soon)',
  'monitoring.general_chat_tooltip': 'General Chat',
  'monitoring.situation_chat_tooltip': 'Situation Chat',
  'Situation.comment.success': 'Added comment',
  'Situation.comment.error': 'Error submitting comment',

  'pending_situation_time_form.time_label': 'Wait Time',
  'pending_situation_time_form.time_placeholder': 'Minutes',
  'pending_situation_time_form.time_error':
    'Time must be more than 1 and less than 720 minutes',
  'pending_situation_time_form.submit_button': 'Set to Pending',
  'pending_situation_time_form.title_text': 'Set to Pending',

  'monitoring.summary.button': 'Generate summary',
  'monitoring.summary.loading': 'Generating...',
  'monitoring.summary.success': 'Summary generated successfully',
  'monitoring.summary.error': 'Error generating summary',
  'monitoring.summary.disabled.no_key':
    'OpenRouter API Key is missing in the Workspace',
  'monitoring.summary.disabled.no_call':
    'No completed call recordings for this situation',

  'events.timeline.assigned_log_text': 'Assigned',
  'events.timeline.assigned_event_log_text': 'Event assigned',
  'events.timeline.abandoned_log_text': 'Abandoned',
  'events.timeline.abandoned_event_log_text': 'Event excluded',
  'events.timeline.created_log_text': 'Created',
  'events.timeline.opened_log_text': 'Opened',
  'events.timeline.comment_log_text': 'Commented',
  'events.timeline.processed_log_text': 'Processed',
  'events.timeline.default_log': 'Unknown',
  'events.timeline.autoprocessed_log_text': 'Self-processed',
  'events.timeline.opened_conversation_log_description':
    'Chat conversation opened',
  'events.timeline.opened_conversation_log_text': 'Opened chat',
  'events.timeline.contact_called_log_text': 'Called contact',
  'events.timeline.contact_called_log_description':
    '{{ operator }} called {{ phoneNumber }}',
  'events.timeline.call_comment_text': 'Call Comment',
  'events.timeline.call_comment_customer_description': `Customer number {{ phoneNumber }} was called. Comment: {{ comment }}`,
  'events.timeline.call_comment_device_description': `Device number {{ phoneNumber }} was called. Comment: {{ comment }}`,
  'events.timeline.call_comment_description':
    'User {{ phoneContact }} phone number {{ phoneNumber }} was called. Comment: {{ comment }}',
  'events.timeline.call_recording_text': 'Call recorded',
  'events.timeline.call_recording_description':
    'Call to {{ number }} recorded - {{ duration }}',
  'events.timeline.duress_confirmed_log_text': 'Duress confirmed',
  'events.timeline.duress_confirmed_log_description':
    'User confirmed the alarm is REAL (duress code)',
  'events.timeline.set_to_pending_log_text': 'Set to pending',
  'events.timeline.set_to_pending_log_description':
    '{{ operator }} set the situation to pending',
  'voip.recording_listen': 'Listen',
  'voip.recording_loading': 'Loading...',
  'voip.recording_incomplete': 'Listen (incomplete)',
  'voip.call_summary': 'Call summary (generated by AI, may contain errors)',
  'voip.saving_recording':
    'Saving recording... Please do not close this window',

  // event details translations
  'events.timeline.commented_log_description':
    '{{ operator }} commented: "{{ comment }}"',
  'events.timeline.opened_log_description':
    '{{ operator }} reviewed this incident',
  'events.timeline.assigned_log_description':
    'The incident was assigned to operator {{ operator }}',
  'events.timeline.processed_log_description':
    'The incident was processed by {{ operator }}',
  'events.timeline.created_log_description': 'Incident created',
  'events.timeline.assigned_event_log_description':
    'Event {{ eventCode }} assigned to the incident',
  'events.timeline.opened_conversation_log_description':
    'Chat conversation opened',
  'events.timeline.abandoned_event_log_description':
    'Event {{ eventCode }} removed from the incident',
  'events.timeline.autoprocessed_log_description': 'Incident auto-processed',
  'events.timeline.reason_label': 'Reason',
  'events.timeline.abandoned_log_text': '{{ operator }} closed the incident',

  'self.generated': 'Self-generated',
  'self.processed': 'Self-processed',
  'self.devicehistory_details_title': 'Signal details',
  'situation.log': 'Situation log',
  'Situation.processed.success': 'The situation has been processed',
  'Situation.processed.error': 'The situation could not be processed',

  'monitoring.monitoring_error_modal_title': 'Important Message',
  'monitoring.operator_already_exists_message':
    'You are already connected to the monitoring service',
  'monitoring.expired_user_connection_message':
    'Your connection to the monitoring service has expired, please reload',
  'monitoring_monitoring_error_modal.button_reset': 'Reload',

  'monitoring.call_window_title': 'Make a call',
  'contacts.phone_number_label': 'Phone number {{ index }}',
  'contacts.local_phone_label': 'Local phone number',
  'contacts.mobile_phone_label': 'Mobile phone number',
  'contacts.group_label': 'Contact(s): {{ count }}',
  'contacts.empty_contacts_text': 'No contacts available',
  'contacts.contact_information_title': 'Contact Information',
  'contacts.security_codes_title': 'Security Codes',
  'contacts.person_id_label': 'Person ID:',
  'contacts.cra_code_label': 'CRA Code',
  'contacts.duress_code_label': 'Duress',
  'contacts.confirmation_code_label': 'Confirmation',
  'contacts.not_available': 'N/A',
  'contacts.emergency_fallback': 'Emergency',
  'contacts.contact_fallback': 'Contact',
  'contacts.device_fallback': 'Device',
  'contacts.user_fallback': 'User',
  'contacts.emergency_contact_category': 'Emergency Contact',
  'contacts.device_user_category': 'Device User',
  'contacts.customer_category': 'Customer',
  'contacts.device_contact_category': 'Device Contact',
  'contacts.emergency_contact_info_default': 'Emergency contact information',
  'contacts.customer_address_not_available': 'Customer Address not available',
  'phonebook.customer_contacts': 'Customer',
  'phonebook.device_contacts': 'Device',
  'phonebook.user_contacts': 'User',
  'phonebook.emergency_contacts': 'Emergency Contacts',

  'device_history_table.chat_history': 'Chat history',
  'device_history_table.more_info_button': 'More info',
  'device_history_table.processed_view': 'Processed',
  'device_history_table.original_view': 'Original',

  'sidebar.dashboard_tab_title': 'Dashboard',
  'sidebar.monitoring_tab_title': 'Monitoring',
  'sidebar.traffic_tab_title': 'Traffic',
  'sidebar.customers_tab_title': 'Customers',
  'sidebar.devices_tab_title': 'Devices',
  'sidebar.reports_tab_title': 'Reports',
  'sidebar.invoices_tab_title': 'Invoices',
  'sidebar.places_tab_title': 'Places',
  'sidebar.settings_tab_title': 'Settings',
  'sidebar.chat_tab_title': 'Chat',
  'sidebar.service_orders_tab_title': 'Service orders',

  // Generic table
  'table.more_options.edit': 'Edit',
  'table.more_options.delete': 'Delete',
  'table.create_button.text': 'Create',

  // Workspaces
  'page.workspace.create': 'Create Workspace',
  'page.workspaces.title': 'Workspaces',
  'page.workspaces.subtitle':
    'Here you can select or manage the workspaces you belongs to',
  'workspaces.create_workspace.button.text': 'Create workspace',
  'workspace.select_workspace_error.snackbar.text':
    'We had problems to get the workspace information',
  'workspace.super_admin_role': 'Super Admin',
  'workspaces.create_workspace_modal.step1.text': 'Step 1',
  'workspaces.create_workspace_modal.step2.text': 'Step 2',
  'workspaces.create_workspace_modal.step3.text': 'Step 3',
  'workspaces.create_workspace_modal.step1.title':
    'Choose a name for your workspace',
  'workspaces.create_workspace_modal.step1.subtitle':
    'This name will be the name how your workspace will be identified, it will be visible for all kind of users',
  'workspaces.create_workspace_modal.step1.name.input_label_text':
    'Workspace name',
  'workspaces.create_workspace_modal.back_button.text': 'Back',
  'workspaces.create_workspace_modal.finish_button.text': 'Create workspace',
  'workspaces.create_workspace_modal.next_button.text': 'Next',
  'workspaces.create_workspace_modal.step2.title':
    'Choose what kind of workspace do you want to create',
  'workspaces.create_workspace_modal.step2.subtitle':
    'Depending of what kind of workspace you create, we will adapt the ui to provide a better experience',
  'workspaces.create_workspace_modal.step2.card1.title': 'Basic',
  'workspaces.create_workspace_modal.step2.card1.subtitle':
    'If you monitor only your own devices',
  'workspaces.create_workspace_modal.step2.card2.title': 'Advanced',
  'workspaces.create_workspace_modal.step2.card2.subtitle':
    'When you monitor devices also for clients',
  'workspaces.create_workspace_modal.step3.title':
    'We are ready to create your workspace',
  'workspaces.create_workspace_modal.step3.subtitle':
    'When you press create we are going to create a new workspace for you, in this workspace you will be able to manage isolated devices and users.',

  'CreateWorkspace.success': 'Workspace created successfully',
  'CreateWorkspace.error': 'Error creating workspace',
  'createWorkspace.finish.title': 'Workspace Created Successfully',
  'createWorkspace.finish.description':
    'Your workspace is being set up. This may take a few moments.',
  'createWorkspace.error.title': 'Failed to Create Workspace',
  'createWorkspace.error.description':
    'Something went wrong while creating your workspace. Please try again.',

  // Monitoring
  'monitoring.situations_tab_title': 'Situations',
  'monitoring.device_history_tab_title': 'Traffic',
  'monitoring.on_hold_tab_title': 'Pending',
  'monitoring.situation.processedByUser':
    'This situation was verified and processed by the user from the app',
  'page.monitoring.title': 'Monitoring',
  'page.monitoring.subtitle':
    'Here you will receive in real time all the events related with your devices that need to be processed',
  'monitoring.monitoring_table.name_field_text': 'Device',
  'monitoring.monitoring_table.events_field_text': 'Events',
  'monitoring.monitoring_table.complement_field_text': 'Complement',
  'monitoring.monitoring_table.extra_field_text': 'Extra',
  'monitoring.monitoring_table.date_field_text': 'Received at',
  'monitoring.monitoring_table.actions_field_text': 'Actions',
  'createDeviceHistory.submit': 'Simulate history',
  'createDeviceHistory.form.longitude': 'Longitude',
  'createDeviceHistory.form.latitude': 'Latitude',
  'createDeviceHistory.form.line': 'Line',
  'createDeviceHistory.form.partition': 'Partition',
  'createDeviceHistory.form.zone_or_user': 'Zone or User',
  'createDeviceHistory.form.channel': 'Channel',
  'createDeviceHistory.form.code': 'Event code',
  'createDeviceHistory.form.protocol': 'Protocol',
  'createDeviceHistory.form.device': 'Device',
  'createDeviceHistory.dialog.subtitle':
    'Here you can simulate an event in the device history',
  'createDeviceHistory.dialog.title': 'Simulate event',
  'monitoring.map_situationDevice.no_position': 'Device no position',
  'timeline_grid.details_modal_title': 'Details',
  'timeline_grid.no_user_text': 'No user',

  // traffic
  'page.traffic.title': 'Traffic',
  'page.traffic.subtitle':
    'Here you can see all the events processed by this workspace',

  // Emergency Contact List
  'emergency_contact_list.title_text': 'Emergency contact lists',
  'emergency_contact_list_table.name_field_text': 'Emergency contact',
  'emergency_contact_list_table.order_field_text': 'Order',
  'emergency_contact_list_table.phone_numbers_field_text': 'Phone Numbers',
  'emergency_contact_list_table.call_field_text': 'Call',
  'emergency_contact_list_table.actions_field_text': 'Actions',
  'emergency_contact_list.button_add_emergency_contact':
    'Add emergency contact',
  'emergency_contact_list.button_update_emergency_contact_list_order':
    'Update emergency contact list',

  // Customers
  'page.customers.title': 'Customers',
  'page.customers.subtitle':
    'Here you can manage the customers. Customers is where you group devices and final client users',
  'customers.table.name_field.text': 'Customer',
  'customers.table.identifier_field.text': 'Identifier',
  'customers.table.devices_field.text': 'Devices',
  'customers.table.actions_field.text': 'Actions',
  'customers.table.link.customer': 'Go to customer',
  'customerForm.title': 'Customer',
  'customer.form.name': ' Name',
  'customer.form.identifier': 'Unique identifier',
  'customerSelector.add.customer.submit': 'Create customer',
  'customerSelector.edit.customer.submit': 'Edit customer',
  'CreateCustomer.create.success': 'Customer created successfully',
  'CreateCustomer.edit.success': 'Customer updated successfully',
  'CreateCustomer.create.error': 'Error creating customer',
  'EditCustomer.create.error': 'Error updating customer',
  'DeleteCustomer.delete.error': 'Error deleting customer',

  // Missing translations batch
  'DeleteCustomer.delete.success': 'Customer deleted successfully',
  'devicePartition.schedule.partition.created':
    'Partition assigned to schedule',
  'devicePartition.schedule.partition.removed':
    'Partition removed from schedule',
  'updateWorkspace.general.success': 'Workspace updated successfully',
  'customer_profile.no_identifier_text': 'No identifier',
  'InvitationItem.success.message': 'Invitation deleted successfully',
  'userItem.success.message': 'User deleted successfully',
  'membersItem.delete.title.confirmation': 'Delete member',
  'membersItem.delete.confirmation':
    'Are you sure you want to delete this member?',
  'resetpassword.invalidlink': 'This link is invalid or has expired',
  'workspace.delete.title.confirmation': 'Delete avatar',
  'workspace.avatar.delete.confirmation':
    'The deleted data cannot be recovered',
  'register.message.accept.invitation': 'Register to accept your invitation',
  'login.info.fromInvitationLink': 'Sign in to accept your invitation',
  'customerItem.delete.title.confirmation': 'Delete customer',
  'customerItem.delete.confirmation':
    'Are you sure you want to delete this customer? This action cannot be undone.',

  // Customer profile
  'customer_profile.devices_tab_title': 'Devices',
  'customer_profile.members_tab_title': 'Members',
  'customer_profile.title_text': 'Customer profile',
  'customer_profile.delete_customer_confirmation_title_text': 'Delete customer',
  'customer_profile.delete_customer_confirmation_description_text':
    'Are you sure you want to delete this customer? This action cannot be undone.',
  'members_table.name_field.text': 'Name',
  'members_table.type_field_text': 'Type',
  'members_table.actions_field.text': 'Actions',
  'members_table.action_field_text': 'Action',
  'members_table.invite_member_text': 'Invite user',
  'members_table.invitation_type_text': 'Invitation',
  'invitation.waiting.approval': 'Waiting for approval',
  'customer.change_avatar_modal.title': 'Change avatar',
  'customer.remove.avatar.title': 'Remove avatar',
  'customer.remove.avatar.description':
    'Are you sure you want to remove the avatar?',
  'customer.view_avatar_modal.label': 'View avatar',
  'customer.view_avatar_modal.title': 'Avatar',
  // Customer Category Select
  'customer_category.created_success': 'Category created successfully',
  'customer_category.create_error': 'Error creating category',
  'customer_category.select_label': 'Customer category',
  'customer_category.search_error': 'Error searching categories',
  'customer_category.add_new': 'Add new category',
  'customer_category.create_title': 'Create new category',
  'customer_category.description_label': 'Category description',
  'customer_category.create_button': 'Create',
  'customer_profile.general_tab_title': 'General',
  // Monitoring
  'device_profile.events_tab_title': 'Situation',

  // Device Profile
  'device_profile.title_text': 'Device profile',
  'device_profile.alarm_type_text': 'Alarm device',
  'device_profile.round_type_text': 'Tours device',
  'device_profile.gps_type_text': 'GPS device',
  'device_profile.treinco_app_type_text': 'Treinco App device',
  'device_profile.cctv_type_text': 'CCTV device',

  'device_profile.situation_tab_title': 'Situation',
  'device_profile.reporters_tab_title': 'Persons',
  'device_profile.map_tab_title': 'Map',
  'device_profile.zones_tab_title': 'Zones',
  'device_profile.schedule_tab_title': 'Schedules',
  'device_profile.rounds_tab_title': 'Tours',
  'device_profile.users_tab_title': 'Users',
  'device_profile.history_tab_title': 'History',
  'device_profile.emergency_contact_tab_title': 'Contacts',
  'device_profile.notes_tab_title': 'Notes',
  'device_profile.channels_tab_title': 'Channels',
  'device_profile.orders_tab_title': 'Service Orders',
  'device_profile.partitions_tab_title': 'Partitions',
  show_expired_notes: 'Show notes expired',
  hide_expired_notes: 'Hide notes expired',
  'device.change_avatar_modal.title': 'Change avatar',
  'device.view_avatar_modal.label': 'View avatar',
  'device.view_avatar_modal.title': 'Avatar',
  'device.status.isActive': 'Device active',
  'device.status.isMonitorable': 'Device monitorable',
  'device.status.isPushNotificationsEnabled': 'Push notifications enabled',

  'device_profile.timers_tab_title': 'Timers',
  'device_profile.inactivations_tab_title': 'Inactivations',
  'device_profile.custom_events_tab_title': 'Custom events',
  'device_profile.attachments_tab_title': 'Attachments',
  'device_profile.links_tab_title': 'Links',
  'device_profile.unknown_status_text': 'Unknown',
  'device_profile.status_tooltip': 'Device status',
  'device_profile.empty_address_text': 'No address',
  'device_profile.customer_id_label': 'Customer ID',
  'speed_limit_form.title_text': "Configure the device's speed limit",
  'speed_limit_form.speed_limit_label_text': 'Speed limit',
  'speed_limit_form.submit_text': 'Save speed limit',
  'command_form.title_text': 'Send a command to the device',
  'command_form.send_by_label': 'Send via',
  'command_form.command_select_label_text': 'Select a command',
  'command_form.submit_text': 'Send command',
  'command_form.error_message': 'Error sending command',
  'device.remove.avatar.title': 'Remove avatar',
  'device.remove.avatar.description':
    'Are you sure you want to remove the avatar?',
  'history.event.not.exist': 'Event does not exist',

  'open.geofence.list': 'Geofences',
  'close.geofence.list': 'Close geofences',
  'open.route.list': 'Routes',
  'close.route.list': 'Close routes',

  'geofences.empty.create':
    'There is not geofences created for this device yet. When you create them, they will be listed here.',

  'geofences.button.create': 'Create',

  'item.update_default.title.confirmation':
    'are you sure you want to set this element as default?',
  'item.update_default.confirmation': 'this will affect new devices only',
  'table.more_options.set_default': 'Set as default',

  'zones.identifier_field_text': 'Identifier',
  'zones.name_field_text': 'Name',
  'zones.partition_field_text': 'Partition',
  'zones.action_field_text': 'Actions',
  'CreateZoneDialog.dialog.title': 'Create zone',
  'CreateZoneDialog.dialog.subtitle':
    'Here you can create a zone to use on your device',
  'createZoneDialog.create': 'Create zone',
  'createZoneDialog.update': 'Edit zone',
  'createZoneDialog.form.identifier': 'Identifier',
  'createZoneDialog.form.name': 'Zone name',
  'deviceZone.delete.title.confirmation': 'Delete zone',
  'deviceZone.delete.subtitle.confirmation':
    'Are you sure you want to delete the zone?',
  'createDeviceZone.general.error': 'Error while creating zone',
  'deviceUsertable.edit.assign.partition': 'Assign partition',
  'deviceUsertable.edit.deviceUser': 'Edit',
  'deviceUsertable.delete.deviceUser': 'Delete',
  'deviceZonetable.edit.deviceZone': 'Edit',
  'deviceZonetable.delete.deviceZone': 'Delete',
  'deviceZonetable.manage.deviceZoneCCTV': 'Manage CCTV associations',
  'deviceZonetable.schedule.deviceZone': 'Schedule settings',
  'deviceZoneSchedule.create_success': 'Zone schedule created successfully',
  'deviceZoneSchedule.create_error': 'Error while creating zone schedule',
  'deviceZoneSchedule.day.Monday': 'Monday',
  'deviceZoneSchedule.day.Tuesday': 'Tuesday',
  'deviceZoneSchedule.day.Wednesday': 'Wednesday',
  'deviceZoneSchedule.day.Thursday': 'Thursday',
  'deviceZoneSchedule.day.Friday': 'Friday',
  'deviceZoneSchedule.day.Saturday': 'Saturday',
  'deviceZoneSchedule.day.Sunday': 'Sunday',
  'deviceZoneSchedule.form_startTime': 'Start time',
  'deviceZoneSchedule.form_endTime': 'End time',
  'deviceZoneSchedule.form.enabled': 'Enabled',
  'deviceZoneSchedule.form.disabled': 'Disabled',
  'zones.schedule_dialog_title': 'Manage schedule',
  'zones.schedule_dialog_subtitle': 'Here you can configure schedule',
  'deviceZoneSchedule.form.save_button': 'Save',
  'deviceZoneSchedule.validation.startTimeRequired':
    'Start time is required when enabled',
  'deviceZoneSchedule.validation.endTimeRequired':
    'End time is required when enabled',
  'deviceZoneSchedule.validation.endTimeAfterStart':
    'End time must be after start time',
  'deviceZoneSchedule.loading_error': 'Error loading schedule',
  'deviceZoneSchedule.validation.differentTimes':
    'End time must be different from start time',
  'deviceZoneSchedule.validation.noOverlaps':
    'Schedules cannot overlap with each other',
  'deviceZoneSchedule.validation.overlapDetected': 'Overlap detected',
  'deviceZoneSchedule.validation.overlapType.identical': 'Identical schedules',
  'deviceZoneSchedule.validation.overlapType.partial': 'Partial overlap',
  'deviceZoneSchedule.validation.overlapType.contained': 'Schedule contained',
  'deviceZoneSchedule.validation.overlapType.contains':
    'Schedule contains another',
  'deviceZoneSchedule.validation.overlapNote':
    "Overlapping schedules may cause unexpected behavior. Please adjust the times to ensure schedules don't conflict with each other.",
  'deviceZoneSchedule.validation.note': 'Note:',
  'deviceZoneSchedule.overnight': 'Overnight',
  'deviceZoneSchedule.overnight_tooltip':
    'This schedule continues into the next day',

  'cctv_zone_manager.title': 'Manage CCTV channels',
  'cctv_zone_manager.location_details':
    'Zone: {{deviceZoneName}} - Location: {{address}} - Lat: {{lat}} Lon: {{lon}}',
  'cctv_zone_manager.no_location':
    'Zone: {{deviceZoneName}} - Location: Not available',
  'cctv_zone_manager.total_associated_channels': 'Associated CCTV Channels',
  'cctv_zone_manager.search_associated_channels_placeholder':
    'Search associated channels...',
  'cctv_zone_manager.total_available_devices': 'Available Devices',
  'cctv_zone_manager.search_devices_placeholder': 'Search available devices...',
  'cctv_zone_manager.add_cctv_success':
    'CCTV channel successfully added to zone',
  'cctv_zone_manager.add_cctv_error': 'Failed to add CCTV channel to zone',
  'cctv_zone_manager.remove_cctv_success':
    'CCTV channel successfully removed from zone',
  'cctv_zone_manager.remove_cctv_error':
    'Failed to remove CCTV channel from zone',

  'users.identifier_field_text': 'Identifier',
  'users.name_field_text': 'Name',
  'users.lastname_field_text': 'Lastname',
  'users.partition_field_text': 'Partition',
  'users.action_field_text': 'Actions',
  'users.userIdentifier_field_text': 'ID Document',

  'create.DeviceEmergencyContact.form.name': 'Name',
  'create.DeviceEmergencyContact.form.note': 'Note',
  'create.DeviceEmergencyContact.form.contactIdentifier': 'ID Document',
  'create.DeviceEmergencyContact.form.email': 'Email',
  'Create.DeviceEmergencyContact.button.submit': 'Create',
  'Create.DeviceEmergencyContact.title': 'Emergency contact',

  'add.emergency.contact.title': 'Add Emergency Contact',
  'emergencyContactEmergencyContactListEventGroup.delete.title.confirmation':
    'This action cannot be undone',
  'emergencyContactEmergencyContactListEventGroup.delete.confirmation':
    'Are you sure you want to delete this contact?',
  'deviceEmergencyContactEventGroup.delete.title.confirmation':
    'This action cannot be undone',
  'deviceEmergencyContactEventGroup.delete.confirmation':
    'Are you sure you want to delete this contact?',
  'emergencyContactList.delete.title.confirmation':
    'This action cannot be undone',
  'emergencyContactList.delete.confirmation':
    'Are you sure you want to delete this list?',

  'emergencyContactListItem.delete.success': 'List was successfully deleted',

  'CreateUserDialog.dialog.title': 'Create user',
  'CreateUserDialog.dialog.subtitle':
    'Here you can register an alarm panel user', //que bolas este error(mio) a->an
  'CreateUserDialog.create': 'Create user',
  'CreateUserDialog.update': 'Edit user',
  'CreateUserDialog.form.identifier': 'Identifier',
  'CreateUserDialog.form.firstName': 'Name',
  'CreateUserDialog.form.lastName': 'Lastname',
  'CreateUserDialog.form.userIdentifier': 'ID Document',

  'dolynk.errors.playback_url_not_found': 'Playback URL not found',
  'dolynk.errors.cctv_websocket_error': 'Error connecting to CCTV WebSocket',
  'dolynk.errors.live_url_not_found': 'Live URL not found',
  'dolynk.errors.stream_lost': 'Live view stopped. The stream did not respond.',
  'dolynk.retry': 'Retry',
  'dolynk.playback.from': 'Playback from',
  'dolynk.playback.to': 'Playback to',
  'table.more_options.playback_camera': 'Playback camera',
  'dolynk.errors.select_start_end_dates':
    'Please select both start and end dates for playback',
  'dolynk.errors.end_date_before_start_date':
    'End date must be after start date',
  'dolynk.errors.select_dates_before_playback':
    'Set start and end dates before loading playback',
  'dolynk.channel_list': 'Channels',
  'dolynk.select_slot':
    'Click a slot to select it, then click a channel to load it',
  'dolynk.empty_slot': 'Select a channel',
  'dolynk.layout.one_up': '1 Camera',
  'dolynk.layout.four_up': '4 Cameras',

  'cctv.download_plugin': ' Download the camera plugin.',
  'cctv.error_conection': 'Failed to connect.',
  'cctv.success': 'Successfully sent.',

  //Device Profile Rounds
  'round.point.stack.add_button': 'Add points',
  'round.form.title': 'Tour Details',
  'round.device_points.title': 'Device Points',
  'round.device_points.add_selected': 'Add to tour',
  'round.round_points.title': 'Round Points',
  'round.empty_round_points_label': 'Yout must add points to the round',
  'round.device_channels.title': 'Camera Channels',
  'rounds.channel': 'Channel',
  'rounds.channel_id_column': 'Channel #',
  'rounds.channel_description_column': 'Description',
  // CCTV Point form
  'cctv_point.channel_label': 'Camera Channel',
  'cctv_point.identifier_label': 'Identifier (auto)',
  'cctv_point.name_label': 'Name',
  'cctv_point.description_label': 'Description',
  'cctv_point.add_error': 'Failed to link camera channel to round',
  'point_table.search_point': 'Search place',
  'Rounds.dialog.title': 'Tour Form',
  'Rounds.name': 'Tour Name',
  'Rounds.startDate': 'Start date',
  'Rounds.endDate': 'End date',
  'Roundsrecurrence.select.title': 'Recurrence',
  notRepeated: 'Not Repeated',
  businessDays: 'Business Days',
  custom: 'Custom',
  'Rounds.add_button_text': 'Add tour',
  'Rounds.edit_button_text': 'Edit tour',
  'calendar_form.delete_button_text': 'Delete',
  'calendar_form.clone_button_text': 'Clone',
  'calendar_form.color_validation_error':
    'Please select a valid color from the available options',
  'rounds.points_table.name_field': 'Name',
  'rounds.points_table.place_field': 'Place',
  'rounds.points_table.order_field': 'Order',
  'rounds.points_table.action_field': 'Actions',

  'point.download_qr_button': 'Print QR codes',
  'point.create_success': 'Point created successfully',
  'point.create_error': 'Unable to create point',
  'point.update_success': 'Point updated successfully',
  'point.update_error': 'Unable to update point',
  'point.delete_success': 'Point removed successfully',
  'point.delete_error': 'Unable to remove point',
  'point.button_add_existing': 'Search',
  'point.attach_modal.title': 'Attach points from workspace',
  'point.attach_modal.confirm': 'Attach points',
  'point.attach_modal.cancel': 'Cancel',
  'point.attach_modal.success': 'Points attached successfully',
  'point.attach_modal.error': 'Unable to attach points',
  'point.attach_modal.workspace_error':
    'Workspace not available for this device',
  'pointItem.delete.title.confirmation':
    'Are you sure you want to remove this point from the round?',
  'pointItem.delete.confirmation': 'This action cannot be undone',
  'table.more_options.delete.point': 'Remove from round',
  'table.more_options.edit.point': 'Edit point',
  'points.view_qr_text': 'View QR code',
  // Alarm Schedules
  'alarm_schedule.add_button_text': 'Add alarm schedule',
  'alarm_schedule.edit_button_text': 'Edit alarm schedule',
  'alarm_schedule.name': 'Name',
  'alarm_schedule.startDate': 'Start date',
  'alarm_schedule.endDate': 'End date',
  'alarm_schedule.recurrence.select.title': 'Recurrence',
  assign_partition: 'Assign partition',
  'alarm_schedule.dialog.title': 'Alarm Schedule',

  //Points
  'createPoint.add.title': "Point Form's",
  'createPoint.add.subtitle': 'Here you can manage the points for your route.',
  'CreatePointDialog.form.identifier': 'Identifier',
  'CreatePointDialog.form.name': 'Name',
  'CreatePointDialog.form.description': 'Description',
  'CreatePointDialog.form.place': 'Place',
  'CreatePointDialog.form.tasks': 'Point tasks',
  'CreatePointDialog.form.add_tasks': 'Add task',
  'createPoint.Add.Point.Submit': 'Create Point',
  'updatePoint.submit': 'Update Point',

  //Device Profile Persons
  'reporters_table.firstName_field': 'Name',
  'reporters_table.lastName_field': 'Lastname',
  'reporters_table.username_field': 'Username',
  'reporters_table.email_field': 'Email',
  'reporters_table.actions_field': 'Actions',
  'reporters.add_reporter_form': 'Add Person',
  'reporters.edit_reporter_form': 'Edit Person',
  'reporters.remove_reporter': 'Remove reporter',
  'reporters.edit_restricted':
    'This user has other roles assigned, so to change their password they must do so from their own account',
  'reporters.edit_wrong_workspace':
    'This person was created from another workspace and cannot be edited here',
  'reporters.search_placeholder': 'Name',
  'add_reporters_form.add_reporter': 'Add Person',
  'reporters.search.add_reporter': 'Create person',
  'add_reporters_form.create_reporter': 'Create person',
  'create_reporter_user.first_name_label': 'First Name',
  'create_reporter_user.last_name_label': 'Last Name',
  'create_reporter_user.email_label': 'Email',
  'create_reporter_user.username_label': 'Username',
  'create_reporter_user.password_label': 'Password',
  'create_reporter_user.confirm_password_label': 'Confirm Password',
  'create_reporter_user.submit_button': 'Create person',
  'reporters.deleted_reporter_success':
    'Person removed from device successfully',
  'reporters.updated_user_success': 'Person updated successfully',

  //Device Profile Actions
  'device_profile.actions_tab_title': 'Actions',
  'actions_table.id_field_text': 'ID',
  'actions_table.name_field_text': 'Name',
  'actions_table.event_field_text': 'Event',
  'actions_table.action_group_field_text': 'Action belongs to',
  'actions_table.actions_field_text': 'Actions',
  'actions_form.event_label': 'Event',
  'actions_form.create_action': 'Create Action',
  'actions_form.update_action': 'Edit Action',
  'actions_form.search_action': 'Search Action',
  'actions_form.search_label': 'Search',
  'actions_form.name_label': 'Name',
  'actions_form.countdown_label': 'Countdown',
  'actions_form.icon_label': 'Icon',
  'actions_form.color_select_label': 'Color',
  'actions_form.content_label': 'Content',
  'actions_form.add_free_content_label': 'Add free content',
  'actions_form.submit_button': 'Create action',
  'actions_form.add_content_label': 'Add content',
  'actions_form.question_label': 'Question',
  'actions_form.content_type_label': 'Content type',
  'actions_form.mandatory_label': 'Mandatory',
  'actions_form.edit_confirm_message': 'Are you sure?',
  'actions_form.edit_confirm_description':
    'Modifying an associated action will affect all linked devices.',
  'action_content.choice_key': 'Key',
  'action_content.choice_value': 'Value',
  'actions.search_action_title': 'Search action',
  'actions.create_action_title': 'Create action',
  'actions.update_action_title': 'Update action',
  'actions.associate_action_to_action_group.success':
    'Action associated to action group successfully',
  'actions.associate_action_to_action_group.error':
    'Error while associating action to action group',
  'add_action_form.add_action': 'Add action',
  'actions.title_text': 'Actions',
  'actions.reorder_action_success': 'Actions reordered successfully',
  'actions_table.order_field_text': 'Order',
  'update_action_form.success': 'Action updated successfully',
  'update_action_form.error': 'Error while updating action',
  'actions.create_action.success': 'Action created successfully',
  'actions.create_action.error': 'Error while creating action',

  'channels_table.id_field_text': 'Channel ID',
  'channels_table.description_field_text': 'Description',
  'channels_table.actions_field_text': 'Actions',

  'history.attachments': 'Attachments',
  'history.identifier_field_text': 'Identifier',
  'history.info_field_text': 'Info',
  'history.device_name_field_text': 'Device Name',
  'history.event_field_text': 'Event',
  'history.quick_search.events': 'Events',
  'history.quick_search.from': 'Date from',
  'history.quick_search.to': 'Date to',
  'history.export_html.title': 'Device history',
  'history.export_html.truncated': 'Export truncated to the first {{max}} rows',
  'history.export_html.error': 'Failed to export history as HTML',
  'history.export_html.attachments': 'Attachments',
  'history.export_html.view_image': 'View image',
  'history.export_html.view_video': 'View video',
  'history.export_html.view_audio': 'View audio',
  'history.export_html.view_signature': 'View signature',
  'history.export_html.view_legacy_image': 'Attached image',
  'history.export_html.view_legacy_audio': 'Attached audio',
  'history.export_html.view_legacy_video': 'Attached video',
  'history.export_html.text_attachment': 'Text attachment',
  'history.export_html.qr_attachment': 'QR attachment',
  'history.export_html.nfc_attachment': 'NFC attachment',
  'history.export_html.choice_attachment': 'Choice attachment',
  'history.export_html.position': 'Position',
  'history.export_html.view_on_map': 'View on Google Maps',
  'table.toolbar.export_html': 'Download as HTML',
  'table.toolbar.print': 'Print (PDF)',
  'history.event_is_self_generated': 'Self-generated',
  'history.point_field_text': 'Point',
  'history.zone_field_text': 'Zone',
  'history.zone_identifier_field_text': 'Zone ID',
  'history.user_field_text': 'User',
  'history.user_identifier_field_text': 'User ID',
  'history.partition_field_text': 'Partition',
  'history.partition_identifier_field_text': 'Partition ID',
  'history.channel_identifier_field_text': 'Channel ID',
  'history.channel_field_text': 'Channel',
  'history.generated_at_field_text': 'Generated at',
  'history.received_at_field_text': 'Received at',
  'history.processed_at_field_text': 'Processed at',
  'history.processed_at_not_monitorable': 'Not monitorable',
  'history.actions_field_text': 'Actions',
  'history.position': 'View position',
  'history.videos': 'Videos',
  'history.audios': 'Audios',
  'history.images': 'Images',
  'history.round_field_text': 'Round',
  'history.site_place_field_text': 'Place',
  'history.site_device_field_text': 'Device',
  'history.person_field_text': 'Person',
  'deviceHistory.images': 'Images',
  'deviceHistory.videos': 'Videos',
  'deviceHistory.audios': 'Audios',
  'history.live_cam': 'Live cam',
  'history.cctv_channel': 'Channel',
  'history.task_point_field_text': 'Point tasks',

  'notes.button_add': 'Create',
  'createNote.add.note.title': 'Create note',
  'createNote.add.note.subtitle':
    'Here you can create a note to use on your device',
  'createNote.add.note.close': 'Cancel',
  'createNote.add.note.submit': 'Create note',
  'CreateNoteDialog.form.title': 'Title',
  'CreateNoteDialog.form.content': 'Content',
  'CreateNoteDialog.form.expirationDate': 'Date expiration',

  // Links
  'links.button_add': 'Add link',
  'links.form.title_create': 'Create link',
  'links.form.title_edit': 'Edit link',
  'links.form.description': 'Description',
  'links.form.url': 'URL',
  'links.table.description': 'Description',
  'links.table.url': 'URL',
  'links.table.actions': 'Actions',
  'links.create_success': 'Link created successfully',
  'links.update_success': 'Link updated successfully',
  'links.delete_success': 'Link deleted successfully',
  'links.save_error': 'Error saving link',
  'links.delete_error': 'Error deleting link',
  'linkItem.delete.title.confirmation': 'Delete link',
  'linkItem.delete.confirmation':
    'Are you sure you want to delete this link? This action cannot be undone.',
  'table.more_options.edit.link': 'Edit link',
  'table.more_options.delete.link': 'Delete link',

  'emergency_contact.name_field_text': 'Emergency contact name',
  'emergency_contact.order_field_text': 'Order',
  'emergency_contact.phone_numbers_field_text': 'Phone Numbers',
  'emergency_contact.call_field_text': 'Call',
  'emergency_contact.edit_field_text': 'Actions',
  // Devices
  'page.devices.title': 'Devices',
  'page.devices.subtitle':
    'Here you can manage and check the details of your devices',
  'devices.button_create': 'Create',
  'devices.title_text': 'Devices',

  'createdevice.create.title': 'Create device',
  'createdevice.create.subtitle': 'Follow the steps to create your device',
  'customer.select': 'Select a customer',
  'createalarm.form.uniqueid': 'Identifier',
  'createalarm.form.name': 'Name',
  'creategps.form.uniqueId': 'Identifier',
  'creategps.form.name': 'Name',
  'CreateRound.form.uniqueId': 'Identifier',
  'CreateRound.form.name': 'Nombre',
  'createBrand.form.brand': 'Select a brand',
  'createalarm.form.model': 'Select a model',
  'createdevice.button.submit': 'Create device',
  'updatedevice.button.submit': 'Update device',
  'createalarm.form.is_active_input_label': 'General status',
  'createalarm.form.is_active_input_description': 'Active or inactive',
  'createalarm.form.is_monitoring_input_label': 'Monitorable',
  'createalarm.form.is_monitoring_input_description':
    'This device can be monitored',
  'createalarm.form.is_push_notifications_enabled_label': 'Push Notifications',
  'createalarm.form.is_push_notifications_enabled_description':
    'Enable push notifications for this device',
  'createalarm.form.prefix': 'Prefix',
  'createDevice.edit.title': 'Edit device',
  'createDevice.edit.subTitle': 'Here you can edit your device',
  'createDevice.form.timezone': 'Timezone',

  'createdevice.create.cctv_type': 'CCTV type',
  'createdevice.create.fields.ipAddress': 'IP / DNS',
  'createdevice.create.fields.port': 'Port',

  'createdevice.create.fields.connectionString': 'RTSP Connection String',
  'createdevice.create.fields.user': 'User',
  'createdevice.create.fields.password': 'Password',
  'createdevice.create.fields.serial': 'Serial',
  'createdevice.create.fields.hikvisionKey': 'Key',
  'createdevice.create.fields.hikvisionSecret': 'Secret',

  'create_treinco_app.form.email': 'Email',
  'create_treinco_app.form.name': 'Name',
  'create_treinco_app.form.last_name': 'Lastname',
  'create_treinco_app.form.device_name': 'Device name',
  'create_treinco_app.button.submit': 'Send invitation',

  'device.type.subtitle.gps':
    'Track real-time GPS positions and receive movement, speed, and geofence-based alerts from vehicles or mobile units.',
  'device.type.subtitle.alarm':
    'Connect and monitor alarm panels with multiple zones. Automatically receive intrusion, fire, panic, and technical alerts from connected sensors and devices.',
  'device.type.subtitle.round':
    'Configure patrol routes, checkpoints, and incident types. Receive automated logs and alerts when guards complete or miss scheduled patrols.',
  'device.type.subtitle.treinco-app':
    'Give your clients (end users) access to device statuses and locations in real time. Monitoring stations can also configure custom action buttons to allow users to send alerts instantly.',
  'device.type.subtitle.cctv':
    'Connect CCTV systems to view live streams, detect motion, and receive camera-related alerts directly from your monitoring dashboard.',

  'devices.name_field_text': 'Device',
  'devices.type_field_text': 'Type',
  'devices.info_field_text': 'Info',
  'devices.speed_field_text': 'Speed',
  'devices.status_field_text': 'Status',
  'devices.action_field_text': 'Actions',
  'devices.customer_field_text': 'Customer',
  'devices.no_customer_text': 'No customer',
  'devices.created_field_text': 'Created at',
  'devices.services_status_field_text': 'Services status',
  'devices.events_tooltip_text': 'Events List',
  'devices.routes_tooltip_text': 'Routes',
  'devices.close_panel_tooltip_text': 'Close',

  'devicetable.link.device.profile': 'Go to profile',
  'devicetable.link.edit.device': 'Edit',
  'devicetable.delete.device': 'Delete',
  'device.delete.title.confirmation': 'Delete device',
  'device.delete.confirmation':
    'Are you sure you want to delete this device? This action cannot be undone.',
  'deviceTable.success.message': 'Device deleted successfully',
  'deviceTable.error.active_situation_message':
    'Device has one or more active situations',

  'devices.alarm_type_text': 'Alarm',
  'devices.round_type_text': 'Tour',
  'devices.gps_type_text': 'GPS',
  'devices.treinco_app_type_text': 'Treinco App',
  'devices.cctv_type_text': 'CCTV',

  'devices.treinco-app_type_text': 'Treinco App',

  'deviceEvent_table.actions_field': 'Actions',
  'deviceEvent.create_device_event_form': 'Event group form',
  'createDeviceHistory.form.event': 'Select event',
  'event.form.type_zone_option': 'Zone',
  'event.form.type_user_option': 'User',
  'event.form.type_none_option': 'None',

  'devicemap.tooltip.latitude': 'Latitude',
  'devicemap.tooltip.longitude': 'Longitude',
  'devicemap.tooltip.speed': 'Speed',
  'devicemap.tooltip.date': 'Date',
  'devicemap.tooltip.status': 'Status',

  'routes.tooltip.no_direction': 'No direction',
  'routes.tooltip.no_time': 'No time',
  'routes.tooltip.no_distance': 'No distance',
  'routes.tooltip.no_battery': 'No battery',
  'routes.tooltip.no_status': 'No status',
  'routes.tooltip.no_speed': 'No speed',
  'routes.tooltip.no_gps_date': 'No GPS date',
  'route.tooltip.no_server_date': 'No server date',
  'route.tooltip.signal_level': 'Signal level',
  'route.tooltip.battery': 'Battery',
  'route.tooltip.end_date': 'End date',
  'route.tooltip.initial_date': 'Initial date',
  'route.tooltip.stop_time': 'Stop time',
  'route.tooltip.status': 'Status',
  'route.tooltip.gps_date': 'GPS date',
  'route.tooltip.date': 'Date',

  'device_action_groups.import.button.text': 'Import action groups',
  'device_action.groups_.import.title': 'Import action group',
  //Timers
  'timers.create_timer_form': 'Timers Form',
  'timers.update_timer_form': 'Edit Timers Form',
  'timer_form.start_date_label': 'Init date',
  'timer_form.end_date_label': 'End date',
  'timer_form.interval_label':
    'Interval (Every how many minutes will it repeat)',
  'timer_form.action_label': 'Timers Action',
  'timer_form.reset_configuration_label': 'configure event restore',
  'timer_form.protocol_label': 'Protocol',
  'timer_form.event_label': 'Event',
  'timer_form.create_submit_button': 'Timers Create',
  'timer_form.update_submit_button': 'Timers Edit',
  'timers_table.start_date_field': 'Start Date',
  'timers_table.end_date_field': 'End Date',
  'timers_table.interval_field': 'Interval',
  'timers_table.actions_field': 'Actions',
  'timers_table.action_field': 'Action',
  'timers_table.reset_config_field': 'Restore event',
  'timer_action.generate_event': 'Generate Event',

  //Inactivations
  'inactivations.create_inactivation_form': "Inactivation Form's",
  'inactivations.update_inactivation_form': "Edit Inactivation Form's",
  'inactivation_form.start_date_label': 'Init Date',
  'inactivation_form.end_date_label': 'End Date',
  'inactivation_form.protocol': 'Protocol',
  'inactivation_form.event': 'Event Code',
  'inactivation_form.zone_or_user': 'Zone or User',
  'inactivation_form.reason_label': 'Reason or motive',
  'reason_form.create_submit_button': 'Create Inactivation',
  'reason_form.update_submit_button': 'Edit Inactivation',
  'inactivations_table.eventId_field_text': 'Code Event',
  'inactivations_table.reason_field_text': 'Reason or Motive',
  'inactivations_table.from_field_text': 'From',
  'inactivations_table.to_field_text': 'To',
  'inactivations_table.actions_field': 'Actions',

  // Notifications
  'notifications_table.description_field_text': 'Description',
  'notifications_table.type_field_text': 'Type',
  'notifications_table.users_field_text': 'Users',
  'notifications_table.createdAt_field_text': 'Created at',
  'notifications_table.notification_group_field_text': 'Notification Group',
  'notifications_table.actions_field': 'Actions',
  'notifications_table.recipients_field_text': 'Recipients',
  'device_notifications.form.contacts_label': 'Contacts',
  'device_notifications.form.new_contact_button': 'New contact',
  'notifications.validation.description_required': 'Description is required',
  'notifications.validation.description_min_length':
    'Description must be at least 3 characters',
  'notifications.validation.description_max_length':
    'Description must be at most 255 characters',
  'notifications.validation.type_required': 'Type is required',
  'notifications.validation.language_required': 'Choose a language',
  'notifications.validation.type_min_length': 'Type is required',
  'notifications.validation.userId_required': 'Select at least one user',
  'notifications.validation.userId_uuid': 'Invalid user',
  'notifications.validation.notificationGroupId_required':
    'Notification group is required',
  'notifications.validation.notificationGroupId_uuid':
    'Invalid notification group',
  'notifications.validation.contactId_required': 'Select at least one contact',
  'notifications.validation.contactId_uuid': 'Invalid contact',

  // Notification contacts: recipients without a Treinco account
  'settings.settings_tabs.notification_contacts_tab_title':
    'Notification contacts',
  'notification_contacts.subtitle':
    'People who receive alerts by email, Telegram or SMS without a Treinco account.',
  'notification_contacts.table.name': 'Name',
  'notification_contacts.table.email': 'Email',
  'notification_contacts.table.actions': 'Actions',
  'notification_contacts.form.create_title': 'New contact',
  'notification_contacts.form.edit_title': 'Edit contact',
  'notification_contacts.form.name': 'Name',
  'notification_contacts.form.email': 'Email',
  'notification_contacts.form.email_helper':
    'Optional. Needed for email alerts.',
  'notification_contacts.form.submit': 'Save',
  'notification_contacts.create_success': 'Contact created',
  'notification_contacts.create_error': 'Could not create the contact',
  'notification_contacts.update_success': 'Contact updated',
  'notification_contacts.update_error': 'Could not update the contact',
  'notification_contacts.delete_success': 'Contact deleted',
  'notification_contacts.delete_error': 'Could not delete the contact',
  'notification_contacts.validation.name_required': 'Name is required',
  'notification_contacts.validation.name_min_length':
    'Name must be at least 2 characters',
  'notification_contacts.validation.name_max_length':
    'Name must be at most 100 characters',
  'notification_contacts.validation.email_invalid': 'Invalid email address',
  'device_notifications.form.search_member_placeholder':
    'Search customer member',
  'notifications.delete_success': 'Notifications deleted successfully',
  'notifications.delete_error': 'Error deleting notifications',
  'notifications.fetch_error': 'Error fetching notifications',
  'notifications.create_notification_form': 'Create notification',
  'notifications.update_notification_form': 'Edit notification',
  'notifications.update_success': 'Notifications updated successfully',
  'notifications.update_error': 'Error updating notification',
  'notifications.create_success': 'Notifications created successfully',
  'notifications.create_error': 'Error creating notification',
  'device_notifications.form.create_button': 'Create notification',
  'device_notifications.form.notification_group_label': 'Notification group',
  'device_notifications.form.errors.notification_group_load_error':
    'Error loading notification groups',
  'device_notifications.form.type_label': 'Type',
  'device_notifications.form.language_label': 'Message language',
  'device_notifications.form.language_helper':
    'Labels and date format of the alert. Event names are sent as configured.',
  'device_notifications.form.description_label': 'Description',
  'device_notifications.form.users_label': 'Users',
  'device_notifications.form.errors.no_customer_assigned':
    'Device has no customer assigned. Assign a customer to select users.',
  'device_profile.notifications_tab_title': 'Notifications',
  'device_notifications.form.type_treinco_app_push': 'Treinco App Push',
  'device_notifications.form.type_telegram': 'Telegram',

  'members_search.username_text': 'Username',
  'members_search.email_text': 'Email',
  'customer_invitation.button.go_home': 'Go Home',
  'treinco_app_invitation.success.new_user':
    'Account created! Check your email to get your password and sign in.',
  'treinco_app_invitation.success.existing': 'Invitation accepted!',
  'treinco_app_invitation.rejected': 'Invitation rejected.',
  'device_authorization.title': 'Authorize device',
  'device_authorization.subtitle':
    'Do you want to authorize "{{label}}" to access your account?',
  'device_authorization.unknown_device': 'this app',
  'device_authorization.button.approve': 'Authorize',
  'device_authorization.button.deny': 'Deny',
  'customerMember.invitation.modal': 'Manage members',
  // 'members_search.name_text': 'Name',
  // 'members_search.lastname_text': 'Lastname',

  // Places
  'createPlace.title_text': 'Create Place',
  'editPlace.title_text': 'Edite Place',
  'editPlace.subtitle':
    'Here you can edit a Place, you can group devices to places',
  'places.title_text': 'Places',
  'pageplaces.title_text': 'Places',
  'page.places.subtitle':
    'Here you can manage and check the details of the places created in your workspace, they are used to group devices and points',
  'createPlace.form.streetAndNumber': 'Street and number',
  'createPlace.form.name': 'Name',
  'createPlace.form.city': 'City',
  'createPlace.form.state': 'State',
  'createPlace.form.zipCode': 'Zip code',
  'createPlace.button.next': 'Next',
  'createPlace.button.back': 'Back',
  'createPlace.button.submit': 'Create place',
  'createPlace.form.country': 'Country',
  'places.toggle.devices': 'Devices',
  'places.toggle.points': 'Points',
  'places.points_field_text': 'Points',
  'places.point_identifier_text': 'Identifier',
  'places.points_without_place': 'Without place',
  'places.devices_field_text': 'Devices',
  'places.name_field_text': 'Name',
  'places.description_field_text': 'Description',
  'places.latitude_field_text': 'Latitude',
  'places.longitude_field_text': 'Longitude',
  'places.radius_field_text': 'Radio',
  'places.action_field_text': 'Actions',
  'places.empty.create':
    'You have not yet created places for this workspace, when you have shown here.',
  'places.button.create': 'Create',
  'placePicker.place_input_label': 'Select a place',
  'placePicker.search_by_label': 'Search by',
  'placePicker.search_by_place_label': 'Places',
  'placePicker.search_by_device_label': 'Devices',
  'places.table.add_button': 'Add points',
  'createPlace.subtitle':
    'Here you can create a Place, you can group devices to places',
  'places.address_field_text': 'Direction',
  'places.zipCode_field_text': 'Zipcode',
  'places.city_field_text': 'City',
  'places.country_field_text': 'Country',
  'places.place_required': 'Must select a place',
  'devicePlace.create_success': 'Place created successfully',
  'devicePlace.update_success': 'Place updated successfully',
  'placesItem.delete.title.confirmation':
    'Are you sure you want to delete the place?',
  'placesItem.delete.confirmation': 'This action can not be undone',
  'placePicker.button_submit': 'Select place',
  'devicePlace.create_error': 'Error creating place',
  'devicePlace.update_error': 'Error updating place',
  'places.delete_success': 'Place deleted successfully',
  'places.delete_error': 'Error deleting place',
  'places.delete_conflict': 'Cannot delete place with associated devices.',

  // Point management
  'editPoint.title_text': 'Edit point',
  'updatePoint.success': 'Point updated successfully',
  'updatePoint.error': 'Error updating point',
  'deletePoint.success': 'Point deleted successfully',
  'deletePoint.error': 'Error deleting point',
  'deletePoint.error_associated_with_device':
    'Cannot delete the point because it has associated devices.',

  //Service order
  'treinco.service_order_status.unassigned': 'Unassigned',
  'treinco.service_order_status.assigned': 'Assigned',
  'treinco.service_order_status.tracking': 'Tracking',
  'treinco.service_order_status.onhold': 'On hold',
  'treinco.service_order_status.finished': 'Finished',
  'treinco.service_order_status.canceled': 'Canceled',

  'device_service_orders_table.type_field_text': 'Type',
  'device_service_orders_table.description_field_text': 'Description',
  'device_service_orders_table.priority_field_text': 'Priority',
  'device_service_orders_table.createdAt_field_text': 'Created At',
  'device_service_orders_table.scheduledAt_field_text': 'Scheduled At',
  'device_service_orders_table.executedAt_field_text': 'Executed At',
  'device_service_orders_table.status_field_text': 'Status',

  'CreatePlaceOptions.select_place_text': 'Select a place',
  'CreatePlaceOptions.select_place_description':
    'Here you can select a place to add to the device',
  'CreatePlaceOptions.create_place_text': 'Create a place',
  'CreatePlaceOptions.create_place_description':
    'Here you can create a place to add to this device',

  //Chat
  'chat.contacts_search_input_placeholder': 'Search contacts',
  'chat.chat_compose_tooltip': 'Create a new chat',
  'chat.to_addressee_text': 'Add',
  'chat.empty_chat_message': 'Select o create a chat to start a conversation',
  'chat.user_info_title': 'Information',
  'chat.input_text_placeholder': 'Write a message',
  'chat.add_participants_tooltip': 'Add participants',
  'chat.group_participants_count': '{{total}} participants',
  'chat.group_total_participants': 'Total participants',
  'chat.record_audio_not_supported_button_text': 'Record audio not supported',
  'chat.record_audio_button_text': 'Send a voice message',
  'chat.empty_chats_text': 'No chats yet',
  'chat.recipients_placeholder_text': 'Select recipients',
  'chat.self_user_name': 'You',
  'chat.add_participants_button_text': 'Invite',
  'chat.system.group_join_message': '{{ name }} added a new participant',
  'chat.system.group_entry_message': '{{ name }} joined the conversation',
  'chat.system.finished_conversation_message':
    '{{ name }} finished the conversation',
  'chat.system.default_message': 'System message',
  'chat.system.verification_request_message':
    '{{ name }} requested alarm verification',
  'chat.system.false_alarm_confirmed_message':
    '{{ name }} confirmed false alarm — situation resolved',
  'chat.system.duress_confirmed_message':
    '{{ name }} confirmed duress — real alarm',
  'chat.system.verification_invalid_code_message':
    '{{ name }} entered an invalid verification code',
  'chat.search_not_found_title': 'Not found',
  'chat.search_not_found_description': 'No results found for',
  'chat.search_enter_keywords': 'Please enter keywords',
  'chat.finish_chat_confirmation': 'Finish conversation?',
  'chat.finish_chat_description':
    'Are you sure you want to finish this conversation? This action cannot be undone.',
  'chat.finish_chat_error': 'Error finishing conversation. Please try again.',
  'chat.finish_chat_option': 'Finish conversation',
  'chat.unknown_user_name': 'Unknown user',
  'chat.join_group_error': 'Error joining group. Please try again.',
  'chat.status_online': 'Online',
  'chat.last_seen': 'Online {{time}}',

  // Settings
  'settings.title_text': 'Settings',
  'settings.settings_tabs.general_tab_title': 'General',
  'settings.settings_tabs.users_tab_title': 'Users',
  'settings.settings_tabs.roles_tab_title': 'Roles',
  'settings.settings_tabs.event_groups_tab_title': 'Event groups',
  'settings.settings_tabs.events_tab_title': 'Events',
  'settings.settings_tabs.brands_tab_title': 'Brands',
  'settings.settings_tabs.models_tab_title': 'Models',
  'settings.settings_tabs.resolutions_tab_title': 'Predefined messages',
  'settings.settings_tabs.emergency_contact_tab_title': 'Emergency contacts',
  'settings.settings_tabs.emergency_contact_lists_tab_title':
    'Emergency contact lists',
  'settings.settings_tabs.integrations_tab_title': 'Integrations',
  'settings.settings_tabs.notification_groups_tab_title': 'Notification groups',

  // Settings connectors
  'connector_form.title_text': 'Connector',
  'connector_form.subtitle_text':
    'Here you can configure your connector, this will allow you to connect devices to your workspace',
  'connector_form.description_field': 'Description',
  'connector_form.errors.description_min':
    'Description must be at least 3 characters',
  'connector_form.errors.description_max':
    'Description must be at most 50 characters',
  'connector_form.errors.description_required': 'Description is required',
  'create_connector_form.submit_text': 'Create integration',
  'edit_connector_form.submit_text': 'Edit integration',
  'settings.connectors_table.description_field_text': 'Description',
  'settings.connectors_table.secret_field_text': 'Secret',
  'settings.connectors_table.status_field_text': 'Status',
  'settings.connectors_table.receivers_status_field_text': 'Receivers',
  'settings.connectors_table.receiver_status_not_available_message':
    'No receivers',
  'settings.connectors_table.receiver_status_unknown_label': 'Unknown status',
  'settings.connectors_table.receiver_label_fallback': 'Receiver',
  'settings.connectors_table.receiver_last_event_prefix': 'Last event:',
  'settings.connectors_table.receiver_should_be_connected_false':
    'Marked as stopped',
  'settings.connectors_table.receiver_status_connected': 'Connected',
  'settings.connectors_table.receiver_status_connecting': 'Connecting',
  'settings.connectors_table.receiver_status_disconnected': 'Offline',
  'settings.connectors_table.actions_field_text': 'Actions',
  'integration_details.buffer_section_title': 'Connector Buffer',
  'integration_details.buffer_status_title': 'Queued Events',
  'integration_details.buffer_summary':
    'Pending: {{pending}}, In-flight: {{active}}',
  'integration_details.buffer_columns.id': 'ID',
  'integration_details.buffer_columns.status': 'Status',
  'integration_details.buffer_columns.timestamp': 'Timestamp',
  'integration_details.buffer_columns.device': 'Device',
  'integration_details.buffer_columns.event': 'Event',
  'integration_details.buffer_status.inited': 'Initialized',
  'integration_details.buffer_status.queued': 'Queued',
  'integration_details.buffer_status.in_progress': 'In progress',
  'integration_details.buffer_status.acknowledged': 'Acknowledged',
  'integration_details.buffer_status.failed': 'Failed',
  'integration_details.buffer_status.unknown': 'Unknown',
  'integration_details.buffer_status_help.inited':
    'Stored by the receiver. Not sent yet.',
  'integration_details.buffer_status_help.queued':
    'Ready to send to the Cloud Receiver. It will be retried automatically.',
  'integration_details.buffer_status_help.in_progress':
    'Sent. Waiting for the Cloud Receiver to respond.',
  'integration_details.buffer_status_help.acknowledged':
    'The Cloud Receiver processed and stored it successfully.',
  'integration_details.buffer_status_help.failed':
    'The Cloud Receiver received it and rejected it. It will not be retried.',
  'integration_details.buffer_status_help.unknown':
    'Status not recognised by this version.',
  'integration_details.buffer_reason.DEVICE_NOT_FOUND':
    'No device is registered with that identifier for this receiver and line. Check the uniqueId and the workspace prefix.',
  'integration_details.buffer_reason.PROCESSING_ERROR':
    "The platform could not process the event. Check the Cloud Receiver logs around this row's timestamp.",
  'integration_details.buffer_reason.INTERNAL_ERROR':
    'Unexpected internal platform error while processing the event.',
  'integration_details.buffer_empty': 'No events waiting in the buffer.',
  'integration_details.refresh': 'Refresh buffer snapshot',
  'integration_details.last_updated': 'Updated {{relative}} ({{date}})',
  'integration_details.empty_message': 'No configuration details available.',
  'receiver_actions.start': 'Start receiver',
  'receiver_actions.stop': 'Stop receiver',
  'receiver_actions.start_success': 'Receiver {{name}} started successfully.',
  'receiver_actions.start_error':
    'Failed to start receiver {{name}}: {{message}}',
  'receiver_actions.stop_success': 'Receiver {{name}} stopped successfully.',
  'receiver_actions.stop_error':
    'Failed to stop receiver {{name}}: {{message}}',
  'receiver_actions.stop_confirm_title': 'Stop receiver?',
  'receiver_actions.stop_confirm_description':
    'The receiver will stop accepting new connections until it is started again.',

  // Settings integrations
  'settings.integrations_table.type_field_text': 'Type',
  'settings.integrations_table.port_config_field_text': 'Port Config',
  'integrations_table.connector_type_text': 'Connector',
  'integrations_table.cloud_connector_type_text': 'Cloud Connector',
  'integrations_table.dahua_dolynk_type_text': 'Dahua Dolynk',
  'integration_details.title': 'Integration details',
  'integration.select_title': 'Select an integration',
  'integration.select_description':
    'Please select the type of integration you want to create',
  'create_integration_form.title': 'Create integration',
  'create_integration_form.description': 'Specify the configuration',
  'update_integration_form.title': 'Edit integration',
  'update_integration_form.description': 'Modify the configuration',
  'integration_labels.description': 'Description',
  'integration_labels.host': 'Server',
  'integration_labels.port': 'Port',
  'integration_labels.connectionStatus': 'Connection status',
  'integration_labels.secret': 'Secret key',
  'integration_labels.email': 'Email',
  'integration_labels.region': 'Region',
  'integration_labels.password': 'Password',
  'integration_labels.version': 'Version',
  'integration_labels.isConnected': 'Connected',
  'integration_labels.lastHeartbeatAt': 'Last heartbeat',
  'integration_labels.lastConnection': 'Last connection',
  'integration_labels.workspaceId': 'Workspace ID',
  'integration_labels.botId': 'Bot ID',
  'integration_labels.botToken': 'Bot token',
  'integration_labels.botUsername': 'Bot username',
  'integration_labels.user': 'Username',
  'integration_labels.pass': 'Password',
  'integration_labels.fromName': 'Sender name',
  'integration_labels.fromEmail': 'Sender address',
  'integration_labels.replyEmail': 'Reply-To address',
  'integrations_form.email_field': 'Email',
  'integrations_form.password_field': 'Password',
  'integrations_form.region_field_label': 'Region',
  'integrations.details_label_menu': 'View details',
  'integrations.list_devices_label_menu': 'List Devices',
  'integrations.manage_extensions_label_menu': 'Manage Extensions',
  'integrations.already_exists_tooltip':
    'This workspace already has one of these. Only one is allowed.',
  'integrations_table.jssip_type_text': 'JSSIP VoIP',
  'jssip_form.server_field': 'SIP Server',
  'jssip_form.port_field': 'Port',
  'jssip_form.prefix_field': 'Extension Prefix',
  'jssip_form.extension_field': 'Extension',
  'jssip_form.password_field': 'Password',
  'jssip_form.user_field': 'Select User',
  'jssip_form.users_field': 'Select Users',
  'jssip_form.openrouter_api_key_field': 'OpenRouter API Key',
  'jssip_form.openrouter_api_key_label': 'OpenRouter API Key (optional)',
  'jssip_extensions.title': 'JSSIP Extensions',
  'jssip_extensions.extension_column': 'Extension',
  'jssip_extensions.password_column': 'Password',
  'jssip_extensions.user_column': 'User',
  'jssip_extensions.users_column': 'Users',
  'jssip_extensions.create_button': 'Create Extension',
  'jssip_extensions.create_title': 'Create Extension',
  'jssip_extensions.create_submit': 'Create',
  'jssip_extensions.edit_title': 'Edit Extension',
  'jssip_extensions.edit_submit': 'Save',
  'jssip_extensions.delete_confirm':
    'Are you sure you want to delete this extension?',
  'jssip_extensions.create_success': 'Extension created successfully',
  'jssip_extensions.update_success': 'Extension updated successfully',
  'jssip_extensions.delete_success': 'Extension deleted successfully',
  'jssip_extensions.extension_already_exists':
    'This extension number already exists in this integration',
  'jssip_extensions.error': 'An error occurred',
  'dolynk_devices.title': 'Dahua DoLynk Devices',
  'dolynk_devices.device_id': 'Device ID',
  'dolynk_devices.name': 'Name',
  'dolynk_devices.status': 'Status',
  'dolynk_devices.activation_status': 'Activation Status',
  'dolynk_devices.bind_time': 'Bind Time',
  'dolynk_devices.account': 'Account',
  'dolynk_devices.activate': 'Activate',
  'dolynk_devices.deactivate': 'Deactivate',
  'dolynk_devices.activation_success': 'Device {{status}} successfully',
  'dolynk_devices.activation_error':
    'Failed to change device activation status',
  'integrations_form.access_key_field': 'Access key',
  'integrations_form.secret_key_field': 'Secret key',
  'connector.create_success': 'Integration created successfully',
  'connector.create_error': 'Error creating integration',
  'connector.update_success': 'Integration updated successfully',
  'connector.update_error': 'Error updating integration',
  'connector.delete.success': 'Integration deleted successfully',
  'connector.delete.error': 'Error deleting integration',
  'connector.download.menu_label': 'Connector setup',
  'connector.download.dialog_title': 'Connector setup',
  'connector.download.step1_title': 'Step 1 — Connector package',
  'connector.download.step1_description':
    'Treinco support provides the package treinco-connector-<version>.zip, containing connector.exe and a config/config.ini file.',
  'connector.download.step2_title': 'Step 2 — Configuration file',
  'connector.download.step2_description':
    'These values are specific to this connector. You can copy them to the clipboard or download a ready-to-use config.ini file.',
  'connector.download.copy_tooltip': 'Copy to clipboard',
  'connector.download.config_copied': 'Configuration copied to clipboard',
  'connector.download.config_copy_error': 'Failed to copy to clipboard',
  'connector.download.download_config_button': 'Download config.ini',
  'connector.download.step3_title': 'Step 3 — Installation',
  'connector.download.step3_extract':
    'Extract the zip you received from Treinco support to a folder (e.g. C:\\Treinco\\).',
  'connector.download.step3_replace_config':
    'Replace the config/config.ini file with the one you downloaded (or paste the copied content).',
  'connector.download.step3_run':
    'Open a terminal in the folder and run connector.exe.',
  'connector.download.close': 'Close',
  'connector.update.no_connector': 'No connector found',
  'connector.version.unknown': 'Unknown',
  // Cloud Connector
  'cloud_connector.description':
    'A cloud connector is a Treinco-managed connector deployed in the cloud with a dedicated static IP. Devices can connect directly to this IP address.',
  'cloud_connector.size_label': 'Connector Size',
  'cloud_connector.pricing_note':
    'Monthly pricing includes Droplet and Reserved IP costs.',
  'cloud_connector.connection_info': 'Connection Information',
  'cloud_connector.provisioning_message': 'Provisioning cloud connector...',
  'cloud_connector.configuring_message': 'Configuring cloud connector...',
  'cloud_connector.static_ip_label': 'Static IP Address',
  'cloud_connector.copy_ip': 'Copy IP address',
  'cloud_connector.copied': '{{label}} copied to clipboard',
  'cloud_connector.ip_instructions':
    'Configure your devices to connect to this IP address on the appropriate receiver ports.',
  'cloud_connector.failed_message': 'Cloud connector provisioning failed.',
  'cloud_connector.retry_button': 'Retry',
  'cloud_connector.update_button': 'Update Connector',
  'cloud_connector.update_error': 'Failed to update cloud connector',
  'cloud_connector.restart_button': 'Restart Connector',
  'cloud_connector.restart_error': 'Failed to restart cloud connector',
  'cloud_connector.retry_success':
    'Cloud connector provisioning retry initiated',
  'cloud_connector.retry_error': 'Failed to retry provisioning',
  'cloud_connector.not_available': 'Not yet available',
  'cloud_connector.busy':
    'Another operation is running on this cloud connector. Wait for its result.',
  'cloud_connector.operation_no_result':
    'The result did not arrive. Reopen the details in a few minutes to see how it ended.',
  'cloud_connector.restart_started': 'Restart started',
  'cloud_connector.restart_outcome_success': 'Connector restarted',
  'cloud_connector.restart_outcome_failed':
    'Could not restart the connector: {{reason}}',
  'cloud_connector.restart_outcome_unknown':
    'Unknown whether the connector restarted: {{reason}}',
  'cloud_connector.update_started':
    'Update started. This can take a few minutes.',
  'cloud_connector.update_outcome_success': 'Connector updated',
  'cloud_connector.update_outcome_failed':
    'Could not update the connector: {{reason}}',
  'cloud_connector.update_outcome_unknown':
    'Unknown whether the update finished: {{reason}}',
  'cloud_connector.pending_message': 'Preparing provisioning...',
  'cloud_connector.stale_message':
    'Provisioning has taken too long to finish. You can retry it.',
  'cloud_connector.status_ready': 'Ready: the connector is connected.',
  'cloud_connector.status_installing':
    'Installing the connector on the droplet: it will show as connected in a few minutes.',
  'cloud_connector.status_offline': 'The connector is not connected.',
  'cloud_connector.extras_title': 'Extras',
  'cloud_connector.extras_description':
    'Optional services that run next to the connector on the droplet. Switching them on or off never restarts the connector.',
  'cloud_connector.extras_legacy':
    'This cloud connector was created before the extras became optional, and runs OSM and Traccar. Save once so Treinco manages them: the connector is not restarted.',
  'cloud_connector.extra_osm': 'OSM (EBS GPRS server)',
  'cloud_connector.extra_osm_ports':
    'EBS panels connect to the static IP: LX 6876, AT 6877, CPX 6878, AG 6879.',
  'cloud_connector.extra_osm_receiver_missing':
    'OSM sends its events to the connector on port 7000, and this connector has no such receiver: without it nothing arrives. Create a receiver with type EBS, connection tcp_server and port 7000; give it the workspace prefix with an empty line and press Start.',
  'cloud_connector.extra_traccar': 'Traccar (GPS trackers)',
  'cloud_connector.extra_traccar_ports':
    'Trackers connect to the static IP: gps103 5001, tk103 5002, teltonika 5027, osmand 5055.',
  'cloud_connector.extra_traccar_receiver_missing':
    'Traccar sends its positions to the connector on port 1598, and this connector has no such receiver: without it nothing arrives. Create a receiver with type Traccar, connection http_server and port 1598; leave the Traccar URL, user and password empty, give it the workspace prefix with an empty line and press Start.',
  'cloud_connector.extras_save': 'Save extras',
  'cloud_connector.extras_applying_button': 'Applying...',
  'cloud_connector.extras_applying':
    'Applying the extras on the droplet. This can take a few minutes.',
  'cloud_connector.extras_success': 'Extras applied',
  'cloud_connector.extras_unknown':
    'The outcome of the extras is unknown: {{reason}}. Save again to be sure.',
  'cloud_connector.extras_partial': 'The extras were saved, but: {{reason}}',
  'cloud_connector.extras_failed': 'Could not apply the extras: {{reason}}',
  'cloud_connector.extras_error': 'Failed to save the extras',
  'integration_labels.provisioningStatus': 'Status',
  'integration_labels.reservedIp': 'Static IP',
  'integration_labels.dropletSize': 'Size',
  'integration_labels.statusMessage': 'Details',
  'integrations_table.hik_partner_pro_type_text': 'Hikvision Partner Pro',
  'integrations_form.workspace_prefix_field': 'Integration prefix',

  // Settings general
  'workspace.settings.general.form.name': 'Workspace name',
  'workspace.settings.general.form.workspaceUrl': 'Workspace URL',
  'settings.general.button_edit': 'Save changes',
  'validation.workspace_name_required': 'Workspace name is required',
  'validation.workspace_name_min_length':
    'Workspace name must have at least 3 characters',
  'validation.workspace_name_max_length':
    'Workspace name must have 50 characters as max',
  'workspaces.create_workspace_modal.step1.name.input_label_text':
    'Workspace name',
  'workspace.change_avatar_modal.title': 'Change avatar',
  'workspace.remove.avatar.title': 'Remove avatar',
  'workspace.remove.avatar.description':
    'Are you sure you want to remove the avatar?',
  'workspace.settings.general.form.addressTitle': 'Address',
  'workspace.settings.general.form.billingTitle': 'Billing',
  'workspace.settings.general.form.currency': 'Default Currency',
  'validation.currency_format': 'Currency must be a 3-letter ISO code',
  'workspace.view_avatar_modal.title': 'Workspace avatar',
  'workspace.view_avatar_modal.label': 'View',
  // Settings users
  'settings.users_table.name_field_text': 'Role',
  'settings.users_table.type_field_text': 'Type',
  'settings.users_table.invitation_type_text': 'Invitation',
  'settings.users_table.last_activity_field_text': 'Last conection',
  'settings.users_table.action_field_text': 'Actions',
  'settings.users_table.user_roles_field_text': 'Users',
  'inviteUser.dialog.title': 'Invite to workspace',
  'inviteUser.dialog.subtitle':
    'Send an invitation to be part of this workspace, if the email is not yet registered, you will be invited first to create an account',
  'WorkspaceInvitation.invitation.accepted':
    'Workspace invitation accepted successfully',
  'WorkspaceInvitation.invitation.invalid': 'The invitation is invalid',
  'InviteUserToWorkspace.invite': 'Invite user to workspace',
  'InviteUserToWorkspace.form.email': 'email',
  'user_edit_form.title_text': "Edit user's rol",
  'user_edit_form.subtitle_text': 'Here you can change the role of a user',
  'user_edit_form.role': 'Select user role',
  'user_edit_form.button_submit_label': 'Edit user',
  'user_edit_form.success_message': 'User role updated successfully',

  // Settings roles
  'settings.roles_table.name_field_text': 'Name',
  'settings.roles_table.actions_field_text': 'Actions',

  'roles_form.create': 'Create role',
  'roles_form.update': 'Update role',
  'roles_form.name_placeholder_text': 'Role name',
  'roles_form.create_submit_text': 'Create',
  'roles_form.update_submit_text': 'Update',
  'roles_form.update_role_success_message': 'Role updated successfully',
  'roles_form.create_role_success_message': 'Role created successfully',
  'roles_form.create_role_error_message': 'Error while creating role',
  'role_form.permissions_label': 'Select the permissions by resource',
  'role_form.select_all_label': 'Select all',
  'role_form.permission_not_assignable': 'You do not have this permission',

  // Settings events
  'settings.events_table.description_field_text': 'Description',
  'settings.events_table.type_field_text': 'Type',
  'settings.events_table.code_field_text': 'Code',
  'settings.events_table.event_group_field_text': 'Event group',
  'settings.events_table.protocol_field_text': 'Protocol',
  'settings.events_table.actions_field_text': 'Actions',
  'settings.events_table.monitorable_field_text': 'Monitorable',
  'settings.events_table.monitorable': 'Monitorable event',
  'settings.events_table.not_monitorable': 'Not monitorable event',

  'createEvent.dialog.title': 'Create event',
  'createEvent.dialog.subtitle':
    'Here you can create an event to be used in your workspace',
  'createEvent.form.technicalDescription': 'Description',
  'createEvent.form.type': 'Type',
  'createEvent.form.code': 'Code',
  'event.form.type_zone_option': 'Zone',
  'event.form.type_user_option': 'User',
  'event.form.type_none_option': 'None',
  'create_event.form.protocol': 'Select a protocol',
  'create_event.event_group.select': 'Select an event group',
  'createEvent.form.priority': 'Priority',
  'createEvent.form.priority_helper':
    '1 = Critical (life emergencies), 10 = Minimal (no security impact)',
  'events.form.is_monitoring_input_label': '¿Is a monitoring event?',
  'createEvent.submit': 'Create event',
  'editEvent.submit': 'Edit event',
  'editEvent.dialog.title': 'Edit event',
  'editEvent.dialog.subtitle':
    'Here you can edit an event to be used in your workspace',
  'createEvent.form.color.not_selected': 'No color',
  'createEvent.form.color_select_label': 'Background color',
  'CreateEvent.success': 'Event created successfully',
  'updateEvent.success': 'Event updated successfully',
  'updateEvent.general.error': 'Error updating event',
  'eventItem.delete.title.confirmation': 'Delete Event',
  'eventItem.delete.confirmation':
    'Are you sure you want to delete this event?',
  'eventItem.general.error': 'Error generating event',
  'updateEvent.general.error': 'Error updating event',
  // Settings brands
  'settings.brands_table.name_field_text': 'Brand',
  'settings.brands_table.website_field_text': 'Website',
  'settings.brands_table.actions_field_text': 'Actions',
  'CreateBrand.title': 'Create brand',
  'CreateBrand.form.name': 'Name',
  'CreateBrand.form.website': 'Website',
  'CreateBrand.button.submit': 'Create',
  'CreateBrand.success': 'Brand created successfully',
  'CreateBrand.general.error': 'Error creating brand',
  'brandItem.delete.title.confirmation': 'Delete Brand',
  'brandItem.delete.confirmation':
    'Are you sure you want to delete this brand?',
  'brandItem.general.error': 'Error deleting brand',

  // Settings models
  'settings.models_table.name_field_text': 'Model',
  'settings.models_table.actions_field_text': 'Actions',
  'settings.models_table.type_field_text': 'Type',
  'settings.models_table.brand_field_text': 'Brand',
  'CreateModel.title': 'Create model',
  'CreateModel.form.name': 'Name',
  'CreateModel.brand.select': 'Select a brand',
  'CreateModel.form.type': 'Type',
  'CreateModel.button.submit': 'Create',
  'CreateModel.success': 'Model created successfully',
  'CreateModel.general.error': 'Error creating model',
  'settings.models_table.round_type_text': 'Tour',
  'settings.models_table.gps_type_text': 'GPS',
  'settings.models_table.alarm_type_text': 'Alarm',
  'settings.models_table.treinco_app_type_text': 'Treinco App',
  'settings.models_table.cctv_type_text': 'CCTV',
  'model.type.round': 'Rounds',
  'model.type.gps': 'GPS',
  'model.type.alarm': 'Alarm',
  'model.type.cctv': 'CCTV',

  // Settings resolutions
  'settings.resolutions_table.text_field_text': 'Resolution',
  'settings.resolutions_table.actions_field_text': 'Actions',
  'CreateResolution.title': 'Create resolution',
  'CreateResolution.form.text': 'Text',
  'CreateResolution.button.submit': 'Create',
  'CreateResolution.success': 'Resolution created successfully',
  'updateResolution.success': 'Resolution updated successfully',
  'CreateResolution.general.error': 'Error creating resolution',
  'resolutionItem.general.error': 'Error with resolution',

  // Settings event groups
  'settings.event_groups_table.name_field_text': 'Name',
  'settings.event_groups_table.device_type_field_text': "Device's Type",
  'settings.event_groups_table.actions_field_text': 'Actions',
  'CreateEventGroup.title': 'Create events group',
  'CreateEventGroup.form.name': 'Name',
  'CreateEventGroup.form.deviceTypes': "Device's Type",
  'CreateEventGroup.button.submit': 'Create',
  'CreateEventGroup.success': 'Event group created successfully',
  'CreateEventGroup.general.error': 'Error creating event group',
  'eventGroupItem.general.error': 'Error with event group',
  'eventGroupTable.edit.eventGroup': 'Edit',

  // Settings emergency contact
  'settings.emergency_contacts_table.button_create': 'Create emergency contact',
  'settings.emergency_contact_table.name_field_text': 'Emergency contact',
  'settings.emergency_contact_table.phone_numbers_field_text':
    'Telephone Numbers',
  'settings.emergency_contact_table.actions_field_text': 'Actions',
  'CreateEmergencyContact.title': 'Create emergency contact',
  'EditEmergencyContact.title': 'Update emergency contact',
  'createEmergencyContact.form.name': 'Name',
  'createEmergencyContact.form.note': 'Note',
  'createEmergencyContact.form.contactIdentifier': 'Contact identifier',
  'createEmergencyContact.form.email': 'Email',
  'PhoneNumberForm.form.phoneNumbers': 'Phone numbers',
  'CreateEmergencyContact.button.submit': 'Create emergency contact',
  'EditEmergencyContact.button.submit': 'Update emergency contact',
  'emergencyContact.create.success': 'Emergency contact created successfully',
  'emergencyContact.update.success': 'Emergency contact updated successfully',
  'CreateEmergencyContact.general.error': 'Error creating emergency contact',
  'form.phoneNumber': 'Phone number',
  'value.Add': 'Add ',
  'value.Number': 'Number ',
  'value.Code': 'Code ',
  'emergencyContact.button_import_contacts': 'Import emergency contacts',
  'emergencyContact.button_add': 'Add emergency contact',
  'import.emergency.contact.title': 'Title',
  'device.emergency.contact.button.submit': 'Import emergency contact',
  'emergency.contact.list.select.title': 'Select emergency contact',
  'emergency.contact.button.submit': 'Add emergency contact',
  'add.device.emergency.contact.title': 'Add emergency contact',
  'deviceEmergencyContact.select': 'Emergency contact name',
  'device.emergency.contact.button.submit': 'Add emergency contact',
  'CreateEmergencyContact.advancedSettings': 'Advanced settings',
  'createEmergencyContact.form.confirmation_code': 'Confirmation code',
  'createEmergencyContact.form.duress_code': 'Duress code',
  'createEmergencyContact.form.cra_code': 'CRA code',

  // Settings emergency contact list
  'settings.emergency_contact_list_table.button_create':
    'Create emergency contact list',
  'settings.emergency_contact_list_table.name_field_text':
    'Emergency contact list',
  'settings.emergency_contact_list_table.actions_field_text': 'Actions',
  'CreateEmergencyContactList.title': 'Create emergency contact list',
  'createEmergencyContactList.form.name': 'Name',
  'CreateEmergencyContactList.button.submit': 'Create list',
  'CreateEmergencyContactList.success':
    'Emergency contact list created successfully',
  'EditEmergencyContactList.title': 'Edit emergency contact list',
  'EditEmergencyContactList.button.submit': 'Update list',

  // Settings notification groups
  'notification_group_form.description_field': 'Description',
  'notification_group_form.add_events_or_groups_label':
    'Add events or event groups',
  'create_notification_group_form.error_message':
    'Error while creating notification group',
  'edit_notification_group_form.error_message':
    'Error while updating notification group',
  'create_notification_group_form.submit_text': 'Create notification group',
  'edit_notification_group_form.submit_text': 'Update notification group',
  'notification_group_data_search.no_options': 'No options',
  'notification_group_form.selected_item_name_column': 'Description',
  'notification_group_form.type_event': 'Event',
  'notification_group_form.type_eventGroup': 'Event group',
  'notification_group_form.type_allProtocolEvents': 'Protocol',
  'notification_group_data_search.all_protocol_events':
    'All events of {{protocol}}',
  'notification_group_form.selected_item_actions_column': 'Action',
  'notification_group_form.remove_item_aria_label': 'Remove',
  'notification_group_data_search.label': 'Search event or event group',
  'notification_group.delete.success':
    'Notification group deleted successfully',
  'notification_group.delete.error': 'Error while deleting notification group',
  'notificationGroup_form.title_text': 'Notification group',
  'notificationGroup_form.subtitle_text':
    'Here you can configure your notification group, this will allow you to group events and event groups to send notifications',
  'notification_group_form.create_success':
    'Notification group created successfully',
  'notification_group_form.update_success':
    'Notification group updated successfully',
  'notification_group_form.create_error':
    'Error while creating notification group',
  'notification_group_form.update_error':
    'Error while updating notification group',

  // Attachments
  'attachments.title_text': 'Attachments',
  'attachments.button_add': 'Add attachment',
  'attachments.table.name_field_text': 'Name',
  'attachments.table.actions_field_text': 'Actions',
  'attachments.table.created_at_field_text': 'Created at',
  'attachments.table.created_by_field_text': 'Created by',
  'attachments.table.size_field_text': 'Size',
  'attachments.table.type_field_text': 'Type',
  'attachments.table.download_action_text': 'Download',
  'attachments.table.delete_action_text': 'Delete',
  'attachments.delete_dialog_title': 'Delete attachment',
  'attachments.delete_dialog_description':
    'Are you sure you want to delete this attachment?',
  'attachments.upload_dialog_title': 'Upload attachment',
  'attachments.upload_dialog_description':
    'Here you can upload an attachment to this device',
  'attachments.upload_dialog_button_text': 'Upload',
  'attachments.upload_dialog_file_input_label': 'Select file',
  'attachments.upload_dialog_file_input_helper_text':
    'Max file size 10MB, allowed file types: jpg, jpeg, png, pdf, doc, docx, xls, xlsx, csv, txt, zip',

  //Dashboard (greetings)
  'page.dashboard.title': 'Dashboard',
  'page.reports.title': 'Reports',
  'page.reports.subtitle': 'Select a report to view',

  // Reports
  'reports.devices_by_event.title': 'Devices by Event',
  'reports.devices_by_event.description':
    'List of devices that reported a specific event or event group in a period of time',
  'reports.devices_by_event.table.events': 'Events',
  'reports.devices_by_event.table.events_button': '{{count}} events',
  'reports.devices_by_event.table.events_button_one': '{{count}} event',
  'reports.devices_by_event.table.events_button_other': '{{count}} events',
  'reports.devices_by_event.modal.title': 'Device events',
  'reports.devices_by_event.modal.total_one': '{{count}} event in this range',
  'reports.devices_by_event.modal.total_other':
    '{{count}} events in this range',
  'reports.devices_by_event.modal.close': 'Close',
  'reports.devices_by_activity.title': 'Devices by Activity',
  'reports.devices_by_activity.description':
    'List of devices ordered by number of events or situations reported in a period of time',
  'reports.devices_by_activity.table.events': 'Events',
  'reports.devices_by_activity.table.events_button': '{{count}} events',
  'reports.devices_by_activity.table.events_button_one': '{{count}} event',
  'reports.devices_by_activity.table.events_button_other': '{{count}} events',
  'reports.devices_by_activity.modal.title': 'Device events',
  'reports.select_date': 'Select date',
  'reports.start_date': 'Start date',
  'reports.end_date': 'End date',
  'reports.date_range_error': 'End date must be after start date',
  'reports.date_required': 'This field is required',
  'reports.fetch': 'Fetch',
  'reports.view_table': 'Table',
  'reports.view_chart': 'Chart',
  'reports.no_results': 'No results',
  'reports.no_rounds_for_date': 'No rounds found for the selected date.',
  'reports.round_resume': 'Round resume',
  'reports.events_summary': 'Events summary',
  'reports.rounds_completed': 'Rounds completed',
  'reports.rounds_incomplete': 'Rounds incomplete',
  'reports.start': 'Start',
  'reports.end': 'End',
  'reports.incomplete': 'Incomplete',
  'reports.total_events': 'Total events',
  'reports.event': 'Event (Description)',
  'reports.total': 'Total',
  'reports.percent': '%',
  'reports.rounds_initiated': 'Initiated rounds',
  'reports.export': 'Export',
  'reports.export_csv': 'CSV',
  'reports.export_xls': 'XLS',
  'reports.export_pdf': 'PDF',
  'reports.rounds_report.description':
    'View events recorded during patrol and guard tour rounds',
  'reports.rounds_report.col_round': 'Round',
  'reports.devices_by_activity.modal.total_one':
    '{{count}} event in this range',
  'reports.devices_by_activity.modal.total_other':
    '{{count}} events in this range',
  'reports.devices_by_activity.modal.total': 'Total',
  'reports.devices_by_activity.modal.close': 'Close',
  'reports.devices_by_activity.no_search_prompt':
    'Select date range and click Search to view results',
  'reports.devices_by_last_event.title': 'Devices by Last Event',
  'reports.devices_by_last_event.description':
    'List of devices ordered by last event received (ascending or descending)',
  'reports.devices_by_last_event.table.last_event_date': 'Last Event Date',
  'reports.devices_by_last_event.table.event': 'Event',
  'reports.devices_by_last_event.table.zone': 'Zone',
  'reports.devices_by_last_event.table.user': 'User',
  'reports.devices_by_last_event.table.partition': 'Partition',
  'reports.devices_by_last_event.table.no_event': 'No events',
  'reports.devices_by_last_event.load_devices': 'Load Devices',
  'reports.devices_by_last_event.no_search_prompt':
    'Click Load Devices to view results',
  'reports.devices_without_image.title': 'Devices without Image',
  'reports.devices_without_image.description':
    'List of devices that do not have an image assigned',
  'reports.devices_without_image.load_devices': 'Load Devices',
  'reports.devices_without_image.no_search_prompt':
    'Click Load Devices to view devices without images',
  'reports.devices_without_image.found_devices':
    '{{count}} devices without image',
  'reports.devices_without_image.found_devices_one':
    '{{count}} device without image',
  'reports.devices_without_image.found_devices_other':
    '{{count}} devices without image',
  'reports.devices_by_last_position.title': 'Devices by Last Position',
  'reports.devices_by_last_position.description':
    'List of devices ordered by last position received (ascending or descending)',
  'reports.devices_by_last_position.table.last_position_date':
    'Last Position Date',
  'reports.devices_by_last_position.table.latitude': 'Latitude',
  'reports.devices_by_last_position.table.longitude': 'Longitude',
  'reports.devices_by_last_position.table.speed': 'Speed',
  'reports.devices_by_last_position.table.received_at': 'Received At',
  'reports.devices_by_last_position.table.no_position': 'No position',
  'reports.devices_by_last_position.load_devices': 'Load Devices',
  'reports.devices_by_last_position.no_search_prompt':
    'Click Load Devices to view results',
  'reports.devices_without_place.title': 'Devices without Place',
  'reports.devices_without_place.description':
    'List of devices that do not have a place assigned',
  'reports.devices_without_place.load_devices': 'Load Devices',
  'reports.devices_without_place.no_search_prompt':
    'Click Load Devices to view devices without places',
  'reports.devices_without_place.found_devices':
    '{{count}} devices without place',
  'reports.devices_without_place.found_devices_one':
    '{{count}} device without place',
  'reports.devices_without_place.found_devices_other':
    '{{count}} devices without place',
  'reports.filters.event_group': 'Event Group',
  'reports.filters.date_from': 'Date From',
  'reports.filters.date_to': 'Date To',
  'reports.filters.all': 'All',

  'dashboard.greetings.morning': 'Good morning! 👋',
  'dashboard.greetings.afternoon': 'Good Afternoon! ☕',
  'dashboard.greetings.night': 'Good evening! 🌃',
  'dashboard.graph_message.new_devices_from_last_month':
    'Devices created in the last 31 days',
  'dashboard.graph_legend.devices_created': 'Devices created',
  'dashboard.devices_chart.labels.daily': 'Daily total (last 31 days)',
  'dashboard.devices_chart.labels.monthly': 'Monthly total (last 12 months)',
  'dashboard.devices_chart.labels.yearly': 'Yearly total (last 5 years)',
  'dashboard.devices_chart.legend.total_devices': 'Devices in workspace',
  'dashboard.devices_chart.toggle.daily': 'Daily',
  'dashboard.devices_chart.toggle.monthly': 'Monthly',
  'dashboard.devices_chart.toggle.yearly': 'Yearly',
  'dashboard.monitoring_heatmap.title': 'Situations workload',
  'dashboard.monitoring_heatmap.range': '{{start}} – {{end}}',
  'dashboard.monitoring_heatmap.previous_week': 'Previous week',
  'dashboard.monitoring_heatmap.next_week': 'Next week',
  'dashboard.monitoring_heatmap.no_data':
    'No situations recorded for this week yet',
  'dashboard.monitoring_heatmap.tooltip_empty':
    'No situations at {{hour}} on {{day}}',
  'dashboard.monitoring_heatmap.tooltip_one':
    '{{count}} situation at {{hour}} on {{day}}',
  'dashboard.monitoring_heatmap.tooltip_other':
    '{{count}} situations at {{hour}} on {{day}}',
  'dashboard.monitoring_heatmap.error': 'Unable to load the situations heatmap',
  // user profile
  'account.popover.home': 'Home',
  'account.popover.profile': 'Profile',
  'account.popover.settings': 'Configuration',
  'account.popover.logout': 'Logout',
  'account_popover.workspace_user': 'Switch to workspace user',
  'account_popover.customer_user': 'Switch to customer user',
  'account_popover.admin_mode': 'Admin Mode',

  // Admin Mode
  'admin.sidebar.title': 'Treinco Admin',
  'admin.sidebar.subtitle': 'System Management',
  'admin.sidebar.management': 'Management',
  'admin.sidebar.workspaces': 'Workspaces',
  'admin.sidebar.users': 'Users',
  'admin.sidebar.integrations': 'Integrations',
  'admin.integrations.title': 'Integrations',
  'admin.integrations.subtitle': 'Manage all integrations across workspaces',
  'admin.integrations.workspace_column': 'Workspace',
  'admin.integrations.select_workspace': 'Select Workspace',
  'admin.integrations.search_workspace': 'Search workspace...',
  'admin.integrations.no_workspaces_found': 'No workspaces found',
  'admin.workspaces.title': 'Workspaces',
  'admin.workspaces.subtitle': 'View and manage all workspaces in the system',
  'admin.workspaces.columns.name': 'Name',
  'admin.workspaces.columns.mode': 'Mode',
  'admin.workspaces.columns.created_at': 'Created At',
  'admin.workspaces.open_dashboard': 'Open workspace dashboard',
  'admin.users.title': 'Users',
  'admin.users.subtitle': 'View all users in the system',
  'admin.users.columns.user': 'User',
  'admin.users.columns.name': 'Name',
  'admin.users.columns.email': 'Email',
  'admin.users.columns.roles': 'Roles',
  'admin.users.columns.role': 'Role',
  'admin.users.columns.scope': 'Scope',
  'admin.users.columns.resource': 'Resource',
  'admin.users.columns.created_at': 'Created At',
  'admin.users.columns.actions': 'Actions',

  // Admin Workspace Profile
  'admin.workspace_profile.tabs.general': 'General',
  'admin.workspace_profile.tabs.monitoring': 'Monitoring',
  'admin.workspace_profile.cover.mode': 'Mode',
  'admin.workspace_profile.cover.created_at': 'Created',
  'admin.workspace_profile.cover.id': 'ID',
  'admin.workspace_profile.not_found.title': 'Workspace not found',
  'admin.workspace_profile.not_found.description':
    'The workspace you are looking for does not exist or you do not have access.',
  // Admin Monitoring Tab
  'admin.monitoring.stats.online_operators': 'Online operators',
  'admin.monitoring.stats.free_situations': 'Free situations in queue',
  'admin.monitoring.columns.operator': 'Operator',
  'admin.monitoring.columns.status': 'Status',
  'admin.monitoring.columns.assigned_situations': 'Assigned situations',
  'admin.monitoring.columns.last_activity': 'Last activity',
  'admin.monitoring.columns.session': 'Session',
  'admin.monitoring.status.free': 'Free',
  'admin.monitoring.status.busy': 'Busy',
  'admin.monitoring.status.paused': 'Paused',
  'admin.monitoring.status.unknown': 'Unknown',
  'admin.monitoring.empty.title': 'No operators connected',
  'admin.monitoring.empty.description':
    'There are no active operators in this workspace.',
  'admin.monitoring.error.title': 'Error loading operators',
  'admin.workspace_profile.not_found.description':
    'The workspace you are looking for does not exist or you do not have access.',
  'admin.workspace_profile.monitoring.toggle_label': 'Monitoring enabled',
  'admin.workspace_profile.monitoring.update_error':
    'Failed to update monitoring status',
  'admin.workspace_profile.monitoring.enable_success':
    'Monitoring successfully enabled',
  'admin.workspace_profile.monitoring.disable.title': 'Disable monitoring',
  'admin.workspace_profile.monitoring.disable.description':
    'New events from this workspace will no longer be delivered to operators. Active situations will continue their normal flow.',
  'admin.users.actions.add_role': 'Add Role',
  'admin.users.actions.remove_role': 'Remove Role',
  'admin.users.scope.system': 'System',
  'admin.users.scope.account': 'Account',
  'admin.users.scope.workspace': 'Workspace',
  'admin.users.scope.customer': 'Customer',
  'admin.users.scope.device': 'Device',
  'admin.users.scope.user': 'User',
  'admin.users.messages.role_added': 'Role added successfully',
  'admin.users.messages.role_removed': 'Role removed successfully',
  'admin.users.messages.error': 'An error occurred',
  'admin.users.messages.error_loading_roles': 'Error loading roles',
  'admin.users.add_role_modal.title': 'Add role to {{name}}',
  'admin.users.add_role_modal.steps.scope': 'Scope',
  'admin.users.add_role_modal.steps.resource': 'Resource',
  'admin.users.add_role_modal.steps.role': 'Role',
  'admin.users.add_role_modal.scope_description':
    'Select the scope level for this role',
  'admin.users.add_role_modal.scope_hints.system': 'Full system-wide access',
  'admin.users.add_role_modal.scope_hints.account':
    'Access to a specific account',
  'admin.users.add_role_modal.scope_hints.workspace':
    'Access to a specific workspace',
  'admin.users.add_role_modal.scope_hints.customer':
    'Access to a specific customer',
  'admin.users.add_role_modal.scope_hints.device':
    'Access to a specific device',
  'admin.users.add_role_modal.scope_hints.user':
    'Access to manage a specific user',
  'admin.users.add_role_modal.select_account': 'Select account',
  'admin.users.add_role_modal.select_workspace': 'Select workspace',
  'admin.users.add_role_modal.select_customer': 'Select customer',
  'admin.users.add_role_modal.select_device': 'Select device',
  'admin.users.add_role_modal.select_user': 'Select user',
  'admin.users.add_role_modal.search_placeholder': 'Type to search...',
  'admin.users.add_role_modal.type_to_search':
    'Type at least 2 characters to search',
  'admin.users.add_role_modal.no_results': 'No results found',
  'admin.users.add_role_modal.select_role': 'Select role',
  'admin.users.add_role_modal.role_description':
    'Assign a role for {{scope}}: {{resource}}',
  'admin.users.add_role_modal.add_role': 'Add Role',
  'page.user.profile': 'User profile',
  'page.user.tabs.general': 'General',
  'page.user.tabs.change_password': 'Change Password',
  'user.profile.tabs.general': 'General',
  'user.profile.tabs.change_password': 'Change password',
  'user.profile.changePassword.form.new.password': 'New password',
  'user.profile.changePassword.form.confirm.password': 'Confirm password',
  'user.profile.changePassword.submit': 'Change password',
  'user_edit_form.button_submit_label': 'Edit user',
  'user_edit_form.role': 'Select user role',
  'user.profile.file_type': 'Allowed *.jpeg, *.jpg, *.png, *.gif',
  'user.profile.file_size': 'max size of',
  'user.profile.file': 'Upload file',
  'user.remove.avatar.title': 'Remove avatar',
  'user.remove.avatar.description':
    'Are you sure you want to remove the avatar?',
  'user.delete.title.confirmation':
    'Are you sure you want to delete this user?',
  'user.avatar.delete.confirmation': 'The deleted data cannot be recovered',
  'user.change_avatar_modal.title': 'Change avatar',
  'user.view_avatar_modal.label': 'View avatar',
  'user.view_avatar_modal.title': 'Avatar',
  // action groups
  'settings.settings_tabs.actions_tab_title': "Action Group's",
  'settings.settings_tabs.items_tab_title': 'Items',
  'settings.settings_tabs.plans_tab_title': 'Plans',
  'settings.settings_tabs.invoice_series_tab_title': 'Invoice Series',
  'settings.settings_tabs.api_keys_tab_title': 'API Key management',
  'api_keys.name': 'Name',
  'api_keys.role': 'Role',
  'api_keys.created_by': 'Created by',
  'api_keys.expires': 'Expires',
  'api_keys.created_at': 'Created',
  'api_keys.actions': 'Actions',
  'api_keys.never': 'Never',
  'api_keys.revoke': 'Revoke',
  'api_keys.create': 'Create API Key',
  'api_keys.expires_at': 'Expiration date (optional)',
  'api_keys.revoke_confirm_title': 'Revoke API Key',
  'api_keys.revoke_confirm_body':
    'This action cannot be undone. The key will stop working immediately.',
  'api_keys.revoked_success': 'API key revoked',
  'api_keys.token_title': 'API Key Created',
  'api_keys.token_warning': 'Copy this token now. It will not be shown again.',
  'api_keys.token_copied': 'Token copied',
  'api_keys.date_future_error': 'Date must be in the future',
  'api_keys.name_required_error': 'Name is required',
  'api_keys.role_required_error': 'Role is required',
  'api_keys.copy': 'Copy',
  'settings.actions_table.name_field_text': "Name's action group",
  'settings.actions_table.actions_field_text': 'Actions',
  'create_action_group_form.submit_text': 'Create action group',
  'edit_action_group_form.submit_text': 'Edit action group',
  'action_group_form.name_field': 'Action group name',
  'action_group_form.success': 'Action group created successfully',
  'action_group_form.error': 'Error while creating action group',
  'action_group_form.update_default.success':
    'Default action group updated successfully',
  'action.delete_success': 'Action deleted successfully',
  'action.delete_error': 'Error while deleting action',
  'import_action_group_form.success': 'Action group imported successfully',
  'import_action_group_form.error': 'Error while importing action group',
  'actionGroup.delete.success': 'Action group deleted successfully',
  'actionGroups.save.order': 'Save order',
  'deviceActionGroup.order.success': 'Order saved successfully',
  'monitoring_device_history.loading_error': 'Error loading device history',
  'edit_members_form.title': 'Edit Member',
  'edit_members_form.subtitle': 'Edit an existing member',
  'action_groups.error': 'Error with action groups',
  // custom event form
  'event_form.create_submit_button': 'Create custom event',
  'event_form.update_submit_button': 'Edit custom event',
  'createDeviceCustomEvent.success': 'Device Custom event created successfully',
  'createDeviceCustomEvent.error': 'Error while creating custom event',
  'updateDeviceCustomEvent.error': 'Error while updating custom event',
  'updateDeviceCustomEvent.success': 'Device custom event updated successfully',

  'create_event.form.eventGroup': 'Event group',

  'item.delete.title.confirmation':
    'Are you sure you want to delete this item?',
  'item.delete.confirmation': 'This action cannot be undone.',
  'itemItem.delete.title.confirmation': 'Delete Item',
  'itemItem.delete.confirmation': 'Are you sure you want to delete this item?',

  // kanban
  'service_orders_page.title_text': 'Service orders',
  'invoices_page.title_text': 'Invoices',

  'invoices.table.identifier': 'Identifier',
  'invoices.table.customer': 'Customer',
  'invoices.table.no_customer': 'No customer',
  'invoices.table.status': 'Status',
  'invoices.table.issue_date': 'Issue date',
  'invoices.table.due_date': 'Due date',
  'invoices.table.currency': 'Currency',
  'invoices.table.total': 'Total',
  'invoices.table.created_at': 'Created at',

  'invoices.detail.page_title': 'Invoice Details',
  'invoices.detail.general_tab': 'General',
  'invoices.detail.items_tab': 'Items',
  'invoices.detail.payments_tab': 'Payments',
  'invoices.detail.notes_tab': 'Notes',
  'invoices.detail.information': 'Information',
  'invoices.detail.identifier': 'Invoice Number',
  'invoices.detail.status': 'Status',
  'invoices.detail.issue_date': 'Issue Date',
  'invoices.detail.due_date': 'Due Date',
  'invoices.detail.total_amount': 'Total Amount',
  'invoices.detail.customer_information': 'Customer Information',
  'invoices.detail.invoice_details': 'Invoice Details',
  'invoices.detail.financial_summary': 'Financial Summary',
  'invoices.detail.subtotal': 'Subtotal',
  'invoices.detail.tax_total': 'Tax',
  'invoices.detail.currency': 'Currency',
  'invoices.detail.notes': 'Notes',
  'invoices.detail.no_notes': 'No notes available',
  'invoices.detail.phone': 'Phone',
  'invoices.detail.created_at': 'Created',
  'invoices.detail.updated_at': 'Updated',
  'invoices.detail.not_found_title': 'Invoice not found',
  'invoices.detail.not_found_description':
    'The invoice you are looking for does not exist or you do not have access to it',
  'invoices.detail.back_button': 'Back to invoices',

  'invoices.items.title': 'Invoice Items',
  'invoices.items.description': 'Description',
  'invoices.items.quantity': 'Quantity',
  'invoices.items.unit_price': 'Unit Price',
  'invoices.items.tax_rate': 'Tax Rate',
  'invoices.items.line_total': 'Line Total',
  'invoices.items.actions': 'Actions',
  'invoices.items.edit_item': 'Edit Item',
  'invoices.items.delete_item': 'Delete Item',
  'invoices.items.create_item': 'Create Item',
  'invoices.items.update_item': 'Update Item',
  'invoices.items.create_item_form': 'Create Invoice Item',
  'invoices.items.update_item_form': 'Update Invoice Item',
  'invoices.items.delete_confirmation_title': 'Delete Item',
  'invoices.items.delete_confirmation_description':
    'Are you sure you want to delete this item? This action cannot be undone.',
  'invoices.items.description_required': 'Description is required',
  'invoices.items.quantity_required': 'Quantity is required',
  'invoices.items.quantity_positive': 'Quantity must be positive',
  'invoices.items.quantity_min': 'Quantity must be at least 0.01',
  'invoices.items.unit_price_required': 'Unit price is required',
  'invoices.items.unit_price_min': 'Unit price must be at least 0',
  'invoices.items.tax_rate_min': 'Tax rate must be at least 0',
  'invoices.items.tax_rate_max': 'Tax rate cannot exceed 100',
  'invoices.items.create_success': 'Item created successfully',
  'invoices.items.create_error': 'Error creating item',
  'invoices.items.update_success': 'Item updated successfully',
  'invoices.items.update_error': 'Error updating item',
  'invoices.items.delete_success': 'Item deleted successfully',
  'invoices.items.delete_error': 'Error deleting item',

  'invoices.payments.title': 'Payment History',
  'invoices.payments.payment_date': 'Payment Date',
  'invoices.payments.amount': 'Amount',
  'invoices.payments.method': 'Payment Method',
  'invoices.payments.reference': 'Reference',
  'invoices.payments.total_paid': 'Total Paid',
  'invoices.payments.balance': 'Balance',
  'invoices.payments.add_payment': 'Add Payment',
  'invoices.payments.actions': 'Actions',
  'invoices.payments.create_payment': 'Create Payment',
  'invoices.payments.edit_payment': 'Edit Payment',
  'invoices.payments.delete_payment': 'Delete Payment',
  'invoices.payments.create_payment_form': 'New Payment',
  'invoices.payments.update_payment_form': 'Edit Payment',
  'invoices.payments.update_payment': 'Update Payment',
  'invoices.payments.delete_confirmation_title': 'Delete Payment',
  'invoices.payments.delete_confirmation_description':
    'Are you sure you want to delete this payment? This action cannot be undone.',
  'invoices.payments.amount_required': 'Amount is required',
  'invoices.payments.amount_positive': 'Amount must be positive',
  'invoices.payments.amount_min': 'Amount must be at least 0.01',
  'invoices.payments.payment_date_required': 'Payment date is required',
  'invoices.payments.create_success': 'Payment created successfully',
  'invoices.payments.create_error': 'Error creating payment',
  'invoices.payments.update_success': 'Payment updated successfully',
  'invoices.payments.update_error': 'Error updating payment',
  'invoices.payments.delete_success': 'Payment deleted successfully',
  'invoices.payments.delete_error': 'Error deleting payment',

  'invoices.notes.placeholder': 'Enter notes here...',
  'invoices.notes.no_notes': 'No notes',
  'invoices.notes.save': 'Save',
  'invoices.notes.cancel': 'Cancel',
  'invoices.notes.updated': 'Notes updated successfully',
  'invoices.notes.error': 'Error updating notes',

  'invoices.create.button': 'Create Invoice',
  'invoices.create.dialog_title': 'Create New Invoice',
  'invoices.create.customer': 'Customer',
  'invoices.create.customer_required': 'Customer is required',
  'invoices.create.identifier': 'Invoice Number',
  'invoices.create.identifier_required': 'Invoice number is required',
  'invoices.create.identifier_max':
    'Invoice number must be less than 255 characters',
  'invoices.create.status': 'Status',
  'invoices.create.status_required': 'Status is required',
  'invoices.create.currency': 'Currency',
  'invoices.create.currency_required': 'Currency is required',
  'invoices.create.currency_format':
    'Currency must be 3 characters (e.g., USD)',
  'invoices.create.issue_date': 'Issue Date',
  'invoices.create.due_date': 'Due Date',
  'invoices.create.due_date_after_issue': 'Due date must be after issue date',
  'invoices.create.notes': 'Notes',
  'invoices.create.notes_max': 'Notes must be less than 5000 characters',
  'invoices.create.submit': 'Create Invoice',
  'invoices.create.success': 'Invoice created successfully',
  'invoices.create.error': 'Failed to create invoice',

  'invoices.update.submit': 'Update Invoice',
  'invoices.update.success': 'Invoice updated successfully',
  'invoices.update.error': 'Failed to update invoice',

  'invoices.delete.title': 'Delete Invoice',
  'invoices.delete.confirmation':
    'Are you sure you want to delete this invoice? This action cannot be undone and will also delete all associated items and payments.',
  'invoices.delete.success': 'Invoice deleted successfully',
  'invoices.delete.error': 'Failed to delete invoice',

  'invoices.table.actions': 'Actions',
  'invoices.table.view_invoice': 'View Invoice',
  'invoices.table.edit_invoice': 'Edit Invoice',
  'invoices.table.delete_invoice': 'Delete Invoice',

  'invoices.status.draft': 'Draft',
  'invoices.status.final': 'Final',
  'invoices.status.paid': 'Paid',
  'invoices.status.overdue': 'Overdue',
  'invoices.status.cancelled': 'Cancelled',

  // Invoice Series
  'invoice_series.title': 'Invoice Series',
  'invoice_series.description':
    'Manage invoice series (lotes) for sequential invoice numbering in your workspace.',
  'invoice_series.create_button': 'Create Series',
  'invoice_series.error_loading': 'Error loading invoice series.',
  'invoice_series.table.name': 'Name',
  'invoice_series.table.prefix': 'Prefix',
  'invoice_series.table.current_number': 'Current Number',
  'invoice_series.table.next_number': 'Next Number',
  'invoice_series.table.status': 'Status',
  'invoice_series.table.active': 'Active',
  'invoice_series.table.inactive': 'Inactive',
  'invoice_series.table.created_at': 'Created At',
  'invoice_series.table.actions': 'Actions',
  'invoice_series.form.title_create': 'Create Invoice Series',
  'invoice_series.form.title_edit': 'Edit Invoice Series',
  'invoice_series.form.name': 'Series Name',
  'invoice_series.form.name_required': 'Name is required',
  'invoice_series.form.name_helper':
    'A descriptive name for this series (e.g., "Main Series", "Export Invoices")',
  'invoice_series.form.prefix': 'Prefix',
  'invoice_series.form.prefix_required': 'Prefix is required',
  'invoice_series.form.prefix_helper':
    'Short prefix for invoice numbers (e.g., "INV", "A", "EXP"). Max 10 characters.',
  'invoice_series.form.is_active': 'Active',
  'invoice_series.form.is_active_helper':
    'Only active series can be used for new invoices',
  'invoice_series.form.submit_create': 'Create Series',
  'invoice_series.form.submit_edit': 'Save Changes',
  'invoice_series.create.success': 'Invoice series created successfully',
  'invoice_series.create.error': 'Error creating invoice series',
  'invoice_series.update.success': 'Invoice series updated successfully',
  'invoice_series.update.error': 'Error updating invoice series',
  'invoice_seriesItem.delete.title.confirmation': 'Delete Invoice Series',
  'invoice_seriesItem.delete.confirmation':
    'Are you sure you want to delete this invoice series? This action cannot be undone.',
  'invoice_series.delete.success': 'Invoice series deleted successfully',
  'invoice_series.delete.error': 'Error deleting invoice series',
  'invoice_series.status.active': 'Active',
  'invoice_series.status.inactive': 'Inactive',

  // Billing Errors
  'billingErrors.INVOICE_NOT_EDITABLE_AFTER_FINALIZATION':
    'This invoice has been finalized and cannot be edited. Only notes and payments can be modified.',
  'billingErrors.CANNOT_ADD_ITEMS_TO_FINALIZED_INVOICE':
    'Cannot add items to a finalized invoice. Only draft invoices can be modified.',
  'billingErrors.CANNOT_MODIFY_ITEMS_ON_FINALIZED_INVOICE':
    'Cannot modify items on a finalized invoice. Only draft invoices can be edited.',
  'billingErrors.CANNOT_DELETE_ITEMS_FROM_FINALIZED_INVOICE':
    'Cannot delete items from a finalized invoice. Only draft invoices can be modified.',
  'billingErrors.INVALID_INVOICE_STATUS_TRANSITION':
    'Invalid status change. Please check the allowed status transitions.',
  'billingErrors.ONLY_DRAFT_INVOICES_CAN_BE_FINALIZED':
    'Only draft invoices can be finalized.',
  'billingErrors.CANNOT_FINALIZE_INVOICE_WITHOUT_ITEMS':
    'Cannot finalize an invoice with no items. Please add at least one item.',
  'billingErrors.CANNOT_DELETE_NON_DRAFT_INVOICE':
    'Only draft invoices can be deleted. Finalized invoices must be cancelled instead.',
  'billingErrors.SERVICE_PERIOD_REQUIRED_FOR_SUBSCRIPTION_ITEMS':
    'Service period dates are required for invoice items linked to subscriptions.',
  'billingErrors.INVALID_STATUS_TRANSITION':
    'Invalid status change for this subscription.',
  'billingErrors.CANNOT_CANCEL_FINISHED_SUBSCRIPTION':
    'Cannot cancel a subscription that has already finished.',
  'billingErrors.CANNOT_ACTIVATE_CANCELLED_SUBSCRIPTION':
    'Cannot reactivate a cancelled subscription.',
  'billingErrors.INVOICE_SERIES_NOT_FOUND': 'Invoice series not found.',
  'billingErrors.INVOICE_SERIES_PREFIX_ALREADY_EXISTS':
    'An invoice series with this prefix already exists in this workspace.',
  'billingErrors.INVOICE_SERIES_IN_USE':
    'Cannot delete this invoice series as it is being used by existing invoices.',
  'billingErrors.INVOICE_SERIES_WORKSPACE_MISMATCH':
    'The selected invoice series does not belong to this workspace.',
  'billingErrors.NO_ACTIVE_INVOICE_SERIES_FOUND':
    'No active invoice series found for this workspace. Please create one first.',
  'billingErrors.CANNOT_DELETE_SERIES_IN_USE':
    'Cannot delete this invoice series as it is being used by existing invoices.',
  'billingErrors.CANNOT_MODIFY_CURRENT_NUMBER_DIRECTLY':
    'The current number cannot be modified directly. It is automatically managed by the system.',
  'billingErrors.INVOICE_NOT_FOUND': 'Invoice not found.',
  'billingErrors.INVOICE_ITEM_NOT_FOUND': 'Invoice item not found.',
  'billingErrors.INVOICE_PAYMENT_NOT_FOUND': 'Invoice payment not found.',
  'billingErrors.SUBSCRIPTION_NOT_FOUND': 'Subscription not found.',
  'billingErrors.SUBSCRIPTION_ITEM_NOT_FOUND': 'Subscription item not found.',
  'billingErrors.CANNOT_DELETE_BILLED_SUBSCRIPTION_ITEM':
    'Cannot delete this subscription item because it has already been billed.',
  'billingErrors.CANNOT_DELETE_BILLED_SUBSCRIPTION':
    'Cannot delete this subscription because it has items that have already been billed.',
  'billingErrors.CUSTOMER_NOT_FOUND_IN_WORKSPACE':
    'Customer not found in this workspace.',
  'billingErrors.DEVICE_NOT_FOUND': 'Device not found.',
  'billingErrors.DEVICE_HAS_NO_CUSTOMER':
    'Device does not have an associated customer.',
  'billingErrors.PLAN_NOT_FOUND': 'Plan not found.',
  'billingErrors.ITEM_NOT_FOUND': 'Item not found.',
  'billingErrors.AUTHORIZATION_ERROR':
    'You do not have permission to perform this action.',
  'billingErrors.ITEM_IN_USE_BY_INVOICE':
    'Cannot delete this item as it is being used in one or more invoices.',
  'billingErrors.ITEM_IN_USE_BY_PLAN':
    'Cannot delete this item as it is being used in one or more plans.',
  'billingErrors.ITEM_IN_USE_BY_SUBSCRIPTION':
    'Cannot delete this item as it is being used in one or more subscriptions.',
  'billingErrors.UNKNOWN_ERROR': 'An unknown error occurred.',
  'billingErrors.DUPLICATE_KEY':
    'This value already exists. Please use a different value.',
  'billingErrors.FOREIGN_KEY_CONSTRAINT':
    'Cannot perform this action due to existing related records.',
  'billingErrors.NOT_NULL_CONSTRAINT':
    'Required field is missing. Please fill in all required fields.',
  'billingErrors.GENERIC_ERROR': 'An error occurred. Please try again.',

  'payment_method.label': 'Payment Method',
  'payment_method.add_new': 'Add new',
  'payment_method.create_title': 'Create Payment Method',
  'payment_method.name': 'Method Name',
  'payment_method.created_success': 'Payment method created successfully',
  'payment_method.create_error': 'Error creating payment method',
  'payment_method.search_error': 'Error loading payment methods',

  'kanban.task_completed_text': 'Completed',
  'kanban.task_not_completed_text': 'Not completed',

  'kanban.column_created_success': 'Column created successfully',
  'kanban.column_created_error': 'Error while creating column',
  'kanban.column_name_placeholder': 'Column name',
  'kanban.column_create_helper_text': 'Type the column name',
  'kanban.add_column_text': 'New column',

  'kanban.delete_column_title': 'Delete column',
  'kanban.delete_column_description':
    'Are you sure you want to delete this column?',
  'kanban.more_options.edit': 'Update',
  'kanban.more_options.delete': 'Delete',

  'kanban.column_update_success': 'Column updated',
  'kanban.column_update_error': 'Error while updating the column',
  'kanban.column_delete_success': 'Column deleted',
  'kanban.column_delete_error': 'Error while deleting the column',

  'kanban.task_created_success': 'Task created successfully',
  'kanban.task_created_error': 'Error while creating task',
  'service_order.create': 'Add service order',

  'kanban.contacts_title': 'Users',
  'kanban.contacts_search_placeholder': 'Search...',
  'kanban.contacts_select_button': 'Add',

  'kanban.delete_task_title': 'Delete task',
  'kanban.delete_task_description':
    'Are you sure you want to delete this task?',
  'kanban.task_delete_tooltip': 'Delete',

  'kanban_comment.comment_placeholder': 'Write a comment...',
  'kanban_comment.comment_submit_text': 'Send',
  'kanban_comment.submit_error': 'Failed to send comment. Please try again.',

  'service_order_form.submit_text': 'Update',
  'service_order_form.name_label': 'Title',
  'service_order_form.name_placeholder': 'Service order title',
  'service_order_form.lead_technician_label': 'Lead technician',
  'service_order_form.technicians_label': 'Technicians',
  'service_order_form.add_technician_tooltip': 'Add technicians',
  'service_order_form.scheduledAt_label': 'Scheduled date',
  'service_order_form.priority_label': 'Priority',
  'service_order_form.description_label': 'Description',
  'service_order_form.description.placeholder': 'Task description...',
  'service_order_form.device_label': 'Device',
  'service_order.device_placeholder': 'Choose a device',
  'service_order_form.completed_check_label': 'Completed',
  'service_order.completed_tooltip': 'Mark order as completed',
  'service_order.add_text': 'Create',
  'service_order.priority_low': 'Low',
  'service_order.priority_medium': 'Medium',
  'service_order.priority_high': 'High',
  'service_order.status_required_error_message': 'Status is required',
  'service_orders.dialog_title': 'Service Orders',
  'service_orders.dialog_description': 'Manage service orders for this device.',
  'service_order_form.name_required': 'Service order title is required',
  'service_order_form.device_required': 'device is required',
  'service_order_form.status_label': 'Status',
  'service_order.status_placeholder': 'Select status',

  // Service Orders Table
  'service_orders.view_table': 'Table',
  'service_orders.view_kanban': 'Kanban',
  'service_orders.create_button': 'New Service Order',
  'service_orders.edit_dialog_title': 'Edit Service Order',
  'service_orders.delete_confirm':
    'Are you sure you want to delete this service order?',
  'service_orders.delete_success': 'Service order deleted',
  'service_orders.delete_error': 'Failed to delete service order',
  'service_orders.completed': 'Completed',
  'service_orders.pending': 'Pending',
  'service_orders.status.unknown': 'Unknown',
  'service_orders.table.title': 'Title',
  'service_orders.table.device': 'Device',
  'service_orders.table.status': 'Status',
  'service_orders.table.lead_technician': 'Lead Technician',
  'service_orders.table.technicians': 'Technicians',
  'service_orders.table.priority': 'Priority',
  'service_orders.table.scheduled_at': 'Scheduled',
  'service_orders.table.created_at': 'Created',
  'service_orders.table.completed': 'Completed',
  'service_orders.table.actions': 'Actions',

  // Service Order MoreMenuButton translations
  'serviceOrderItem.delete.title.confirmation': 'Delete Service Order',
  'serviceOrderItem.delete.confirmation':
    'Are you sure you want to delete this service order? This action cannot be undone.',
  'table.more_options.edit.serviceOrder': 'Edit service order',
  'table.more_options.delete.serviceOrder': 'Delete service order',

  'kanban.delete_task_title': 'Delete task',
  'kanban.delete_task_description':
    'Are you sure yout want to delete this task?',
  'kanban.task_delete_tooltip': 'Delete',

  'kanban.update_task_success_message': 'Task updated successfully',
  'kanban.update_task_error_message': 'Error while updating this task',

  'kanban_details.overview_tab_title': 'Details',
  'kanban_details.subtasks_tab_title': 'Subtasks',
  'kanban_details.comments_tab_title {{ comments }}':
    'Comments ({{ comments }})',

  'kanban.update_subtask_success': 'Updated subtask',
  'kanban.update_subtask_error': 'Error while updating this subtask',

  'kanban.add_subtask_success': 'Subtask added successfully',
  'kanban.add_subtask_error': 'Error while adding subtask',

  'kanban_subtask.total_count {{ count }} {{ total }}':
    '{{ count }} of {{ total }}',
  'kanban_subtask.empty_text':
    'Currently there are no subtask for this task, try adding one!',
  'kanban_subtask.add_subtask_text': 'Add',
  'kanban_subtask.add_subtask_description_placeholder': 'Task description...',

  'kanban.column_updated_error': 'Error while updating the column',
  'kanban.task_updated_error': 'Error while updating the task',
  'kanban.task_delete_success': 'Task deleted successfully',

  'kanban.error_title': 'Currently there are no existing columns',
  'kanban.toggle_completed__text': 'Show completed',

  'kanban.comment_created': 'Has created a service order',
  'kanban.task_assigned {{ userId }} {{ technicians }}':
    'Assigned a technician {{ userId }} {{ technicians }}',
  'kanban.task_scheduled': 'Has added an execution date',
  'kanban.status_changed {{ statusId }}': 'Has moved to column {{ statusId }}',
  'kanban.task_finished': 'Has marked this task as completed',
  'kanban.task_unfinished': 'Has marked this task as not completed',
  'kanban.unknown_type': 'Unknown',

  // PERMISSIONS TRANSLATIONS
  treinco_permissions_account: 'Account',
  'treinco_permissions_account.view': 'View account',
  treinco_permissions_system: 'System',

  treinco_permissions_action_group: 'Action Group',
  'treinco_permissions_action_group.create': 'Create',
  'treinco_permissions_action_group.update': 'Update',
  'treinco_permissions_action_group.delete': 'Delete',
  'treinco_permissions_action_group.view': 'View',
  treinco_permissions_invoice: 'Invoices',
  'treinco_permissions_invoice.create': 'Create',
  'treinco_permissions_invoice.update': 'Update',
  'treinco_permissions_invoice.delete': 'Delete',
  'treinco_permissions_invoice.view': 'View',
  'treinco_permissions_invoice.read': 'Read',
  treinco_permissions_subscription: 'Subscriptions',
  'treinco_permissions_subscription.create': 'Create',
  'treinco_permissions_subscription.update': 'Update',
  'treinco_permissions_subscription.delete': 'Delete',
  'treinco_permissions_subscription.view': 'View',
  treinco_permissions_plan: 'Plans',
  'treinco_permissions_plan.create': 'Create',
  'treinco_permissions_plan.update': 'Update',
  'treinco_permissions_plan.delete': 'Delete',
  'treinco_permissions_plan.view': 'View',
  treinco_permissions_item: 'Items',
  'treinco_permissions_item.create': 'Create',
  'treinco_permissions_item.update': 'Update',
  'treinco_permissions_item.delete': 'Delete',
  'treinco_permissions_item.view': 'View',
  treinco_permissions_brand: 'Brand',
  'treinco_permissions_brand.create': 'Create',
  'treinco_permissions_brand.update': 'Update',
  'treinco_permissions_brand.delete': 'Delete',
  'treinco_permissions_brand.view': 'View',
  treinco_permissions_cloud_connector: 'Cloud Connector',
  'treinco_permissions_cloud_connector.create': 'Create Cloud Connector',
  'treinco_permissions_cloud_connector.update': 'Update Cloud Connector',
  'treinco_permissions_cloud_connector.delete': 'Delete Cloud Connector',
  treinco_permissions_command_sent: 'Sent Commands',
  'treinco_permissions_command_sent.create': 'Create',
  treinco_permissions_connector: 'Connector',
  'treinco_permissions_connector.create': 'Create',
  'treinco_permissions_connector.update': 'Update',
  'treinco_permissions_connector.delete': 'Delete',
  'treinco_permissions_connector.view': 'View',
  treinco_permissions_conversation: 'Conversation',
  'treinco_permissions_conversation.create': 'Create',
  'treinco_permissions_conversation.update': 'Update',
  'treinco_permissions_conversation.delete': 'Delete',
  'treinco_permissions_conversation.view': 'View',
  treinco_permissions_company: 'Company',
  'treinco_permissions_company.view': 'View',
  'treinco_permissions_company.create': 'Create',
  'treinco_permissions_company.update': 'Update',
  'treinco_permissions_company.delete': 'Delete',
  treinco_permissions_customer: 'Customer',
  'treinco_permissions_customer.create': 'Create',
  'treinco_permissions_customer.update': 'Update',
  'treinco_permissions_customer.delete': 'Delete',
  'treinco_permissions_customer.view': 'View',
  'treinco_permissions_customer.user_management': 'User management',
  treinco_permissions_device: 'Device',
  'treinco_permissions_device.create': 'Create',
  'treinco_permissions_device.update': 'Update',
  'treinco_permissions_device.delete': 'Delete',
  'treinco_permissions_device.view': 'View devices',
  'treinco_permissions_device.user_management': 'User management',
  treinco_permissions_device_link: 'Device Link',
  'treinco_permissions_device_link.view': 'View',
  'treinco_permissions_device_link.create': 'Create',
  'treinco_permissions_device_link.update': 'Update',
  'treinco_permissions_device_link.delete': 'Delete',
  treinco_permissions_device_event: 'Device Event',
  'treinco_permissions_device_event.create': 'Create',
  'treinco_permissions_device_event.update': 'Update',
  'treinco_permissions_device_event.delete': 'Delete',
  'treinco_permissions_device_event.view': 'View',
  treinco_permissions_device_history: 'Device History',
  'treinco_permissions_device_history.create': 'Create',
  'treinco_permissions_device_history.update': 'Update',
  'treinco_permissions_device_history.delete': 'Delete',
  'treinco_permissions_device_history.view': 'View',
  treinco_permissions_device_inactivations: 'Device Inactivations',
  'treinco_permissions_device_inactivations.create': 'Create',
  'treinco_permissions_device_inactivations.update': 'Update',
  'treinco_permissions_device_inactivations.delete': 'Delete',
  'treinco_permissions_device_inactivations.view': 'View',
  treinco_permissions_device_note: 'Device Note',
  'treinco_permissions_device_note.create': 'Create',
  'treinco_permissions_device_note.update': 'Update',
  'treinco_permissions_device_note.delete': 'Delete',
  'treinco_permissions_device_note.view': 'View',
  treinco_permissions_device_round: 'Device Round',
  'treinco_permissions_device_round.create': 'Create',
  'treinco_permissions_device_round.update': 'Update',
  'treinco_permissions_device_round.delete': 'Delete',
  'treinco_permissions_device_round.view': 'View',
  treinco_permissions_device_schedule: 'Device Schedule',
  'treinco_permissions_device_schedule.create': 'Create',
  'treinco_permissions_device_schedule.update': 'Update',
  'treinco_permissions_device_schedule.delete': 'Delete',
  'treinco_permissions_device_schedule.view': 'View',
  treinco_permissions_device_user: 'Device User',
  'treinco_permissions_device_user.create': 'Create',
  'treinco_permissions_device_user.update': 'Update',
  'treinco_permissions_device_user.delete': 'Delete',
  'treinco_permissions_device_user.view': 'View',
  treinco_permissions_device_zone: 'Device Zone',
  'treinco_permissions_device_zone.create': 'Create',
  'treinco_permissions_device_zone.update': 'Update',
  'treinco_permissions_device_zone.delete': 'Delete',
  'treinco_permissions_device_zone.view': 'View',
  treinco_permissions_emergency_contact: 'Emergency Contact',
  'treinco_permissions_emergency_contact.create': 'Create',
  'treinco_permissions_emergency_contact.update': 'Update',
  'treinco_permissions_emergency_contact.delete': 'Delete',
  'treinco_permissions_emergency_contact.view': 'View',
  treinco_permissions_event: 'Event',
  'treinco_permissions_event.create': 'Create',
  'treinco_permissions_event.update': 'Update',
  'treinco_permissions_event.delete': 'Delete',
  'treinco_permissions_event.view': 'View',
  treinco_permissions_event_group: 'Event Group',
  'treinco_permissions_event_group.create': 'Create',
  'treinco_permissions_event_group.update': 'Update',
  'treinco_permissions_event_group.delete': 'Delete',
  'treinco_permissions_event_group.view': 'View',
  treinco_permissions_invitation: 'Invitation',
  'treinco_permissions_invitation.create': 'Create',
  'treinco_permissions_invitation.update': 'Update',
  'treinco_permissions_invitation.delete': 'Delete',
  'treinco_permissions_invitation.view': 'View',
  treinco_permissions_model: 'Model',
  'treinco_permissions_model.create': 'Create',
  'treinco_permissions_model.update': 'Update',
  'treinco_permissions_model.delete': 'Delete',
  'treinco_permissions_model.view': 'View',
  treinco_permissions_monitoring_resolution: 'Monitoring Resolution',
  'treinco_permissions_monitoring_resolution.create': 'Create',
  'treinco_permissions_monitoring_resolution.update': 'Update',
  'treinco_permissions_monitoring_resolution.delete': 'Delete',
  'treinco_permissions_monitoring_resolution.view': 'View',
  treinco_permissions_place: 'Place',
  'treinco_permissions_place.create': 'Create',
  'treinco_permissions_place.update': 'Update',
  'treinco_permissions_place.delete': 'Delete',
  'treinco_permissions_place.view': 'View',
  treinco_permissions_role: 'Role',
  'treinco_permissions_role.create': 'Create',
  'treinco_permissions_role.update': 'Update',
  'treinco_permissions_role.delete': 'Delete',
  'treinco_permissions_role.view': 'View',
  treinco_permissions_service_order: 'Service Order',
  'treinco_permissions_service_order.create': 'Create',
  'treinco_permissions_service_order.update': 'Update',
  'treinco_permissions_service_order.delete': 'Delete',
  'treinco_permissions_service_order.view': 'View',
  treinco_permissions_timer: 'Timer',
  'treinco_permissions_timer.create': 'Create',
  'treinco_permissions_timer.update': 'Update',
  'treinco_permissions_timer.delete': 'Delete',
  'treinco_permissions_timer.view': 'View',
  treinco_permissions_user: 'User',
  'treinco_permissions_user.create': 'Create',
  'treinco_permissions_user.update': 'Update',
  'treinco_permissions_user.delete': 'Delete',
  'treinco_permissions_user.view': 'View',
  treinco_permissions_user_role: 'User Role',
  'treinco_permissions_user_role.create': 'Create user role',
  'treinco_permissions_user_role.update': 'Update user role',
  'treinco_permissions_user_role.delete': 'Delete user role',
  'treinco_permissions_user_role.view': 'View user role',
  treinco_permissions_workspace: 'Workspace',
  'treinco_permissions_workspace.create': 'Create',
  'treinco_permissions_workspace.update': 'Update',
  'treinco_permissions_workspace.delete': 'Delete',
  'treinco_permissions_workspace.view': 'View',
  treinco_permissions_workspace_shared_access: 'Workspace Shared Access',
  'treinco_permissions_workspace_shared_access.create': 'Create',
  'treinco_permissions_workspace_shared_access.manage': 'Manage',
  'treinco_permissions_workspace_shared_access.view': 'View',
  'treinco_permissions_workspace_shared_access.delete': 'Delete',
  treinco_permissions_device_partition: 'Device Partition',
  'treinco_permissions_device_partition.create': 'Create',
  'treinco_permissions_device_partition.update': 'Update',
  'treinco_permissions_device_partition.delete': 'Delete',
  'treinco_permissions_device_partition.view': 'View',
  treinco_permissions_geofence: 'Geofence',
  'treinco_permissions_geofence.create': 'Create',
  'treinco_permissions_geofence.update': 'Update',
  'treinco_permissions_geofence.delete': 'Delete',
  'treinco_permissions_geofence.view': 'View',
  treinco_permissions_monitoring: 'Monitoring',
  'treinco_permissions_monitoring.create': 'Create',
  'treinco_permissions_monitoring.update': 'Update',
  'treinco_permissions_monitoring.delete': 'Delete',
  'treinco_permissions_monitoring.view': 'View',
  'treinco_permissions_attachment.delete': 'Delete',
  'treinco_permissions_attachment.view': 'View',
  'treinco_permissions_attachment.create': 'Create',
  'treinco_permissions_device_cctv_channel.create': 'Create',
  'treinco_permissions_device_cctv_channel.update': 'Update',
  'treinco_permissions_device_cctv_channel.delete': 'Delete',
  'treinco_permissions_device_cctv_channel.view': 'View',
  treinco_permissions_situation: 'Situation',
  'treinco_permissions_situation.view': 'View',

  'general.phonenumbers.button.show_more': 'more',
  'general.phonenumbers.button.show_less': 'Show less',

  'create_channel.title': 'Create Channel',
  'update_channel.title': 'Update Channel',
  'channel_form.create_button_text': 'Create',
  'channel_form.update_button_text': 'Update',
  'channel_form.channelNumber_label': 'Channel ID',
  'channel_form.description_label': 'Description',
  'table.more_options.view_camera': 'View camera',
  'table.more_options.playback_camera': 'Playback camera',
  'create_channel.success': 'Channel created successfully',
  'update_channel.success': 'Channel updated successfully',
  'channel.delete_success': 'Channel deleted successfully',
  'channel.delete_error_associated_with_round':
    'Cannot delete channel: its linked point is used in a round.',
  'channel.delete_error': 'An error occurred while deleting the channel.',
  'cctv.check_plugin': 'Check',
  // partition

  'partitionSelector.title': 'Select a partition',
  'partition.search': 'Search a partition',
  'partitionSelector.noPartitions.subtitle': 'No partitions yet',
  'partitionSelector.button.add': 'Add partition',
  'devicePartition.error.identifier.already.exist': 'Partition already exists',
  'devicePartition.general.error': 'Error while creating the partition',
  'devicePartition.user.partition.removed': 'Partition has been removed',
  'createPartition.form.identifier': 'Identifier',
  'createPartition.form.name': 'Name',
  'createPartition.button.edit': 'Edit',
  'createPartition.button.add': 'Create',
  'createPartition.button.delete': 'Delete',
  'partitionSelector.delete.title.confirmation':
    'Are you sure you want to delete this partition?',
  'partitionSelector.delete.subtitle.confirmation':
    'This action can not be undone',
  'partition.status': 'Status',
  'partition.actions': 'Actions',
  'partitions.disarmed': 'Disarmed',
  'partitions.armed': 'Armed',

  // attachment

  'fetchAttachments.error': 'Error fetching attachments.',
  'attachments.title': 'Attachments',
  'attachments.empty_message': 'No attachments found.',
  'attachments.error_message': 'Error loading attachments.',
  'attachments.upload_error_message': 'Error uploading attachment.',
  'attachments.delete_success_message': 'Attachment deleted successfully.',
  'attachments.delete_error_message': 'Error deleting attachment.',
  'attachments.view_error_message':
    'Could not open attachment. URL might be missing.',
  'common.actions.view': 'View',
  'common.actions.download': 'Download',
  'common.actions.delete': 'Delete',
  'attachments.delete_confirm_message':
    'Are you sure you want to delete this attachment?',
  'table.more_options.download_view': 'View / Download',
  'attachmentsTable.error_graphql_create': 'Error creating attachment record.',
  'attachmentsTable.error_getting_upload_url': 'Could not get upload URL.',
  'createAttachmentForm.success_single': 'Attachment uploaded successfully.',
  'createAttachmentForm.error_submit':
    'Attachment submission failed. Please try again.',
  'createAttachmentForm.title_single': 'Upload New Attachment',
  'attachmentsTable.title': 'Attachments',
  'attachmentsTable.add_button': 'Add Attachment',
  'attachments_table.filename_field': 'Filename',
  'attachments_table.created_at_field': 'Created At',
  'attachments_table.actions_field': 'Actions',
  'createAttachmentForm.error_no_file_selected':
    'Please select a file to upload.',
  'common.cancel': 'Cancel',
  'createAttachmentForm.uploading_button': 'Uploading...',
  'createAttachmentForm.upload_button': 'Upload',
  'createAttachmentForm.error_forbidden_type':
    'Forbidden file type for {{fileName}}.',
  'createAttachmentForm.error_remove_existing':
    'Please remove the existing file first.',
  'createAttachmentForm.file_selected_title': 'File Selected',
  'createAttachmentForm.drop_zone_title_single': 'Drag & Drop file here',
  'createAttachmentForm.drop_zone_text_single': 'or ',
  'createAttachmentForm.browse_link': 'browse files',
  'createAttachmentForm.file_to_upload': 'File to Upload',
  'attachments_table.file_type_field': 'File Type',
  'createAttachmentForm.error_size_limit':
    'File {{fileName}} exceeds the maximum size of {{maxSize}}.',

  // Device general settings
  'deviceSettings.success.update': 'Device settings updated successfully',
  'deviceSettings.error.update_failed': 'Failed to update device settings',
  'deviceSettings.loading': 'Loading...',
  'deviceSettings.tooltip.edit': 'Edit',
  'deviceSettings.form.key': 'Key',
  'deviceSettings.form.secretKey': 'Secret key',
  'deviceSettings.form.craSecretKey': 'CRA secret key',
  'deviceSettings.form.duressCode': 'Duress key',
  'deviceSettings.tooltip.secretKey':
    'Code the user types in the app to confirm the alarm was false. Closes the event automatically.',
  'deviceSettings.tooltip.craSecretKey':
    'Central station (CRA) code. Shown to the operator for manual verification only; not used by chat verification.',
  'deviceSettings.tooltip.duressCode':
    'Code the user types when under duress. Looks like a normal answer, but flags the alarm as real and keeps the event open.',
  'deviceSettings.form.sim': 'SIM',
  'deviceSettings.form.imei': 'IMEI',
  'deviceSettings.form.deviceSerial': 'Device Serial',
  'deviceSettings.form.password': 'Device Password',
  'deviceSettings.form.contactTitle': 'Contact information',
  'deviceSettings.form.localPhone': 'Home phone',
  'deviceSettings.form.mobilePhone': 'Mobile phone',
  'deviceSettings.form.email': 'Email',
  'deviceSettings.form.contact_person': 'Contact person',
  'deviceSettings.form.installer': 'Installer',
  'deviceSettings.form.submit': 'Submit',
  'deviceSettings.form.description': 'Description',
  'deviceSettings.form.create_asset_brand_title': 'Create asset brand',
  'deviceSettings.form.create_asset_model_title': 'Create asset model',
  'deviceSettings.button.save': 'Save',
  'device_category.created_success': 'Category created successfully',
  'device_category.create_error': 'Error creating category',
  'deviceSettings.form.device_category': 'Category',
  'device_category.search_error': 'Error searching categories',
  'device_category.add_new': 'Add new category',
  'device_category.create_title': 'Create Device Category',
  'device_category.description_label': 'Description',
  'device_category.create_button': 'Create',
  'device_category.select_label': 'Category',
  'deviceSettings.validation.simDigits': 'SIM must be only digits',
  'deviceSettings.validation.simMin': 'SIM seems too short',
  'deviceSettings.validation.simMax': 'SIM seems too long',
  'deviceSettings.validation.imeiDigits': 'IMEI must be only digits',
  'deviceSettings.validation.imeiLength': 'IMEI must be 15 digits',
  'deviceSettings.validation.phoneCodeFormat': 'Invalid phone code format',
  'deviceSettings.validation.phoneNumberDigits':
    'Phone number must contain only digits',
  'deviceSettings.validation.emailFormat':
    'Email must be a valid email address',
  'deviceSettings.validation.keyInvalid': 'The key is not valid',
  'deviceSettings.validation.keyMaxLength':
    'The key must be at most 100 characters',
  'deviceSettings.validation.keysMustDiffer':
    'The secret, CRA and duress keys must all be different from each other',
  'device_profile.generals_tab_title': 'General',
  'deviceSettings.validation.phonePairRequired':
    'Both phone code and number are required',
  'deviceSettings.validation.installerMaxLength':
    'Installer name must be at most 100 characters',
  'deviceLabelsAutocomplete.label': 'Device tags',
  'deviceLabelsAutocomplete.placeholder': 'Type to search or add labels',
  'deviceLabelsAutocomplete.add_label': 'Add "{{label}}"',
  'deviceLabelsAutocomplete.create_new_label': 'Create New Label',
  'deviceLabelsAutocomplete.error_loading_labels':
    'Error loading labels: {{message}}',
  'createDeviceLabelForm.title': 'Label Name',
  'createDeviceLabelForm.color': 'Color',
  'createDeviceLabelForm.create_button': 'Create Label',
  'createDeviceLabelForm.creating': 'Creating...',
  'createDeviceLabelForm.error': 'Error creating label',
  'createDeviceLabelForm.success': 'Label created successfully',
  'createCustomerLabelForm.name': 'Label Name',
  'createCustomerLabelForm.color': 'Color',
  'createCustomerLabelForm.error': 'Error creating label',
  'createCustomerLabelForm.success': 'Label created successfully',
  'createDeviceLabelForm.success': 'Label created successfully',

  'customerLabelsAutocomplete.label': 'Customer tags',
  'customerLabelsAutocomplete.placeholder': 'Type to search or add labels',
  'customerLabelsAutocomplete.add_label': 'Add "{{label}}"',
  'customerLabelsAutocomplete.create_new_label': 'Create New Label',
  'customerLabelsAutocomplete.error_loading_labels':
    'Error loading labels: {{message}}',
  'customers.generals.updateError': 'Error updating customer',
  'customers.generals.updateSuccess': 'Customer updated successfully',
  'deviceSettings.form.device_object_data_title': 'Device asset data',
  'deviceSettings.form.create_asset_brand_success':
    'Brand created successfully',
  'deviceSettings.form.create_asset_brand_error': 'Error creating brand',
  'deviceSettings.form.create_asset_model_success':
    'Model created successfully',
  'deviceSettings.form.create_asset_model_error': 'Error creating model',
  'deviceSettings.form.delete_asset_brand_success':
    'Brand deleted successfully',
  'deviceSettings.form.delete_asset_brand_error': 'Error deleting brand',
  'deviceSettings.form.delete_asset_model_success':
    'Model deleted successfully',
  'deviceSettings.form.delete_asset_model_error': 'Error deleting model',
  'deviceSettings.form.device_asset_brand_label': 'Brand',
  'deviceSettings.form.device_asset_model_label': 'Model',

  'common.actions': 'Actions',

  // Calendar Toolbar
  'calendar.today': 'Today',
  'calendar.week': 'Week',
  'calendar.day': 'Day',
  'calendar.agenda': 'Agenda',
  'calendar.month': 'Month',

  'calendar.move.error':
    'Could not move the event, edit the recurrence configuration.',

  'users.category_field_text': 'Category',
  'device_user_category.select_label': 'Select category',
  'device_user_category.created_success': 'Category created successfully',
  'device_user_category.create_error': 'Error creating category',
  'device_user_category.add_new': 'Add new category',
  'device_user_category.create_title': 'Create new category',
  'device_user_category.description_label': 'Category description',
  'device_user_category.create_button': 'Create category',

  // event inactivity
  'event_inactivity_form.title_text': 'Event inactivity notification',
  'event_inactivity_form.unit_minutes': 'Minutes',
  'event_inactivity_form.unit_hours': 'Hours',
  'event_inactivity_form.interval_label': 'Interval',
  'event_inactivity_form.last_activity_label': 'Last activity',
  'event_inactivity_form.submit_text': 'Save inactivity notification',
  'event_inactivity_form.remove_text': 'Remove inactivity notification',
  'event_inactivity_form.unit_required': 'Unit is required',
  'event_inactivity_form.interval_required': 'Interval is required',
  'event_inactivity_form.interval_min_error': 'Interval must be at least 1',
  'device_quick_actions.event_inactivity_text': 'System inactivity',

  // position inactivity
  'position_inactivity_form.title_text': 'Position inactivity notification',
  'position_inactivity_form.unit_minutes': 'Minutes',
  'position_inactivity_form.unit_hours': 'Hours',
  'position_inactivity_form.interval_label': 'Interval',
  'position_inactivity_form.last_activity_label': 'Last activity',
  'position_inactivity_form.submit_text': 'Save inactivity notification',
  'position_inactivity_form.remove_text': 'Remove inactivity notification',
  'position_inactivity_form.unit_required': 'Unit is required',
  'position_inactivity_form.interval_required': 'Interval is required',
  'position_inactivity_form.interval_min_error': 'Interval must be at least 1',
  'device_quick_actions.position_inactivity_text': 'Position inactivity',

  // stop limit
  'stop_limit_inactivity_form.title_text': 'Stopped time limit notification ',
  'stop_limit_inactivity_form.unit_minutes': 'Minutes',
  'stop_limit_inactivity_form.unit_hours': 'Hours',
  'stop_limit_inactivity_form.interval_label': 'Interval',
  'stop_limit_inactivity_form.last_activity_label': 'Last activity',
  'stop_limit_inactivity_form.submit_text': 'Save stop limit notification',
  'stop_limit_inactivity_form.remove_text': 'Remove stop limit notification',
  'stop_limit_inactivity_form.unit_required': 'Unit is required',
  'stop_limit_inactivity_form.interval_required': 'Interval is required',
  'stop_limit_inactivity_form.interval_min_error':
    'Interval must be at least 1',
  'device_quick_actions.position_inactivity_text': 'Position inactivity',
  'device_quick_actions.stop_limit_inactivity_text': 'Position stop limit',

  // Timer validation messages
  ACTION_REQUIRED: 'Action is required',
  START_DATE_REQUIRED: 'Start date is required',
  END_DATE_MUST_BE_LARGER_THAN_START: 'End date must be after start date',
  INTERVAL_REQUIRED: 'Interval is required',
  EVENT_PROTOCOL_REQUIRED: 'Event protocol is required',
  EVENT_CODE_REQUIRED: 'Event code is required',
  'inactivity_form.create_success': 'Inactivation event created successfully',
  'inactivity_form.update_success': 'Inactivation event updated successfully',
  'inactivity_form.delete_success': 'Inactivation event deleted successfully',
  'inactivity_form.error': 'Error processing inactivation event',
  'inactivity_form.delete_error': 'Error deleting inactivation event',

  'profile.update_user_successful': 'Successfully updated user',

  'inactivity_form.title_text': 'Device Inactivity Notification',
  'inactivity_form.interval_label': 'Notification Interval',
  'inactivity_form.unit_label': 'Unit',
  'inactivity_form.unit_minutes': 'minutes',
  'inactivity_form.unit_hours': 'hours',
  'inactivity_form.last_activity_date_label': 'Last Activity Date',
  'inactivity_form.submit_button': 'Save',
  'inactivity_form.remove_button': 'Remove',
  'inactivity_form.interval_required': 'Notification interval is required',
  'inactivity_form.interval_positive': 'Notification interval must be positive',
  'inactivity_form.interval_integer':
    'Notification interval must be an integer',
  'inactivity_form.unit_required': 'Unit is required',
  'inactivity_form.last_activity_date_required':
    'Last activity date is required',

  'device_quick_actions.send_command_text': 'Send Command',
  'device_quick_actions.inactivity_event_text': 'Event inactivity',
  'device_quick_actions.inactivity_position_text': 'Position Inactivity',
  'device_quick_actions.speed_value_text': 'Speed limit',

  'speed_limit_form.title_text': 'Speed limit notification',
  'speed_limit_form.speed_limit_label': 'Speed Limit',

  'monitoring.email_field_label': 'Email',
  'monitoring.events_per_page': 'Events per page',
  'monitoring.start_date_label': 'Start Date',
  'monitoring.end_date_label': 'End Date',
  'monitoring.apply_filter_button_text': 'Apply Filters',
  'monitoring.reset_filter_button_text': 'Reset Filters',
  'monitoring.filter_options_text': 'Filter Options',
  'monitoring.refresh_button_text': 'Refresh',
  'monitoring.event_details_title': 'Event Details',
  'monitoring.event_details_id_label': 'Event ID',
  'monitoring.event_details_device_label': 'Device',
  'monitoring.event_details_event_label': 'Event',
  'monitoring.event_details_generated_label': 'Generated At',
  'monitoring.event_details_received_label': 'Received At',
  'monitoring.event_details_status_label': 'Status',
  'monitoring.event_details_processed_by_label': 'Processed By',
  'monitoring.event_details_processed_at_label': 'Processed At',
  'monitoring.event_details_notes_label': 'Notes',
  'updateDeviceNote.general.error': 'Error updating device note',
  'monitoring.event_details_actions_label': 'Actions',
  'monitoring.event_details_type_label': 'Type',
  'monitoring.event_details_priority_label': 'Priority',
  'monitoring.event_details_is_monitorable_label': 'Is Monitorable',
  'monitoring.event_details_event_group_label': 'Event Group',
  'monitoring.event_details_created_at_label': 'Created At',
  'monitoring.event_details_updated_at_label': 'Updated At',
  'monitoring.event_details_raw_data_label': 'Raw Data',
  'monitoring.event_details_raw_data_copy_button': 'Copy Raw Data',
  'monitoring.event_details_raw_data_copied': 'Raw data copied to clipboard!',

  // Timer validation messages
  ACTION_REQUIRED: 'Action is required',
  START_DATE_REQUIRED: 'Start date is required',
  END_DATE_MUST_BE_LARGER_THAN_START: 'End date must be after start date',
  INTERVAL_REQUIRED: 'Interval is required',
  EVENT_PROTOCOL_REQUIRED: 'Event protocol is required',
  EVENT_CODE_REQUIRED: 'Event code is required',
  'inactivity_form.error': 'Error processing inactivation event',
  'inactivity_form.delete_error': 'Error deleting inactivation event',
  'event_inactivity_form.never': 'Never',

  // Missing translation keys found in components
  'set.default.value.title.confirmation': 'Set Default Value',
  'set.default.value.body.confirmation':
    'Are you sure you want to set this as the default value?',
  'video.attachments': 'Video Attachments',
  'audio.attachments': 'Audio Attachments',
  'audio n. ': 'Audio ',
  'AudioMenuDialog.no.audio': 'No audio selected',
  'AudioMenuDialog.select.audio.selected':
    'Select an audio from the list to play it',
  'videoMenuDialog.counter': 'Video {{current}} / {{total}}',
  'Monitoring.status.waiting': 'Monitoring status: waiting',
  'Monitoring.status.paused': 'Monitoring status: paused',
  'Monitoring.loading.error': 'Error loading monitoring data',
  'Monitoring.bulk_process.empty_options.error':
    'Please select processing options',
  'Monitoring.bulk_process.empty_resolution_comment.error':
    'Resolution comment is required',
  'Monitoring.bulk_process.processed.success':
    'Successfully processed {{count}} of {{total}} situations',
  'Monitoring.bulk_process.processed.partial_error':
    'Failed to process {{failed}} of {{total}} situations',
  'Monitoring.bulk_process.processed.error': 'Error processing situations',
  'monitoring.bulk_process.selected_count': '{{count}} situations selected',
  'monitoring.bulk_process.processing': 'Processing situations...',
  'monitoring.bulk_process.round_not_selectable':
    'This situation belongs to a round and cannot be processed in bulk',
  'fetchEvents.error': 'Error fetching events',
  'createDeviceHistory.form.fetch_error_text': 'Error fetching data for form',
  'createDeviceHistory.success': 'Device history created successfully',
  'createDeviceHistory.general.error': 'Error creating device history',
  'sent_invitation.success': 'Invitation sent successfully',
  'create_treinco_app.form.email_error': 'Invalid email address',
  'create_treinco_app.form.email_required': 'Email is required',
  'create_treinco_app.form.name_error': 'Name is required',
  'create_treinco_app.form.last_name_error': 'Last name is required',
  'create_treinco_app.form.device_name_error': 'Device name is required',
  'device_history_preview.latest_events_title': 'Latest Events',
  'PlacerPicker.success_message': 'Place selected successfully',
  'PlacerPicker.error_message': 'Error selecting place',
  'emergencyContactList.noEmergencyContactList.title':
    'No Emergency Contact Lists',
  'emergencyContactList.noEmergencyContactList.subtitle':
    'Create your first emergency contact list to get started',
  'emergencyContactList.search.eventGroups': 'Search event groups...',
  'common.search.placeholder': 'Search...',
  'monitoring_monitoring_error_modal.button_reset': 'Reset Connection',

  // Additional missing translation keys
  'deleteGeofenceById.create.success': 'Geofence deleted successfully',
  'deleteGeofenceById.geofence.has.devices.error':
    'Cannot delete geofence: it has associated devices',
  'deleteGeofenceById.general.error': 'Error deleting geofence',
  'deleteGeofenceById.delete.title.confirmation': 'Delete Geofence',
  'deleteGeofenceById.delete.subtitle.confirmation':
    'Are you sure you want to delete this geofence?',
  'deleteGeofenceAssociationById.success':
    'Geofence association removed successfully',
  'CreateGeofence.create.success': 'Geofence created successfully',
  'CreateGeofence.general.error': 'Error creating geofence',
  'updateGeofenceById.create.success': 'Geofence updated successfully',
  'updateGeofenceById.general.error': 'Error updating geofence',
  'flushDeviceGeofence.general.error': 'Error flushing device geofence',
  'no.geofenceType.error': 'Geofence type is required',
  'createDeviceGeofence.success':
    'Device geofence association created successfully',
  'createDeviceGeofence.general.error':
    'Error creating device geofence association',
  'geofence.remove.association.title.confirmation':
    'Remove Geofence Association',
  'geofence.remove.association.confirmation':
    'Are you sure you want to remove this geofence association?',
  'geofenceCard.link.edit.geofence': 'Edit Geofence',
  'geofenceCard.remove.association': 'Remove Association',
  'geofenceCard.delete.geofence': 'Delete Geofence',
  'close.geofence.list': 'Close Geofence List',
  'open.geofence.list': 'Open Geofence List',
  'devicesGeofence.input.text': 'Search devices by geofence',
  'geofences.button.create': 'Create Geofence',
  'button.new.association': 'Add Existing',
  'geofences.empty.create': 'Create your first geofence',
  'GeofenceListToAssociate.save': 'Save',
  'GeofenceListToAssociate.back': 'Back',
  'GeofenceList.empty.geofences': 'No geofences available to associate',

  'CreateGeofence.create.title': 'Create Geofence',
  'createGeofence.form.name': 'Name',
  'createGeofence.form.geofence.type': 'Type',
  'createGeofence.form.color': 'Color',
  'geofence.type.line': 'Line',
  'geofence.type.polygon': 'Polygon',
  'geofence.type.circle': 'Circle',
  'geofence.draw': 'Draw',
  'geofence.re-draw': 'Re-draw',
  'geofence.stop': 'Stop',
  'geofence.submit': 'Submit',
  'geofence.back': 'Back',
  'devices_tab_title.devices': 'Devices',
  'devices_tab_title.geofences': 'Geofences',

  'RouteSummarySearch.general.error': 'Error searching route summary',
  'editDevice.success': 'Device updated successfully',
  'createDevice.success': 'Device created successfully',
  'device_form.error': 'Error processing device form',
  'device_form.error_uniqueId_exist':
    'A device with this prefix and identifier combination already exists.',
  'devicePlace.update.error': 'Error updating device place',
  'deviceTable.general.error': 'Error processing device table action',
  'resetpassword.success': 'Password reset successfully',
  'validateaccount.general.error': 'Error validating account',
  'validateaccount.success': 'Account validated successfully',
  'deleteEmergencyContactListEventGroup.success':
    'Emergency contact list event group deleted successfully',
  'deleteEmergencyContactListEventGroup.error':
    'Error deleting emergency contact list event group',
  'updateEmergencyContactListEventGroup.success':
    'Emergency contact list event group updated successfully',
  'updateEmergencyContactListEventGroup.error':
    'Error updating emergency contact list event group',
  'createEmergencyContactEventGroup.success':
    'Emergency contact event group created successfully',
  'create_customer.error': 'Customer is required',
  'createEmergencyContactEventGroup.general.error': 'Error adding the contact',

  // Validation error messages
  VALIDATE_PARTITION_IDENTIFIER_MIN_LENGHT_ERROR:
    'Partition identifier must be at least 1 character',
  VALIDATE_PARTITION_IDENTIFIER_MAX_LENGHT_ERROR:
    'Partition identifier must be at most 50 characters',
  VALIDATE_PARTITION_IDENTIFIER_REQUIRED: 'Partition identifier is required',
  VALIDATE_PARTITION_NAME_MIN_LENGHT_ERROR:
    'Partition name must be at least 3 characters',
  VALIDATE_PARTITION_NAME_MAX_LENGHT_ERROR:
    'Partition name must be at most 50 characters',
  VALIDATE_PARTITION_NAME_REQUIRED: 'Partition name is required',
  VALIDATE_EMERGENCY_NAME_MIN_LENGHT_ERROR:
    'Emergency contact name must be at least 3 characters',
  VALIDATE_EMERGENCY_NAME_MAX_LENGHT_ERROR:
    'Emergency contact name must be at most 50 characters',
  VALIDATE_DEVICE_NAME_MIN_LENGHT_ERROR:
    'Device name must be at least 3 characters',
  VALIDATE_DEVICE_NAME_MAX_LENGHT_ERROR:
    'Device name must be at most 50 characters',
  VALIDATE_DEVICE_NAME_REQUIRED: 'Device name is required',
  VALIDATE_TIMEZONE_REQUIRED: 'Timezone is required',
  VALIDATE_GEOFENCE_COLOR_REQUIRED: 'Geofence color is required',
  VALIDATE_DEVICE_ZONE_NAME_MIN_LENGHT_ERROR:
    'Device zone name must be at least 3 characters',
  VALIDATE_DEVICE_ZONE_NAME_MAX_LENGHT_ERROR:
    'Device zone name must be at most 50 characters',
  VALIDATE_DEVICE_ZONE_NAME_REQUIRED: 'Device zone name is required',

  // Workspace invitation and creation
  'workspaceInvitation.title.text': 'Workspace Invitation',
  'workspaceInvitation.body.text': 'You have been invited to join a workspace',
  'workspaceInvitation.body.error.text': 'Invalid or expired invitation',
  'workspaces.create_workspace.button.text': 'Create Workspace',
  'workspaces.create_workspace_modal.back_button.text': 'Back',
  'workspaces.create_workspace_modal.finish_button.text': 'Finish',
  'workspaces.create_workspace_modal.next_button.text': 'Next',
  'workspaces.create_workspace_modal.retry_button.text': 'Retry',
  'workspaceInvitation.button.cancel': 'Cancel',
  'workspaceInvitation.button.submit': 'Accept',
  'workspaceInvitation.button.goHome': 'Go Home',
  'WorkspaceInvitation.invitation.emailMismatch':
    'This invitation link is not for you. Please sign in with the correct account to accept the invitation.',
  'workspaceInvitation.body.error.emailMismatch':
    'This invitation link is not for you, please sign in with the correct account to accept the invitation.',
  'page.workspace.invitation': 'Workspace Invitation',
  'workspaceInvitation.body.accept_reject_success':
    'You have successfully accepted or rejected the invitation.',
  'workspaceInvitation.general.error':
    'An error occurred while processing the invitation.',
  // Form fields and actions
  'CreateResolution.form.text': 'Resolution Text',
  'device_action_groups.import.button.text': 'Import Actions',

  // User invitation to workspace
  'inviteUserToWorkspace.invitation.sent': 'Invitation sent successfully',
  'InviteUserToWorkspace.invite': 'Send Invitation',
  'InviteUserToWorkspace.form.email': 'Email Address',
  'inviteUserToWorkspace.error.user.exist':
    'User already exists in this workspace',
  'common.delete': 'Delete',
  'common.delete_confirm': 'Are you sure you want to delete "{{ name }}"?',

  // situation logs
  'situation_logs.dialog.title': 'Situation log',
  'situation_logs.load_error': 'Could not load the situation log.',
  'situation_logs.action_field_title': 'Action',
  'situation_logs.user_field_title': 'User',
  'situation_logs.date_field_title': 'Date',
  'situation_logs.comment_field_title': 'Comment',

  // Device Custom Key Values (using "Attribute" instead of "Key" in user-facing text)
  'device.custom_key_values': 'Custom Attributes',
  'device.no_custom_key_values': 'No custom attributes assigned',
  'device.add_custom_key_value': 'Add Custom Attribute',
  'device.custom_key_created': 'Custom attribute created successfully',
  'device.custom_key_already_exists':
    'This custom attribute is already assigned to this device',
  'device.custom_key_label': 'Custom Attribute',
  'device.custom_key_value': 'Value',
  'device.create_custom_key_title': 'Create Custom Attribute',
  'device.custom_key_name': 'Attribute Name',
  'device.create_key_button': 'Create Attribute',
  'device.unknown_key': 'Unknown Attribute',
  'device.add_new_key': 'Add new attribute',
  'device.custom_key_value_created':
    'Custom attribute value created successfully',
  'device.custom_key_value_deleted':
    'Custom attribute value deleted successfully',

  // Integration form translations
  'settings.integrations_table.receivers_field_text': 'Receivers',
  'integrations.add_receiver_label_menu': 'Add Receiver',
  'settings.connectors_table.connector_status_unknown_message':
    'Unknown Status',
  'update_receiver_form.title': 'Update Receiver',
  'create_receiver_form.title': 'Create Receiver',
  'update_receiver_form.submit': 'Update',
  'create_receiver_form.submit': 'Create',

  'receiver_form.description_label': 'Description',
  'receiver_form.description_placeholder': 'Enter description',
  'receiver_form.connection_type_label': 'Connection Type',
  'receiver_form.connection_types.serial': 'Serial',
  'receiver_form.connection_types.tcpClient': 'TCP Client',
  'receiver_form.connection_types.tcpServer': 'TCP Server',
  'receiver_form.connection_types.udp': 'UDP',
  'receiver_form.connection_types.httpServer': 'HTTP Server',
  'receiver_form.connection_types.polling': 'Polling',
  'receiver_form.receiver_type_label': 'Receiver Type',
  'receiver_form.host_label': 'Host',
  'receiver_form.port_label': 'Port',
  'receiver_form.baudRate_label': 'Baud Rate',
  'receiver_form.parity_label': 'Parity',
  'receiver_form.parity.none': 'None',
  'receiver_form.parity.even': 'Even',
  'receiver_form.parity.odd': 'Odd',
  'receiver_form.parity.mark': 'Mark',
  'receiver_form.parity.space': 'Space',
  'receiver_form.byteSize_label': 'Byte Size',
  'receiver_form.stopBits_label': 'Stop Bits',
  'receiver_form.maxInactivity_label': 'Maximum Inactivity',
  'receiver_form.dahua.api_label': 'DoLynk API URL',
  'receiver_form.dahua.api_placeholder': 'Enter DoLynk API URL',
  'receiver_form.dahua.access_key_label': 'DoLynk Access Key',
  'receiver_form.dahua.access_key_placeholder': 'Enter DoLynk access key',
  'receiver_form.dahua.sk_label': 'DoLynk Secret Key',
  'receiver_form.dahua.sk_placeholder': 'Enter DoLynk secret key',
  'receiver_form.dahua.product_id_label': 'DoLynk Product ID',
  'receiver_form.dahua.product_id_placeholder': 'Enter DoLynk product ID',
  'receiver_form.dahua.extra_required': 'All DoLynk fields are required.',
  'receiver_form.dahua.api_invalid':
    'Enter a valid DoLynk API URL (must start with http or https).',
  'receiver_form.traccar.url_label': 'Traccar API URL',
  'receiver_form.traccar.url_placeholder': 'Enter Traccar API URL',
  'receiver_form.traccar.user_label': 'Traccar Username',
  'receiver_form.traccar.user_placeholder': 'Enter Traccar username',
  'receiver_form.traccar.password_label': 'Traccar Password',
  'receiver_form.traccar.password_placeholder': 'Enter Traccar password',
  'receiver_form.traccar.url_invalid':
    'Enter a valid Traccar API URL (must start with http or https).',
  'receiver_form.traccar_api_not_reachable':
    'Could not connect to the API. Please verify the URL and credentials.',
  'receiver_form.risco.api_url_label': 'Risco Cloud API URL',
  'receiver_form.risco.api_url_placeholder':
    'Enter Risco Cloud API URL (optional)',
  'receiver_form.risco.proxy_host_label': 'Risco Proxy Host',
  'receiver_form.risco.proxy_host_placeholder':
    'Enter Risco proxy host (optional)',
  'receiver_form.risco.proxy_port_label': 'Risco Proxy Port',
  'receiver_form.risco.proxy_port_placeholder':
    'Enter Risco proxy port (optional)',
  'receiver_form.risco.username_label': 'Risco Username',
  'receiver_form.risco.username_placeholder': 'Enter Risco username (optional)',
  'receiver_form.risco.password_label': 'Risco Password',
  'receiver_form.risco.password_placeholder': 'Enter Risco password (optional)',
  'create_receiver_form.success_message': 'Receiver created successfully',
  'create_receiver_form.error_message': 'Error creating receiver',
  'create_receiver_form.prefix_required_error':
    'At least one prefix is required',
  'update_receiver_form.success_message': 'Receiver updated successfully',
  'update_receiver_form.error_message': 'Error updating receiver',
  'receiver_delete.success_message': 'Receiver deleted successfully',
  'receiver_delete.error_message': 'Error deleting receiver',
  // Workspace Shared Access
  'workspace.shared_access.title': 'Shared Access',
  'workspace.shared_access.my_workspace_id': 'My Workspace ID',
  'workspace.shared_access.id_copied': 'Workspace ID copied to clipboard',
  'workspace.shared_access.copy_error': 'Failed to copy workspace ID',
  'workspace.shared_access.loading': 'Loading shared access data...',
  'workspace.shared_access.fetch_error': 'Failed to load shared access data',
  'workspace.shared_access.error_loading':
    'Error while loading shared access data',
  'workspace.shared_access.incoming_title': 'Workspaces that can watch me',
  'workspace.shared_access.outgoing_title': 'Workspaces I can watch',
  'workspace.shared_access.no_incoming': 'No workspaces requesting access',
  'workspace.shared_access.no_outgoing': 'No outgoing access requests',
  'workspace.shared_access.add_new': 'Request to be Monitored',
  'workspace.shared_access.delete_title': 'Remove Shared Access',
  'workspace.shared_access.delete_message':
    'Are you sure you want to remove shared access for "{{workspaceName}}"? This action cannot be undone.',
  'workspace.shared_access.deleted_success':
    'Shared access removed successfully',
  'workspace.shared_access.delete_error': 'Failed to remove shared access',
  'workspace.shared_access.approved_success': 'Access request approved',
  'workspace.shared_access.rejected_success': 'Access request rejected',
  'workspace.shared_access.status_update_error':
    'Failed to update request status',
  'workspace.shared_access.request_sent': 'Access request sent successfully',
  'workspace.shared_access.request_error': 'Failed to send access request',
  'workspace.shared_access.workspace_not_found': 'Workspace not found',
  'workspace.shared_access.cannot_request_self':
    'Cannot request access to your own workspace',
  'workspace.shared_access.request_exists': 'Request already exists',
  'workspace.shared_access.access_exists': 'Access already granted',
  'workspace.shared_access.status.approved': 'Approved',
  'workspace.shared_access.status.pending': 'Pending',
  'workspace.shared_access.status.rejected': 'Rejected',
  'workspace.shared_access.actions.approve': 'Approve',
  'workspace.shared_access.actions.reject': 'Reject',
  'workspace.shared_access.actions.remove': 'Remove',
  'workspace.shared_access.form.description':
    'Enter the workspace ID that you want to REQUEST to monitor you. The workspace owner will need to approve your request to observe your devices.',
  'workspace.shared_access.form.workspace_id': 'Workspace ID',
  'workspace.shared_access.form.workspace_id_required':
    'Workspace ID is required',
  'workspace.shared_access.form.invalid_uuid':
    'Please enter a valid workspace ID',
  'workspace.shared_access.form.cannot_add_self':
    'Cannot request access to your own workspace',
  'workspace.shared_access.form.workspace_already_exists':
    'A request for this workspace already exists',
  'workspace.shared_access.form.send_request': 'Send Request',
  'workspace.shared_access.unknown_workspace': 'Unknown Workspace',

  'invitations.pending_state_label': 'Pending',
  'invitationItem.delete.title.confirmation': 'Delete Invitation',
  'invitationItem.delete.confirmation':
    'Are you sure you want to delete this invitation?',

  'createUserDialog.imageUploadFailed': 'Image upload failed',
  'createUserDialog.form.image': 'User image',
  'deviceUsertable.view_image': 'View user image',
  'createZoneDialog.imageUploadFailed': 'Image upload failed',
  'createZoneDialog.form.image': 'Zone image',
  'deviceZonetable.view_image': 'View zone image',
  'CreateEmergencyContact.imageUploadFailed': 'Image upload failed',
  'createEmergencyContact.form.image': 'Contact image',
  'createDeviceEmergencyContact.success':
    'Emergency contact created successfully',
  'createDeviceEmergencyContact.general.error':
    'Error creating emergency contact',
  'emergencyContactItem.view_image_error': 'No image available',
  'emergencyContactItem.view_image': 'View image',
  'emergencycontactItem.delete.title.confirmation': 'Delete emergency contact',
  'emergencycontactItem.delete.confirmation':
    'Are you sure you want to delete this emergency contact?',
  'emergencyContactItem.general.error': 'Error with emergency contact',
  'emergencyContact.select': 'Select emergency contact',
  'imageUploader.remove_image': 'Remove image',
  'imageUploader.drag_and_drop_or_click':
    'Drag and drop or click to select an image',
  'imageUploader.select_image': 'Select image',
  'createDeviceEmergencyContact.form.image': 'Image',
  // Common translations used in SharedAccess
  'error.forbidden_permissions':
    'You do not have the necessary permissions to perform this action.',
  'common.retry': 'Retry',
  'common.cancel': 'Cancel',
  'general.cancel': 'Cancel',
  'common.deleting': 'Deleting...',
  'common.copied': 'Copied!',
  'common.copy': 'Copy',
  'common.add': 'Add',
  'prefixLine.list.title': 'Prefix Lines',
  'prefixLine.prefix.label': 'Prefix',
  'prefixLine.line.label': 'Line',
  'prefixLine.list.empty': 'No items yet. Click "Add" to add your first item.',
  'prefix.range.prefix.label': 'Prefix',
  'prefix.range.from.label': 'From',
  'prefix.range.to.label': 'To',
  'receiver.prefix.title': 'Receiver Prefixes',
  'prefix.range.no_data': 'No prefix ranges found for this workspace.',
  'prefix.range.title': 'Prefix Ranges',
  'prefixRange.from.label': 'From',
  'prefixRange.to.label': 'To',
  'device_search.label': 'Search a device',
  'device_search.empty': 'No devices found',
  'device_search.loading': 'Loading devices...',
  'device_search.error': 'Error fetching devices',
  'delete.calendar.event.title.confirmation': 'Delete Calendar Event',
  'delete.calendar.event.body.confirmation':
    'Are you sure you want to delete this calendar event?',
  'deviceProfile.partitions.armed': 'Armed',
  'deviceProfile.partitions.disarmed': 'Disarmed',
  'deviceProfile.partitions.alarm': 'Alarm',
  'address.map.no.result': 'No results found for this address',
  'CustomRecurrenceForm.form.title': 'Custom Recurrence',
  'CustomRecurrenceForm.recurrence_days': 'Recurrence days',
  save: 'Save',
  repeatEvery: 'Repeat every',
  days: 'days',
  weeks: 'weeks',
  months: 'months',
  years: 'years',
  end: 'End',
  never: 'Never',
  occurrences: 'occurrences',
  'recurrence.end.never': 'Never',
  'recurrence.end.afterOccurrences': 'After occurrences',
  'occurrences.placeholder': '0',
  'reporters.username_text': 'Username',
  'reporters.email_text': 'Email',
  treinco_permissions_device_notification: 'Device Notification Permissions',
  'treinco_permissions_device_notification.create':
    'Create Device Notifications',
  'treinco_permissions_device_notification.update':
    'Update Device Notifications',
  'treinco_permissions_device_notification.delete':
    'Delete Device Notifications',
  'treinco_permissions_device_notification.view': 'View Device Notifications',
  treinco_permissions_integration: 'Integration',
  'treinco_permissions_integration.create': 'Create Integrations',
  'treinco_permissions_integration.update': 'Update Integrations',
  'treinco_permissions_integration.delete': 'Delete Integrations',
  'treinco_permissions_integration.view': 'View',
  treinco_permissions_label: 'Label',
  'treinco_permissions_label.create': 'Create Labels',
  'treinco_permissions_label.update': 'Update Labels',
  'treinco_permissions_label.delete': 'Delete Labels',
  'treinco_permissions_label.view': 'View Labels',
  treinco_permissions_notification_group: 'Notification Group',
  'treinco_permissions_notification_group.create': 'Create Notification Groups',
  'treinco_permissions_notification_group.update': 'Update Notification Groups',
  'treinco_permissions_notification_group.delete': 'Delete Notification Groups',
  'treinco_permissions_notification_group.view': 'View Notification Groups',
  treinco_permissions_workspace_to_workspace:
    'Workspace to Workspace Permissions',
  'treinco_permissions_workspace.shared_access.create': 'Create Shared Access',
  'treinco_permissions_workspace.shared_access.manage': 'Manage Shared Access',
  'treinco_permissions_workspace.shared_access.view': 'View Shared Access',
  'treinco_permissions_workspace.shared_access.delete': 'Delete Shared Access',
  treinco_permissions_device_cctv_channel: 'Device CCTV Channel',
  treinco_permissions_attachment: 'Attachment',
  'treinco_permissions_workspace.user_management': 'User management',
  treinco_permissions_apiKey: 'API Key',
  'treinco_permissions_api_key.create': 'Create API Keys',
  'treinco_permissions_api_key.revoke': 'Revoke API Keys',
  'treinco_permissions_api_key.view': 'View API Keys',

  'userItem.addRole': 'Add Role',

  'history.event.loading_or_not_exist':
    'Loading event data or event does not exist',
  'emergencyContactListTable.edit.emergencyContactList':
    'Edit Emergency Contact List',
  'emergencyContactListTable.delete.emergencyContactList':
    'Delete Emergency Contact List',

  'resolutionTable.edit.resolution': 'Edit predefined message',
  'resolutionTable.delete.resolution': 'Delete predefined message',
  'resolutionItem.delete.title.confirmation': 'Delete predefined message',
  'resolutionItem.delete.success': 'Resolution deleted successfully',
  'resolutionItem.delete.confirmation':
    'Are you sure you want to delete this predefined message?',
  'eventGroupTable.delete.eventGroup': 'Delete Event Group',
  'eventItem.delete.title.confirmation': 'Delete Event',
  'eventItem.delete.confirmation':
    'Are you sure you want to delete this event?',
  'eventItem.general.error': 'Error deleting event',

  'eventGroupItem.delete.title.confirmation': 'Delete Event Group',
  'eventGroupItem.delete.confirmation':
    'Are you sure you want to delete this event group?',

  'common.yes': 'Yes',
  'common.no': 'No',
  'common.generic_error': 'Unexpected error',
  'common.update': 'Update',
  'event.position': 'Position',
  'qr.no_points_available': 'No points available to generate QR codes.',
  'change.avatar.success': 'Updated profile picture',
  'change.avatar.error': 'Error updating profile picture',
  // recorridos

  'routeSearch.search.title': 'Search routes',
  'routeSearch.server.time': 'Server Time',
  'routeSearch.gps.time': 'GPS Time',
  'routeSearch.form.startDate': 'Start date',
  'routeSearch.form.endDate': 'End date',
  'routeSummary.empty.events': 'No existing routes',
  'places.places_field_text': 'Places',
  'device_profile.places_tab_title': 'Places',
  'device_profile.points_tab_title': 'Points',
  'device_profile.points.name_column': 'Name',
  'device_profile.points.identifier_column': 'Identifier',
  'device_profile.points.description_column': 'Description',
  'device_profile.points.type_column': 'Type',
  'device_profile.points.actions_column': 'Actions',
  'device_profile.points.group_column': 'Place',
  'device_profile.points.without_place_group': 'Without place',
  'device_profile.rounds_tab_identifier': 'Identifier',
  'point.button_add': 'Create Point',
  'device_search.start_typing': 'Start typing to search for devices',
  'device_search.minimum_length': 'Enter at least two characters to search',
  'device_search.helper': 'Search by device name, ID, or workspace prefix',
  'device_search.unnamed_device': 'Unnamed device',
  'create_reporter_user.success_created': 'User created successfully',
  'create_reporter_user.success_assigned':
    'User already exists and has been assigned as reporter. Existing user data was preserved.',
  'create_reporter_user.error_creating': 'Error creating user',
  'create_reporter_user.error_user_exist':
    'A user with this email or username already exists',
  'device_profile.subscriptions_tab_title': 'Subscriptions',
  'subscriptions.table.id': 'ID',
  'subscriptions.table.plan': 'Plan',
  'subscriptions.table.plan_item': 'Plan / Item',
  'subscriptions.table.no_plan': 'No plan',
  'subscriptions.table.status': 'Status',
  'subscriptions.table.start_date': 'Start date',
  'subscriptions.table.end_date': 'End date',
  'subscriptions.table.billing_timing': 'Billing timing',
  'subscriptions.table.billing_anchor': 'Anchor day',
  'subscriptions.table.end_of_month': 'EOM',
  'subscriptions.table.day_n': 'Day {{n}}',
  'subscriptions.table.items_count': '# Items',
  'subscriptions.table.next_billing_date': 'Next billing date',
  'subscriptions.table.total_monthly_cost': 'Total monthly cost',
  'subscriptions.table.actions': 'Actions',
  'subscriptions.add': 'Create subscription',
  'subscriptions.create_success': 'Subscription created',
  'subscriptions.update_success': 'Subscription updated',
  'subscriptions.delete_success': 'Subscription deleted',
  'subscriptions.delete.error': 'Error deleting subscription',
  'subscriptions.save_error': 'Error saving subscription',
  'subscriptions.actions.pause': 'Pause subscription',
  'subscriptions.actions.resume': 'Resume subscription',
  'subscriptions.actions.cancel': 'Cancel subscription',
  'subscriptions.actions.history': 'View billing history',
  'subscriptions.actions.view': 'View',
  'subscriptions.actions.add_item': 'Add item',
  'subscriptions.history_coming_soon': 'Billing history coming soon',
  'subscriptions.items.modal_title': 'Subscription items',
  'subscriptions.items.add': 'Add item',
  'subscriptions.items.create_success': 'Subscription item created',
  'subscriptions.items.update_success': 'Subscription item updated',
  'subscriptions.items.delete_success': 'Subscription item deleted',
  'subscriptions.items.delete.title.confirmation': 'Delete Subscription Item',
  'subscriptions.items.delete.confirmation':
    'Are you sure you want to delete this subscription item? This action cannot be undone.',
  'subscriptions.items.save_to_manage':
    'Select a plan to preview items or save the subscription to manage them.',
  'subscriptions.form.edit_title': 'Edit subscription',
  'subscriptions.form.create_title': 'Create subscription',
  'subscriptions.form.plan_id': 'Plan',
  'subscriptions.form.plan_none': 'No plan',
  'subscriptions.form.status': 'Status',
  'subscriptions.form.start_date': 'Start date',
  'subscriptions.form.end_date': 'End date',
  'subscriptions.form.billing_timing': 'Billing timing',
  'subscriptions.form.billing_anchor': 'Billing anchor day (-1 or 1..31)',
  'subscriptions.form.status.active': 'Active',
  'subscriptions.form.status.paused': 'Paused',
  'subscriptions.form.status.finished': 'Finished',
  'subscriptions.form.status.cancelled': 'Cancelled',
  'subscriptions.form.timing.in_advance': 'In advance',
  'subscriptions.form.timing.in_arrears': 'In arrears',
  'subscriptions.form.save': 'Save',
  'subscriptions.form.create': 'Create',
  'subscriptions.form.cancel': 'Cancel',
  'subscriptions.form.field_immutable': 'Cannot be changed after creation',
  'subscriptions.form.end_date_error': 'End date must be after start date',
  'subscriptions.form.items_in_treeview':
    'Subscription items can be managed in the table below by expanding the subscription row.',
  'subscriptions.items.plan_preview': 'Plan items preview',
  'subscriptions.items.select_plan_preview':
    'Select a plan to preview items that will be created.',
  'subscriptions.items.form.edit_title': 'Edit subscription item',
  'subscriptions.items.form.create_title': 'Add subscription item',
  'subscriptions.items.form.item': 'Item',
  'subscriptions.items.form.charge_type': 'Charge type',
  'subscriptions.items.form.billing_period': 'Billing period',
  'subscriptions.items.form.every_n': 'Every N',
  'subscriptions.items.form.total_cycles': 'Total cycles',
  'subscriptions.items.form.unit_price': 'Unit price',
  'subscriptions.items.form.status': 'Status',
  'subscriptions.items.form.cancel': 'Cancel',
  'subscriptions.items.form.save': 'Save',
  'subscriptions.items.form.add': 'Add',
  'subscriptions.items.form.helper.every_n': 'Step size; default 1',
  'subscriptions.items.form.helper.total_cycles':
    'For installments must be > 0; null for unlimited recurring',
  'subscriptions.items.form.status.active': 'Active',
  'subscriptions.items.form.status.paused': 'Paused',
  'subscriptions.items.form.status.finished': 'Finished',
  'subscriptions.items.form.status.cancelled': 'Cancelled',
  'subscriptions.items.form.field_immutable':
    'Cannot be changed after creation',
  'subscriptions.items.form.charge_type.one_time': 'One time',
  'subscriptions.items.form.charge_type.recurring': 'Recurring',
  'subscriptions.items.form.charge_type.installment': 'Installment',
  'subscriptions.items.form.billing_period.day': 'Day',
  'subscriptions.items.form.billing_period.month': 'Month',
  'subscriptions.items.form.billing_period.year': 'Year',
  'subscriptions.confirm.pause_title': 'Pause Subscription',
  'subscriptions.confirm.pause_description':
    'Are you sure you want to pause this subscription? Billing will be suspended until resumed.',
  'subscriptions.confirm.cancel_title': 'Cancel Subscription',
  'subscriptions.confirm.cancel_description':
    'Are you sure you want to cancel this subscription? This action cannot be undone and no further billing will occur.',
  'subscriptions.pause_success': 'Subscription paused',
  'subscriptions.resume_success': 'Subscription resumed',
  'subscriptions.cancel_success': 'Subscription cancelled',
  'subscriptions.prorating.title': 'Prorated Billing Required',
  'subscriptions.prorating.description':
    'The subscription start date creates an uncovered service gap. This happens when service starts before the next regular billing date.',
  'subscriptions.prorating.items_with_gaps':
    'Items requiring prorated billing:',
  'subscriptions.prorating.item': 'Item',
  'subscriptions.prorating.gap_period': 'Gap Period',
  'subscriptions.prorating.next_billing': 'Next Regular Billing',
  'subscriptions.prorating.prorated_amount': 'Prorated Amount',
  'subscriptions.prorating.total': 'Total',
  'subscriptions.prorating.choice_description':
    'You can either create a prorated invoice now to cover the gap period, or skip prorating and start billing from the next regular billing date.',
  'subscriptions.prorating.skip': 'Skip Prorating',
  'subscriptions.prorating.create_invoice': 'Create Prorated Invoice',
  'subscriptions.prorating.invoice_created': 'Prorated invoice created',
  'subscriptions.cancellation.title': 'Unbilled Service',
  'subscriptions.cancellation.description':
    'There is unbilled service that was provided but not yet invoiced.',
  'subscriptions.cancellation.items_with_gaps': 'Items:',
  'subscriptions.cancellation.unbilled_period': 'Period',
  'subscriptions.cancellation.choice_description': 'Create an invoice or skip.',
  'subscriptions.cancellation.skip': 'Skip',
  'subscriptions.cancellation.create_invoice': 'Create Invoice',
  'subscriptions.cancellation.invoice_created': 'Invoice created',
  'subscriptions.pause.title': 'Unbilled Service',
  'subscriptions.pause.description':
    'There is unbilled service that was provided but not yet invoiced.',
  'subscriptions.pause.items_with_gaps': 'Items:',
  'subscriptions.pause.choice_description': 'Create an invoice or skip.',
  'subscriptions.pause.skip': 'Skip',
  'subscriptions.pause.create_invoice': 'Create Invoice',
  'subscriptions.pause.invoice_created': 'Invoice created',
  'subscriptions.resume.title': 'Service Gap on Resume',
  'subscriptions.resume.description':
    'Resuming this subscription will create a service gap between today and the next billing date. The billing schedule will be recalculated from today.',
  'subscriptions.resume.items_with_gaps': 'Items with service gaps:',
  'subscriptions.resume.choice_description':
    'You can create a prorated invoice for the gap period, or skip and give the gap period as free service.',
  'subscriptions.resume.skip': 'Skip Prorating',
  'subscriptions.resume.create_invoice': 'Create Prorated Invoice',
  'subscriptions.resume.prorated_invoice_created':
    'Prorated invoice created for service gap',
  'subscriptions.resume.new_next_billing': 'New Next Billing',
  'subscriptions.confirm.resume_title': 'Resume Subscription',
  'subscriptions.confirm.resume_description':
    'Are you sure you want to resume this subscription? Billing will continue from the next scheduled date.',
  // Subscription Items
  'subscriptionItems.form.charge_type.one_time': 'One time',
  'subscriptionItems.form.charge_type.recurring': 'Recurring',
  'subscriptionItems.form.charge_type.installment': 'Installment',
  'subscriptionItems.form.billing_period.day': 'Day',
  'subscriptionItems.form.billing_period.month': 'Month',
  'subscriptionItems.form.billing_period.year': 'Year',
  'subscriptionItems.form.status.active': 'Active',
  'subscriptionItems.form.status.paused': 'Paused',
  'subscriptionItems.form.status.finished': 'Finished',
  'subscriptionItems.form.status.cancelled': 'Cancelled',
  'subscriptionItems.table.item': 'Item',
  'subscriptionItems.table.status': 'Status',
  'subscriptionItems.table.charge_type': 'Charge type',
  'subscriptionItems.table.billing_period': 'Billing period',
  'subscriptionItems.table.every_n': 'Every N',
  'subscriptionItems.table.unit_price': 'Unit price',
  'subscriptionItems.table.next_billing': 'Next billing',
  'subscriptionItems.table.cycles': 'Cycles',
  'subscriptionItems.table.actions': 'Actions',
  'subscriptionItems.actions.edit': 'Edit',
  'subscriptionItems.actions.delete': 'Delete',
  'subscriptionItems.actions.pause': 'Pause',
  'subscriptionItems.actions.resume': 'Resume',
  'subscriptionItems.actions.cancel': 'Cancel',
  'subscriptionItems.confirm.delete_title': 'Delete Subscription Item',
  'subscriptionItems.confirm.delete_description':
    'Are you sure you want to delete this subscription item? This action cannot be undone.',
  'subscriptionItems.confirm.pause_title': 'Pause Subscription Item',
  'subscriptionItems.confirm.pause_description':
    'Are you sure you want to pause this subscription item? It will stop being billed until resumed.',
  'subscriptionItems.confirm.resume_title': 'Resume Subscription Item',
  'subscriptionItems.confirm.resume_description':
    'Are you sure you want to resume this subscription item? Billing will continue from the next scheduled date.',
  'subscriptionItems.confirm.cancel_title': 'Cancel Subscription Item',
  'subscriptionItems.confirm.cancel_description':
    'Are you sure you want to cancel this subscription item? This action cannot be undone.',
  'subscriptionItems.pause_success': 'Subscription item paused',
  'subscriptionItems.resume_success': 'Subscription item resumed',
  'subscriptionItems.cancel_success': 'Subscription item cancelled',
  'planItems.table.item': 'Item',
  'planItems.table.charge_type': 'Charge type',
  'planItems.table.billing_period': 'Billing period',
  'planItems.table.every_n': 'Every N',
  'planItems.table.cycles': 'Cycles',
  'planItems.table.default_price': 'Default price',
  'planItems.table.actions': 'Actions',
  'planItems.create_success': 'Plan item created',
  'planItems.update_success': 'Plan item updated',
  'planItems.delete_success': 'Plan item deleted',
  'planItems.delete_error': 'Error deleting plan item',
  'planItems.delete_confirm': 'Delete this plan item?',
  'items.table.name': 'Name',
  'items.table.type': 'Type',
  'items.table.recurring': 'Recurring',
  'items.table.default_price': 'Default price',
  'items.table.tax_rate': 'Tax rate (%)',
  'items.table.active': 'Active',
  'items.table.actions': 'Actions',
  'items.add': 'Create item',
  'items.create_success': 'Item created',
  'items.update_success': 'Item updated',
  'items.delete_success': 'Item deleted',
  'items.save_error': 'Error saving item',
  'items.delete_error': 'Error deleting item',
  'items.form.title_create': 'Create item',
  'items.form.title_edit': 'Edit item',
  'items.form.name': 'Name',
  'items.form.type': 'Type',
  'items.form.recurring': 'Is recurring',
  'items.form.default_price': 'Default price',
  'items.form.tax_rate': 'Tax rate (%)',
  'items.form.sku': 'SKU',
  'items.form.active': 'Active',
  'items.search_error': 'Error loading items',
  'items.add_new': 'Add new',
  'items.delete_error_in_use_invoice':
    'Cannot delete this item as it is being used in one or more invoices.',
  'items.delete_error_in_use_plan':
    'Cannot delete this item as it is being used in one or more plans.',
  'items.delete_error_in_use_subscription':
    'Cannot delete this item as it is being used in one or more subscriptions.',
  'invoices.items.select_item': 'Select Item',
  'invoices.items.item_required': 'Item is required',
  'invoices.items.not_editable_message':
    'Item details cannot be edited for finalized invoices.',
  'plans.table.name': 'Name',
  'plans.table.description': 'Description',
  'plans.table.isActive': 'Active',
  'plans.table.items': '# Items',
  'plans.table.actions': 'Actions',
  'plans.add': 'Create plan',
  'plans.create_success': 'Plan created',
  'plans.update_success': 'Plan updated',
  'plans.delete_success': 'Plan deleted',
  'plans.delete_error': 'Error deleting plan',
  'plans.save_error': 'Error saving plan',
  'plans.form.title_create': 'Create plan',
  'plans.form.title_edit': 'Edit plan',
  'plans.form.name': 'Name',
  'plans.form.description': 'Description',
  'plans.form.active': 'Active',
  'plans.details.title': 'Plan details',
  'plans.details.add_item': 'Add item',
  'plans.delete.error': 'Error deleting plan',
  'plans.actions.edit': 'Edit',
  'plans.actions.add_item': 'Add item',
  'plans.actions.delete': 'Delete',
  'common.save': 'Save',
  'common.create': 'Create',
  'common.loading': 'Loading...',
  'common.back': 'Back',
  'common.continue': 'Continue',
  'common.done': 'Done',

  // Plan Items Form
  'planItems.form.title_create': 'Add plan item',
  'planItems.actions.edit': 'Edit',
  'planItems.actions.delete': 'Delete',
  'planItems.form.title_edit': 'Edit plan item',
  'planItems.form.item': 'Item',
  'planItems.form.charge_type': 'Charge type',
  'planItems.form.billing_period': 'Billing period',
  'planItems.form.billing_period_helper':
    'Required for recurring and installment',
  'planItems.form.every_n': 'Every N',
  'planItems.form.every_n_helper': 'Step size; default 1',
  'planItems.form.cycles': 'Cycles',
  'planItems.form.cycles_helper':
    'For installments must be > 0; null for unlimited recurring',
  'planItems.form.default_price': 'Default price',
  'planItems.form.charge_type.one_time': 'One time',
  'planItems.form.charge_type.recurring': 'Recurring',
  'planItems.form.charge_type.installment': 'Installment',
  'planItems.form.billing_period.day': 'Day',
  'planItems.form.billing_period.month': 'Month',
  'planItems.form.billing_period.year': 'Year',
  'planItems.save_error': 'Error saving plan item',

  // Items Form - Type options
  'items.form.type.product': 'Product',
  'items.form.type.service': 'Service',

  // Invoice Series Form - Additional validations
  'invoice_series.form.name_max': 'Name must be less than 100 characters',
  'invoice_series.form.prefix_max': 'Prefix must be less than 10 characters',
  'invoice_series.form.prefix_format':
    'Prefix must only contain uppercase letters and numbers',
  'invoice_series.form.current_number': 'Current number',
  'invoice_series.form.next_invoice_will_be': 'Next invoice will be',
  'invoice_series.form.inactive_warning':
    'Inactive series cannot be used for new invoices',
  'invoice_series.form.create_success': 'Invoice series created successfully',
  'invoice_series.form.update_success': 'Invoice series updated successfully',
  'invoice_series.form.create_error': 'Error creating invoice series',
  'invoice_series.form.update_error': 'Error updating invoice series',

  // Invoice Create Form - Series
  'invoices.create.series': 'Invoice Series',
  'invoices.create.series_helper':
    'Select a series for automatic numbering, or leave empty to enter manually',
  'invoices.create.no_series_available':
    'No active invoice series available. You must enter an invoice number manually.',

  // Subscription Item Form - Errors
  'subscriptions.items.form.errors.item_required': 'Item is required',
  'subscriptions.items.form.errors.total_cycles_required':
    'Total cycles must be greater than 0 for installments',
  'subscriptions.items.form.errors.unit_price_required':
    'Unit price is required',
  'subscriptions.items.form.next_run': 'Next billing',

  // Plans Table - Items count fix
  'plans.table.items_count': '# Items',

  // Invoice Detail - Finalize
  'invoices.detail.finalize_invoice': 'Finalize Invoice',
  'invoices.detail.finalize_confirmation_title': 'Finalize Invoice',
  'invoices.detail.finalize_warning': 'Warning: This action cannot be undone.',
  'invoices.detail.finalize_confirmation_message':
    'Once finalized, this invoice cannot be edited. The status will change from draft to final.',
  'invoices.detail.finalize_button': 'Finalize',
  'invoices.detail.finalize_success': 'Invoice finalized successfully',
  'invoices.detail.series': 'Series',
  'invoices.detail.total': 'Total',
  'invoices.detail.items_count': 'Items',

  // Billing Run
  'billing.run.button': 'Run Billing',
  'billing.run.title': 'Run Billing',
  'billing.run.select_date': 'Select billing date',
  'billing.run.preview': 'Preview',
  'billing.run.generate': 'Generate {{count}} Invoices',
  'billing.run.no_items_due':
    'No subscription items are due for billing on this date',
  'billing.run.success': '{{count}} draft invoices created successfully',
  'billing.run.preview_error': 'Failed to generate preview',
  'billing.run.execute_error': 'Failed to generate invoices',
  'billing.run.cancel': 'Cancel',
  'billing.run.customer': 'Customer',
  'billing.run.items': 'Items',
  'billing.run.subtotal': 'Subtotal',
  'billing.run.tax': 'Tax',
  'billing.run.total': 'Total',
  'billing.run.invoices_count': 'Invoices',
  'billing.run.total_amount': 'Total Amount',
  'billing.run.billing_date': 'Billing Date',
  'billing.run.already_billed':
    '{{count}} items already billed for this period (excluded)',
  'billing.run.items_detail': 'Items',
  'billing.run.device': 'Device',
  'billing.run.item_name': 'Item',
  'billing.run.charge_type': 'Type',
  'billing.run.service_period': 'Service Period',
  'billing.run.amount': 'Amount',

  // Table Filters
  'filters.value': 'Value',
  'filters.select_option': 'Select...',
  'filters.is_operator_label': 'is',
  'filters.not_operator_label': 'is not',
  'filters.is_any_of_operator_label': 'is any of',
  'filters.not_contains_operator_label': 'not contains',
  'filters.not_equals_operator_label': 'not equals',
  'filters.select_user': 'Select user',
  'CustomBooleanFilterInput.label_text': 'Value',
  'CustomBooleanFilterInput.select_value_label': 'Select...',
  'CustomBooleanFilterInput.any_value_label': 'Any',
  'CustomBooleanFilterInput.true_value_label': 'Yes',
  'CustomBooleanFilterInput.false_value_label': 'No',

  // VoIP translations
  'voip.extension_not_configured': 'VoIP Extension Not Configured',
  'voip.debug_title': 'VoIP Debug',
  'voip.debug_ua_label': 'UA:',
  'voip.debug_registered_label': 'Registered:',
  'voip.debug_call_label': 'Call:',
  'voip.debug_muted_label': 'Muted:',
  'voip.debug_hold_label': 'Hold:',
  'voip.status_connected': 'VoIP Connected',
  'voip.status_connecting': 'Connecting...',
  'voip.status_connection_failed': 'Connection Failed',
  'voip.status_offline': 'VoIP Offline',
  'voip.status_label': 'VoIP',
  'voip.debug_panel_hide': 'Hide debug panel',
  'voip.debug_panel_show': 'Show debug panel',
  'voip.not_connected': 'VoIP not connected',
  'voip.extension_not_available': 'VoIP extension not available',
  'voip.cannot_call_editing': 'Cannot call while editing',
  'voip.make_call': 'Make call',
  'voip.incoming_call': 'Incoming Call',
  'voip.calling': 'Calling...',
  'voip.connecting': 'Connecting...',
  'voip.on_hold': 'On Hold',
  'voip.call_ended': 'Call Ended',
  'voip.unknown': 'Unknown',
  'voip.select_number': 'Select Number',

  'treinco_table.error_message': 'An error occurred while loading data.',

  // Leaflet Draw localizations
  'leafletDraw.draw.handlers.circle.tooltip.start':
    'Click and drag to draw circle.',
  'leafletDraw.draw.handlers.circle.radius': 'Radius',
  'leafletDraw.draw.handlers.circlemarker.tooltip.start':
    'Click map to place circle marker.',
  'leafletDraw.draw.handlers.marker.tooltip.start':
    'Click map to place marker.',
  'leafletDraw.draw.handlers.polygon.tooltip.start':
    'Click to start drawing shape.',
  'leafletDraw.draw.handlers.polygon.tooltip.cont':
    'Click to continue drawing shape.',
  'leafletDraw.draw.handlers.polygon.tooltip.end':
    'Click first point to close this shape.',
  'leafletDraw.draw.handlers.polyline.error':
    '<strong>Error:</strong> shape edges cannot cross!',
  'leafletDraw.draw.handlers.polyline.tooltip.start':
    'Click to start drawing line.',
  'leafletDraw.draw.handlers.polyline.tooltip.cont':
    'Click to continue drawing line.',
  'leafletDraw.draw.handlers.polyline.tooltip.end':
    'Click last point to finish line.',
  'leafletDraw.draw.handlers.rectangle.tooltip.start':
    'Click and drag to draw rectangle.',
  'leafletDraw.draw.handlers.simpleshape.tooltip.end':
    'Release mouse to finish drawing.',

  'deviceMap.waiting.position': 'Waiting for the first GPS signal',
  'deviceMap.waiting.position.description':
    'We are waiting for your device to send its first signal. This usually happens automatically as soon as the GPS detects movement or satellite signal.',

  // device mirror
  'deviceSettings.form.mirroredDevicesTitle': 'Mirror Devices',
  'deviceSettings.form.mirroredDevices': 'Mirrored devices',
  'device_profile.reports_tab_title': 'Reports',

  // Event Report — Event Report (Device Profile)
  'device_profile.event_report.card.title': 'Event Report',
  'device_profile.event_report.card.description':
    'View and export device events filtered by date range and event types.',
  // Rounds Report — Rounds Report (Device Profile)
  'device_profile.rounds_report.card.title': 'Rounds Report',
  'device_profile.rounds_report.card.description':
    'View events recorded during patrol and guard tour rounds.',
  'device_profile.event_report.title': 'Event Report',
  'device_profile.event_report.filters.device': 'Device',
  'device_profile.event_report.filters.start_date': 'Start Date',
  'device_profile.event_report.filters.end_date': 'End Date',
  'device_profile.event_report.filters.event_types': 'Event Types',
  'device_profile.event_report.filters.event_types_placeholder':
    'Select event types...',
  'device_profile.event_report.filters.search': 'Search',
  'device_profile.event_report.filters.clear': 'Clear',
  'device_profile.event_report.table.date': 'Date',
  'device_profile.event_report.table.event_type': 'Event Type',
  'device_profile.event_report.table.description': 'Description',
  'device_profile.event_report.table.no_search_prompt':
    'Select filters and press Search to view results',
  'device_profile.event_report.chart.title': 'Event Distribution by Type',
  'device_profile.event_report.chart.x_axis_label': 'Count',
  'device_profile.event_report.chart.series_label': 'Events',

  // CCTV channel screenshots (CAM-SCREENSHOT)
  'table.more_options.channel_screenshots': 'Screenshots',
  'channelScreenshots.title': 'Reference Screenshots',
  'channelScreenshots.latest_label': 'Latest screenshot',
  'channelScreenshots.capture_button': 'Take Screenshot',
  'channelScreenshots.capturing': 'Capturing...',
  'channelScreenshots.view_history': 'View history',
  'channelScreenshots.view_history_full': 'View screenshot history',
  'channelScreenshots.refresh_latest': 'Refresh',
  'channelScreenshots.history_title': 'Screenshot History',
  'channelScreenshots.history_date_field': 'Date',
  'channelScreenshots.history_uploader_field': 'Uploaded by',
  'channelScreenshots.load_error': 'The screenshot could not be loaded',
  'channelScreenshots.empty_state': 'No screenshots uploaded yet.',
  'channelScreenshots.uploaded_by': 'Uploaded {{date}} by {{uploader}}',
  'channelScreenshots.success_upload': 'Screenshot uploaded successfully.',
  'channelScreenshots.error_upload':
    'Screenshot upload failed. Please try again.',
  'channelScreenshots.error_getting_upload_url': 'Could not get upload URL.',
  'channelScreenshots.delete_confirm_title': 'Delete Screenshot',
  'channelScreenshots.delete_confirm_description':
    'This screenshot will be permanently deleted. This action cannot be undone.',
  'channelScreenshots.delete_success': 'Screenshot deleted.',
  'channelScreenshots.delete_error':
    'Error deleting the screenshot. Please try again.',

  // --- Telegram notification channel ---
  'integrations_table.telegram_type_text': 'Telegram',
  'integrations.telegram.delete_warning':
    'This deletes the workspace Telegram bot. {{notifications}} notification(s) across {{devices}} device(s) will stop being delivered over Telegram, with no fallback to push. This cannot be undone.',
  'integrations_form.telegram_setup_help':
    'Create a bot with /newbot in BotFather, upload your company logo with /setuserpic, then paste the token here. The logo can only be uploaded from BotFather.',
  'integrations_form.telegram_bot_token_field': 'Bot token',
  'integrations_form.telegram_bot_token_helper':
    'Stored securely and never shown in full again. Leave it as is to keep the current one.',
  'integrations_form.telegram_bot_username_field': 'Bot username',
  'device_notifications.form.type_email': 'Email',
  'device_notifications.form.channel_unavailable_telegram':
    'set up the bot in Settings > Integrations',
  'device_notifications.form.channel_unavailable_email':
    'set up a mail server in Settings > Integrations',
  // --- Workspace SMTP email channel ---
  'integrations_table.smtp_type_text': 'Email (SMTP)',
  'integrations_form.smtp_setup_help':
    'Device alerts go out through this server, under your own name. Use a relay or a mailbox that is allowed to send as the address below.',
  'integrations_form.smtp_host_field': 'Server',
  'integrations_form.smtp_port_field': 'Port',
  'integrations_form.smtp_port_helper':
    '587 or 2525 for STARTTLS, 465 for implicit TLS.',
  'integrations_form.smtp_user_field': 'Username',
  'integrations_form.smtp_pass_field': 'Password',
  'integrations_form.smtp_pass_helper':
    'Stored securely and never shown in full again. Leave it as is to keep the current one.',
  'integrations_form.smtp_from_email_field': 'Sender address',
  'integrations_form.smtp_from_email_helper':
    'What recipients see. The server has to be allowed to send as this address.',
  'integrations_form.smtp_from_name_field': 'Sender name',
  'integrations_form.smtp_reply_email_field': 'Reply-To address',
  'integrations_form.smtp_reply_email_helper':
    'Where replies go. Defaults to the sender address.',
  'integrations_form.smtp_require_tls_field': 'Require an encrypted connection',
  'device_notifications.telegram.invite_title': 'Connect Telegram',
  'device_notifications.telegram.invite_explanation':
    'Telegram only lets a bot write to someone after they start the chat. Send each contact their personal link - by email if we have their address, or copy it and send it however you already talk to them.',
  'device_notifications.telegram.send_invite': 'Send email',
  'device_notifications.telegram.get_link': 'Get link',
  'device_notifications.telegram.link_ready': 'Link ready - copy it below',
  'device_notifications.telegram.copy_link': 'Copy link',
  'device_notifications.telegram.link_copied': 'Link copied to the clipboard',
  'device_notifications.telegram.no_email_on_file': 'No email on file',
  'notification_contacts.table.telegram': 'Telegram',
  'notification_contacts.table.telegram_linked': 'Connected',
  'notification_contacts.table.telegram_not_linked': 'Not connected',
  'integration_errors.SMTP_VERIFICATION_FAILED':
    'The mail server refused the connection: {{reason}}',
  'integration_errors.TELEGRAM_VERIFICATION_FAILED':
    'Telegram rejected the bot token: {{reason}}',
  'integration_errors.SMTP_CONFIG_INCOMPLETE':
    'Server, username, password and sender address are all required.',
  'integration_errors.CREDENTIAL_REQUIRED_FOR_NEW_DESTINATION':
    'You changed the server, so enter the password again - the stored one is never sent to a new host.',
  'integration_errors.TELEGRAM_BOT_TOKEN_REQUIRED': 'A bot token is required.',
  'integration_errors.TELEGRAM_BOT_NOT_CONNECTED':
    'The workspace bot is not connected. Check its token in Settings → Integrations.',
  'integration_errors.TELEGRAM_API_URL_NOT_CONFIGURED':
    'Treinco is not reachable from Telegram yet. Contact support.',
  'integration_errors.TELEGRAM_INTEGRATION_ALREADY_EXISTS':
    'This workspace already has a Telegram bot.',
  'integration_errors.SMTP_INTEGRATION_ALREADY_EXISTS':
    'This workspace already has a mail server.',
  'device_notifications.delivery.reachable_count':
    '{{reachable}} of {{total}} reachable',
  'device_notifications.delivery.no_recipients': 'No recipients',
  'device_notifications.email.no_mail_server': 'No mail server',
  'device_notifications.email.missing_address':
    'Some contacts have no email address',
  'notification_contacts.invite_telegram': 'Invite to Telegram',
  'notification_contacts.delete_warning':
    'This contact stops receiving alerts on every notification that lists them. Notifications with other recipients keep working.',
  'device_notifications.telegram.no_bot': 'No bot configured',
  'device_notifications.telegram.resend_invite':
    'Resend invitation to the remaining contacts',
  'device_notifications.telegram.invite_sent': 'Invitation sent',
  'device_notifications.telegram.invite_error': 'Could not send the invitation',
  'notifications_table.delivery_field_text': 'Delivery',
  // --- SMS channel through Android phones ---
  'device_notifications.form.type_sms': 'SMS',
  'device_notifications.form.channel_unavailable_sms':
    'set up the SMS gateway in Settings > Integrations',
  'device_notifications.sms.no_gateway': 'No SMS gateway',
  'device_notifications.sms.missing_phone': 'Some contacts have no phone',
  'notification_contacts.table.phone': 'Phone',
  'notification_contacts.form.phone': 'Phone',
  'notification_contacts.form.phone_helper':
    'Optional. Needed for SMS alerts. With the country code, e.g. +34600111222.',
  'notification_contacts.validation.phone_invalid':
    'Invalid phone: include the country code, e.g. +34600111222',
  'integrations_table.sms_gateway_type_text': 'SMS (Android phones)',
  'integrations_form.sms_gateway_setup_help':
    'SMS go out from the workspace\'s own Android phones, with their SIMs. Saving creates the gateway account; then add each phone from the "Phones" menu with a one-time code. With several phones, sends are spread across them and, if one does not respond, the SMS moves to another.',
  'integration_errors.SMS_GATEWAY_SETUP_FAILED':
    'Could not create the SMS gateway account. Reason: {{reason}}',
  'integration_errors.SMS_GATEWAY_NOT_CONFIGURED':
    "Treinco's SMS gateway is not set up yet. Contact support.",
  'integration_errors.SMS_GATEWAY_ACCOUNT_REJECTED':
    "The SMS gateway no longer accepts this workspace's account (it was deleted, or someone changed its password from a phone). Delete the integration, create it again and add the phones again.",
  'integration_errors.SMS_GATEWAY_DEVICE_NOT_REMOVED':
    'The phone could not be removed from the gateway. Try again: until then the phones may show as silent, though they keep sending.',
  'integration_errors.SMS_GATEWAY_WEBHOOK_NOT_PUBLISHED':
    'The phone was removed, but the gateway did not get the new ping secret: the other phones may show as silent. Save the integration to retry.',
  'integration_errors.SMS_GATEWAY_INTEGRATION_ALREADY_EXISTS':
    'This workspace already has an SMS gateway.',
  'sms_gateway.devices_menu_label': 'Phones',
  'sms_gateway.devices_title': 'SMS gateway phones',
  'sms_gateway.add_phone': 'Add phone',
  'sms_gateway.add_phone_steps':
    '1. Install the SMS Gateway app on the Android phone (the APK version Treinco specifies).\n2. In the app settings, under "Cloud server", enter the server URL below and choose the "SSE only" notification channel. Do it before signing in, so the phone never goes through the app author\'s push service.\n3. Sign in with the "By code" tab and enter the code.',
  'sms_gateway.server_url': 'Server URL',
  'sms_gateway.login_code': 'One-time code',
  'sms_gateway.code_valid_until': 'Valid until {{time}}',
  'sms_gateway.code_error': 'Could not create the code',
  'sms_gateway.keep_awake':
    'Keep the phone plugged in and turn off battery optimisation for the app: if Android kills it, the phone stops sending.',
  'sms_gateway.no_phones':
    'No phones yet. Without at least one, this gateway sends no SMS.',
  'sms_gateway.status_column': 'Status',
  'sms_gateway.status_online': 'Online',
  'sms_gateway.status_offline': 'Silent: no ping in the last 3 minutes',
  'sms_gateway.name_column': 'Phone',
  'sms_gateway.battery_column': 'Battery',
  'sms_gateway.connection_column': 'Connection',
  'sms_gateway.connection_none': 'No internet',
  'sms_gateway.connection_cellular': 'Mobile data',
  'sms_gateway.connection_unknown': 'Unknown',
  'sms_gateway.sims_column': 'SIM',
  'sms_gateway.failed_column': 'Failed (1 h)',
  'sms_gateway.last_ping_column': 'Last contact',
  'sms_gateway.version_column': 'Version',
  'sms_gateway.delete_confirm':
    'The phone stops sending SMS for this workspace at once. To use it again it has to be added again.',
  'sms_gateway.delete_success': 'Phone removed',
  'sms_gateway.delete_error': 'Could not remove the phone',
};
